!(function (t) {
    var e,
        a = t("body"),
        o = t(document),
        i = (t("html"), t(window));
    o.ready(() => {
        o.ajaxStart(() => {
            n.isAjaxLoading = !0;
        }),
            o.ajaxStop(() => {
                n.isAjaxLoading = !1;
            }),
            n.ready();
    }),
        (window.onload = function () {
            n.init();
        });
    var n = {
        haloTimeout: null,
        isAjaxLoading: !1,
        ready: function () {
            this.loaderScript(),
                this.loaderProductBlock(),
                navigator.userAgent.match(/Mac OS X.*(?:Safari|Chrome)/) && !navigator.userAgent.match(/Chrome/) ? document.body.classList.add("safari") : document.body.classList.add("chrome"),
                "undefined" != typeof InstallTrigger && document.body.classList.add("firefox");
            /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && document.body.classList.add("iOS"),
                a.hasClass("template-product") && this.loaderRecommendationsBlock(),
                t("[data-product-tab-block]").length && this.clickedActiveProductTabs(),
                a.hasClass("product-card-layout-07") && this.calculateTranslateYHeight(),
                (window.sharedFunctions = {
                    setLocalStorageProductForWishlist: this.setLocalStorageProductForWishlist,
                    checkNeedToConvertCurrency: this.checkNeedToConvertCurrency,
                    productBlockSilder: this.productBlockSilder,
                    calculateTranslateYHeight: this.calculateTranslateYHeight,
                    productCountdownCard: n.productCountdownCard,
                    swapHoverVideoProductCard: n.swapHoverVideoProductCard,
                    updateSidebarCart: n.updateSidebarCart,
                });
        },
        init: function () {
            this.initMultiTab(),
                this.initMultiTabMobile(),
                this.productBlockInfiniteScroll(),
                this.initGlobalCheckbox(),
                this.initColorSwatch(),
                this.initAddToCart(),
                this.initQuickShop(),
                this.initQuickCart(),
                this.initNotifyInStock(),
                this.initCompareProduct(),
                this.initWishlist(),
                this.initAskAnExpert(),
                this.initHeader(),
                this.headerLanguageCurrency(),
                this.headerMasonry(),
                this.initLiveChat(),
                this.headerSidebarSearch(),
                this.headerStickySearchForm(),
                this.initCountdown(),
                this.collectionCountdown(),
                this.handleScrollDown(),
                this.initVideoPopup(),
                this.swapHoverVideoProductCard(),
                this.initDynamicBrowserTabTitle(),
                this.initWarningPopup(),
                this.clickIconScrollSection(),
                this.specialBanner(),
                this.formMessage(),
                this.typingAnimation(),
                this.spotlightproductSlider(),
                this.doBeforeMegaMenuProductBlock(),
                t(".lookbook-carousel").length && this.lookbookCarousel(),
                (window.quick_view.show || window.quick_view.show_mb) && this.initQuickView(),
                window.innerWidth < 1025 && (this.menuSidebarMobile(), this.menuSidebarMobileToggle());
            const e = document.querySelectorAll(".media--loading-effect img"),
                o = document.getElementById("main-collection-product-grid");
            let s;
            (e.length > 0 || o) && this.initLazyloadObserver(e, o),
                a.hasClass("show_effect_close") && (this.backgroundOverlayHoverEffect(), this.backgroundOverlayHoverEffect1()),
                a.hasClass("template-cart") && (this.updateGiftWrapper(), this.activeCheckboxStickyCartMobile()),
                (a.hasClass("template-product") || t(".product-details").hasClass("featured-product")) &&
                    (this.initProductView(t(".halo-productView")),
                    this.initProductBundle(),
                    this.articleGallery(),
                    this.toggleSidebarMobile(),
                    this.initCollapseSidebarBlock(),
                    this.initCategoryActive(),
                    this.productCustomInformation(),
                    this.iconZoomClickMobile(),
                    this.productBlockSilderSidebar()),
                (a.hasClass("template-blog") || a.hasClass("template-article")) &&
                    (this.initCollapseSidebarBlock(), this.initCategoryActive(), this.toggleSidebarMobile(), this.initBlogMasonry(), this.productBlockSilderSidebar(), this.productBlockSilderArticle()),
                a.hasClass("template-article") && this.articleGallery(),
                (a.hasClass("template-collection") || a.hasClass("template-search")) &&
                    (this.initCollapseSidebarBlock(), this.initCategoryActive(), this.toggleSidebarMobile(), this.productBlockSilderSidebar(), this.initInfiniteScrolling(), this.initQuickShopProductList()),
                a.hasClass("template-list-collections") && (this.toggleSidebarMobile(), this.productBlockSilderSidebar()),
                a.hasClass("template-collection") && t(".collection-express-order").length && (this.toggleVariantsForExpressOrder(), this.initExpressOrderAddToCart()),
                a.hasClass("product-card-layout-08") && n.productCountdownCard(),
                n.checkScrollLayoutForRecenlyViewed(),
                (s = window.innerWidth > 1024),
                i.on("resize", () => {
                    this.headerSidebarSearch(),
                        this.specialBanner(),
                        this.specialBannerSlider(),
                        this.unsymmetricalSlider(),
                        this.doBeforeMegaMenuProductBlock(),
                        window.innerWidth > 1024 ? document.body.classList.remove("menu_open") : s && ((s = !1), this.menuSidebarMobile(), this.menuSidebarMobileToggle(), this.initMultiTab(), this.initMultiTabMobile());
                });
        },
        checkNeedToConvertCurrency: function () {
            return (window.show_multiple_currencies && "undefined" != typeof Currency && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        },
        loaderScript: function () {
            var e = function () {
                var e = t("[data-loader-script]");
                e.length > 0 &&
                    e.each((e, a) => {
                        var o = t(a),
                            i = o.data("loader-script"),
                            s = a.getBoundingClientRect().top;
                        o.hasClass("is-load") || (s < window.innerHeight + 100 && (n.buildScript(i), t('[data-loader-script="' + i + '"]').addClass("is-load")));
                    });
            };
            e(), window.addEventListener("scroll", e);
        },
        buildScript: function (t) {
            var e = document.createElement("script");
            (e.src = t), document.body.appendChild(e);
        },
        buildStyleSheet: function (t, e) {
            if ("" == t) return;
            const a = document.createElement("link");
            (a.rel = "stylesheet"), (a.type = "text/css"), (a.href = t), e.parentNode.insertBefore(a, e);
        },
        loaderProductBlock: function () {
            o.ajaxStart(() => {
                !0;
            }),
                o.ajaxStop(() => {
                    !1;
                });
            this.productBlock = document.querySelectorAll("[data-product-block]");
            (this.observer = new IntersectionObserver(
                (e, o) => {
                    e.forEach((e) => {
                        if (e.isIntersecting) {
                            const u = t(e.target);
                            if (u.hasClass("ajax-loaded")) return;
                            var o = u.data("collection"),
                                i = u.data("layout"),
                                s = u.data("limit"),
                                r = u.data("image-ratio"),
                                c = u.data("swipe"),
                                l = u.attr("sectionId"),
                                d = u.attr("hasCountdown");
                            null != o && null != o
                                ? t.ajax({
                                      type: "get",
                                      url: window.routes.root + "/collections/" + o,
                                      cache: !1,
                                      data: { view: "ajax_product_block", constraint: "limit=" + s + "+layout=" + i + "+sectionId=" + l + "+imageRatio=" + r + "+swipe=" + c + "+hasCountdown=" + d },
                                      beforeSend: function () {
                                          u.addClass("ajax-loaded");
                                      },
                                      success: function (e) {
                                          if ("" != o) {
                                              const a = n.handleResponse(t(e), 0, s);
                                              "grid" == i ? u.find(".products-grid").html(a) : "slider" == i ? u.find(".products-carousel").html(a) : "scroll" == i && u.find(".products-flex").html(a),
                                                  u.find(".card-product .variants-popup-content .selector-wrapper .swatch-element").each(function () {
                                                      const e = t(this).find("input"),
                                                          a = t(this).find("label");
                                                      e.attr({ id: (e.attr("id") || "") + l, name: (e.attr("name") || "") + l }), a.attr("for", (a.attr("for") || "") + l);
                                                  }),
                                                  u.find(".card-product").each(function () {
                                                      const e = t(this).find(".variants-popup-content form"),
                                                          a = t(this).find(".card-action form"),
                                                          o = t(this).find(".variants-popup-content select"),
                                                          i = t(this).find(".card-action form button"),
                                                          n = t(this).find(".variants-popup-content .product-card__button2 button");
                                                      e.attr("id", (e.attr("id") || "") + l),
                                                          a.attr("id", (a.attr("id") || "") + l),
                                                          o.attr("id", (o.attr("id") || "") + l),
                                                          i.attr("data-form-id", (i.attr("data-form-id") || "") + l),
                                                          n.attr("data-form-id", (n.attr("data-form-id") || "") + l);
                                                  });
                                          }
                                      },
                                      complete: function () {
                                          if (
                                              ("slider" == i && n.productBlockSilder(u),
                                              u.hasClass("special-banner__product") && "grid" == i && window.innerWidth < 1200 && (u.find(".special-banner__products--grid").addClass("products-carousel"), n.productBlockSilder(u)),
                                              u.hasClass("halo-block-unsymmetrical") && "grid" == i && window.innerWidth < 1200 && n.unsymmetricalSlider(u),
                                              window.compare.show)
                                          ) {
                                              var e = t("[data-compare-link]");
                                              n.setLocalStorageProductForCompare(e);
                                          }
                                          n.swapHoverVideoProductCard(),
                                              window.wishlist.show && n.setLocalStorageProductForWishlist(),
                                              n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                                              t("body").hasClass("cursor-fixed__show") && (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton()),
                                              a.hasClass("product-card-layout-08") && n.productCountdownCard();
                                      },
                                  })
                                : (u.addClass("ajax-loaded"),
                                  "slider" == i && n.productBlockSilder(u),
                                  n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"));
                        }
                    });
                },
                { rootMargin: "0px 0px 200px 0px" }
            )),
                this.productBlock.forEach((t) => {
                    this.observer.observe(t);
                });
        },
        handleResponse: (t, e, a) => (t = t.splice(e, a)),
        loaderRecommendationsBlock: function () {
            n.buildRecommendationBlock();
        },
        headerMasonry: function () {
            t(".menu-dropdown__wrapper [data-masonry]").masonry({ columnWidth: ".grid-sizer", itemSelector: "[data-gridItem]" });
        },
        initLiveChat: function () {
            t(".live-wrapper-icon").on("click", function (e) {
                t(this).parent().toggleClass("live_help--active");
            }),
                a.on("click", function (e) {
                    t(".live_help").hasClass("live_help--active") && 0 === t(event.target).closest(".live_help").length && (e.preventDefault(), t(".live_help").removeClass("live_help--active"));
                });
        },
        initHeader: function () {
            const t = document.querySelectorAll('[class*="section-header"]');
            if (t) {
                let e = t.length + 20;
                t.forEach((t) => {
                    t.classList.contains("section-header-mobile") || (t.setAttribute("data-index", e), (t.style.zIndex = e), e--);
                });
                const a = document.querySelector(".header-basic--transparent");
                if (a && document.body.classList.contains("template-index")) {
                    const t = a.offsetHeight,
                        e = document.querySelector('.header-navigation[class*="--transparent"]');
                    e && ((e.style.top = `${t}px`), e.classList.add("has-top"));
                }
            }
        },
        headerLanguageCurrency: function () {
            if (!document.querySelector(".header-language_currency")) return;
            const t = document.querySelectorAll('[class*="section-header-"]');
            document.addEventListener("click", (e) => {
                const a = e.target,
                    o = a.closest(".header-language_currency"),
                    i = o?.querySelector(".top-language-currency"),
                    n = o?.querySelector(".dropdown-currency"),
                    s = o?.querySelector(".dropdown-language");
                a.matches(".header-language_currency") || a.closest(".header-language_currency")
                    ? (a.matches(".icon-languageCurrency") || a.closest(".icon-languageCurrency")
                          ? i?.classList.toggle("show")
                          : (!a.matches(".top-language-currency") && !a.closest(".top-language-currency")) || document.querySelector(".icon-languageCurrency") || i?.classList.toggle("show"),
                      (a.matches(".halo-top-currency") || a.closest(".halo-top-currency")) && (s?.classList.remove("show"), n?.classList.toggle("show")),
                      (a.matches(".halo-top-language") || a.closest(".halo-top-language")) && (n?.classList.remove("show"), s?.classList.toggle("show")),
                      a.matches(".dropdown-menu .dropdown-item") && (n?.classList.remove("show"), s?.classList.remove("show")))
                    : t.forEach((t) => {
                          t.querySelector(".top-language-currency")?.classList.remove("show"), t.querySelector(".dropdown-currency")?.classList.remove("show"), t.querySelector(".dropdown-language")?.classList.remove("show");
                      });
            });
        },
        headerSidebarSearch: function () {
            t(".header-top .header__search .search_details"), t("#search-form-mobile .halo-sidebar-wrapper .search_details");
            var e = t(".header-top .header__search"),
                a = t("#search-form-mobile .halo-sidebar-wrapper"),
                o = t(".search_details"),
                i = t(".header-top .header__search predictive-search"),
                n = t("#search-form-mobile .halo-sidebar-wrapper predictive-search");
            0 === i.length && (i = t(".header-top .header__search .search_details")),
                0 === n.length && (n = t("#search-form-mobile .halo-sidebar-wrapper .search_details")),
                window.innerWidth < 1025
                    ? (t(".header").hasClass("header-01") && i.appendTo(a),
                      o.attr("open", "true"),
                      t("[data-search-mobile]").on("click", (e) => {
                          e.preventDefault(), t("body").addClass("open_search_mobile");
                      }),
                      t("[data-search-close-sidebar], .background-overlay").on("click", (e) => {
                          e.preventDefault(), t("body").removeClass("open_search_mobile");
                      }))
                    : (t(".header").hasClass("header-01") && n.appendTo(e),
                      o.removeAttr("open"),
                      t(".search-modal__close-button").on("click", (e) => {
                          t(".search_details").removeAttr("open"), t("body").removeClass("open_search_menu");
                      }),
                      t("[data-search-menu]").on("click", (e) => {
                          e.preventDefault(), t("body").addClass("open_search_menu");
                      }));
        },
        headerStickySearchForm: function () {
            var e = "[data-search-sticky-form]",
                a = "[data-search-menu-sticky-form] .icon-search",
                o = "[data-search-menu-sticky-form] .icon-search-custom";
            t(window).width() > 1025 &&
                (t(document)
                    .off("click.toggleSearch", e)
                    .on("click.toggleSearch", e, function (e) {
                        e.preventDefault(), e.stopPropagation(), t("body").addClass("sticky-search-open"), t(".search_details").attr("open", "true");
                    }),
                t(document)
                    .off("click.hideSearch")
                    .on("click.hideSearch", function (e) {
                        var a = t(".search-modal__form"),
                            o = t(".quickSearchResultsWrap");
                        !t("body").hasClass("sticky-search-open") ||
                            a.has(e.target).length ||
                            o.has(e.target).length ||
                            t(e.target).hasClass("search-modal__content") ||
                            0 != t(e.target).closest(".search-modal__content").length ||
                            (t("body").removeClass("sticky-search-open"), t('[class*="section-header-"]').removeClass("sticky-search-menu-open"), t(".search_details").removeAttr("open"));
                    }),
                t(document)
                    .off("click.toggleSearch", a)
                    .on("click.toggleSearch", a, function (e) {
                        e.preventDefault(),
                            e.stopPropagation(),
                            t(e.target).closest('[class*="section-header-"]').addClass("sticky-search-menu-open"),
                            t(e.target).closest(".section-header-navigation").css("z-index", "101"),
                            t(".search_details").attr("open", "true");
                    }),
                t(document)
                    .off("click.toggleSearch", o)
                    .on("click.toggleSearch", o, function (e) {
                        t(e.target).closest('[class*="section-header-"]').addClass("sticky-search-menu-custom-open");
                    }),
                t(document)
                    .off("click.hideSearchSticky")
                    .on("click.hideSearchSticky", function (e) {
                        var o = t(".header-navigation .search-modal__form"),
                            i = t(".header-navigation .quickSearchResultsWrap");
                        if (
                            t('[class*="section-header-"]').hasClass("sticky-search-menu-open") &&
                            !o.has(e.target).length &&
                            !i.has(e.target).length &&
                            !t(e.target).hasClass("search-modal__content") &&
                            0 == t(e.target).closest(".search-modal__content").length
                        ) {
                            const e = t(a).closest(".section-header-navigation"),
                                o = e.data("index");
                            t('[class*="section-header-"]').removeClass("sticky-search-menu-open"),
                                e.css("z-index", o),
                                t(".header-navigation .search_details").removeAttr("open"),
                                i.hasClass("is-show") && i.removeClass("is-show").addClass("hidden");
                        }
                        0 === t(e.target).closest(".search-modal__content").length && (t("body").removeClass("open_search_menu"), t('[class*="section-header-"]').removeClass("sticky-search-menu-custom-open"));
                    }));
        },
        menuSidebarMobile: function () {
            var e = t(".mobileMenu-toggle"),
                i = t(".halo-sidebar-close, .background-overlay");
            const n = () => {
                a.addClass("menu_open"),
                    t(".list-menu-loading").remove(),
                    "default" == window.mobile_menu && (t("#navigation-mobile .site-nav-mobile.nav .header__inline-menu").length || t(".header .header__inline-menu").appendTo("#navigation-mobile .site-nav-mobile.nav")),
                    t("#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text").length ||
                        t(".header-top--wrapper .header-top--right .free-shipping-text").appendTo("#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"),
                    t("#navigation-mobile .site-nav-mobile.nav-account .customer-service-text").length ||
                        t(".header-top--wrapper .header-top--right .customer-service-text").appendTo("#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"),
                    t("#navigation-mobile .site-nav-mobile.nav-account .header__location").length || t(".header-top--wrapper .header-top--right .header__location").appendTo("#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"),
                    t("#navigation-mobile .top-language-currency").length ||
                        (t(".header").hasClass("header-03")
                            ? t(".header .header-bottom-right .top-language-currency").appendTo("#navigation-mobile .site-nav-mobile.nav-currency-language")
                            : t(".header").hasClass("header-05")
                            ? t(".header .header-top--left .top-language-currency").appendTo("#navigation-mobile .site-nav-mobile.nav-currency-language")
                            : t(".header .header-language_currency .top-language-currency").appendTo("#navigation-mobile .site-nav-mobile.nav-currency-language"));
            };
            document.body.matches(".menu_open") && n(),
                e.off("click.toggleCurrencyLanguage").on("click.toggleCurrencyLanguage", (t) => {
                    t.preventDefault(), n();
                }),
                i.off("click.toggleCloseCurrencyLanguage").on("click.toggleCloseCurrencyLanguage", () => {
                    a.removeClass("menu_open"),
                        t("#navigation-mobile")
                            .off("transitionend.toggleCloseMenu")
                            .on("transitionend.toggleCloseMenu", () => {
                                a.hasClass("menu_open") ||
                                    (t(".header .header__inline-menu").length ||
                                        (t(".header").hasClass("header-03") || t(".header").hasClass("header-04") || t(".header").hasClass("header-07") || t(".header").hasClass("header-08")
                                            ? t("#navigation-mobile .site-nav-mobile.nav .header__inline-menu").appendTo(".header .header-bottom--wrapper .header-bottom-left")
                                            : t("#navigation-mobile .site-nav-mobile.nav .header__inline-menu").appendTo(".header .header-bottom--wrapper")),
                                    t(".header-top--wrapper .header-top--right .free-shipping-text").length ||
                                        t(".header-04").hasClass("style_2") ||
                                        t("#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text").insertBefore(".header-top--wrapper .header-top--right .header__group"),
                                    t(".header-top--wrapper .header-top--right .header__location").length ||
                                        t("#navigation-mobile .site-nav-mobile.nav-account .header__location").insertBefore(".header-top--wrapper .header-top--right .header__group"),
                                    t(".header-top--wrapper .header-top--right .customer-service-text").length ||
                                        (t(".header").hasClass("header-03")
                                            ? t("#navigation-mobile .site-nav-mobile.nav-account .customer-service-text").insertBefore(".header-top--wrapper .header-top--right .header__group .header__icon--wishlist")
                                            : t("#navigation-mobile .site-nav-mobile.nav-account .customer-service-text").insertBefore(".header-top--wrapper .header-top--right .top-language-currency")),
                                    t(".header-language_currency .top-language-currency").length ||
                                        (t(".header").hasClass("header-03") || t(".header").hasClass("header-04")
                                            ? t("#navigation-mobile .site-nav-mobile .top-language-currency").appendTo(".header .header-bottom--wrapper .header-bottom-right .header-language_currency")
                                            : t(".header").hasClass("header-05")
                                            ? t("#navigation-mobile .site-nav-mobile .top-language-currency").appendTo(".header .header-top--wrapper .header-top--left .header-language_currency")
                                            : t("#navigation-mobile .site-nav-mobile .top-language-currency").insertBefore(".header .header-language_currency .header__search")));
                            });
                }),
                o.on("click", ".halo-sidebar-close", function (t) {
                    t.preventDefault(), t.stopPropagation(), a.removeClass("menu_open");
                });
        },
        menuSidebarMobileToggle: function () {
            a.on("click", ".site-nav-mobile .list-menu .menu_mobile_link", function (e) {
                if (!e.currentTarget.classList.contains("list-menu__item--end")) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this),
                        o = a.parent(),
                        i = a.parent().find("ul.list-menu--disclosure-1");
                    o.removeClass("is-hidden").addClass("is-open").removeClass("d-none"),
                        i.off("transitionend.toggleMenuLink1").on("transitionend.toggleMenuLink1", () => {
                            !o.hasClass("is-open") || o.hasClass("is-hidden") || o.hasClass("d-none") || o.siblings().removeClass("is-open").addClass("is-hidden").removeClass("d-none");
                        });
                }
            }),
                a.on("click", ".site-nav-mobile .list-menu .menu_mobile_link_2", function (e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this),
                        o = (a = t(this)).parent().parent(),
                        i = a.parent().find("ul.list-menu--disclosure-2"),
                        n = a.parent().parent().parent().parent().parent().parent();
                    o.removeClass("is-hidden").addClass("is-open").removeClass("d-none"),
                        i.off("transitionend.toggleMenuLink2").on("transitionend.toggleMenuLink2", () => {
                            !o.hasClass("is-open") ||
                                o.hasClass("is-hidden") ||
                                o.hasClass("d-none") ||
                                (o.addClass("d-none"), o.siblings().removeClass("is-open").addClass("is-hidden").removeClass("d-none"), n.animate({ scrollTop: 0 }, 0));
                        }),
                        (t(".menu-dropdown").hasClass("megamenu_style_5") ||
                            t(".menu-dropdown").hasClass("megamenu_style_4") ||
                            t(".menu-dropdown").hasClass("megamenu_style_3") ||
                            t(".menu-dropdown").hasClass("megamenu_style_2") ||
                            t(".menu-dropdown").hasClass("megamenu_style_1")) &&
                            a.parents(".menu-dropdown").animate({ scrollTop: 0 }, 0),
                        a.parents(".menu-dropdown").addClass("is-overflow");
                }),
                a.on("click", ".nav-title-mobile", function (e) {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(this),
                        o = a.parent().parent().parent().parent(".is-open"),
                        i = a.parent().parent().parent(".is-open"),
                        n = a.parent().parent(".is-open");
                    o.siblings().removeClass("is-hidden"),
                        o.removeClass("is-open").removeClass("d-none"),
                        i.siblings().removeClass("is-hidden"),
                        i.removeClass("is-open").removeClass("d-none"),
                        n.siblings().removeClass("is-hidden"),
                        n.removeClass("is-open").removeClass("d-none"),
                        t(".menu-dropdown").removeClass("is-overflow");
                }),
                "default" != window.mobile_menu &&
                    o.on("click", "[data-mobile-menu-tab]", (t) => {
                        t.preventDefault(), t.stopPropagation();
                        var e = t.currentTarget.closest("li"),
                            a = t.currentTarget.dataset.target;
                        e.classList.contains("is-active") ||
                            document
                                .querySelector("[data-navigation-tab-mobile]")
                                .querySelectorAll("li")
                                .forEach((t) => {
                                    t != e
                                        ? t.classList.remove("is-active")
                                        : (t.classList.add("is-active"),
                                          document.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((t) => {
                                              t.getAttribute("id") == a ? (t.classList.remove("is-hidden"), t.classList.add("is-visible")) : (t.classList.remove("is-visible"), t.classList.add("is-hidden"));
                                          }));
                                });
                    }),
                t(document).on("click", "[data-navigation-mobile] .no-megamenu .menu-lv-1__action", (e) => {
                    const a = t(e.currentTarget).attr("href").split("#")[1];
                    null != a && "" != a && t(`#${a}`).length && (t("body").removeClass("menu_open"), t("html, body").animate({ scrollTop: t(`#${a}`).offset().top }, 700));
                });
        },
        setCookie(t, e, a) {
            const o = new Date();
            o.setTime(o.getTime() + 24 * a * 60 * 60 * 1e3);
            const i = "expires=" + o.toUTCString();
            document.cookie = t + "=" + e + ";" + i + ";path=/";
        },
        initMultiTab: function () {
            let e,
                o,
                s = !0;
            (e = !!document.body.matches(".shopify-design-mode")), (o = !!document.body.matches(".menu_open"));
            const r = () => {
                    s && ((s = !1), n.initMobileMenuDefault(d));
                },
                c = () => {
                    s && ((s = !1), n.initMultiTabMobile());
                };
            if (t("[data-menu-tab]").length > 0) {
                var l = t("[data-menu-tab] li.is-active").data("load-page"),
                    d = window.routes.root + `/search?type=product&q=${l}&view=ajax_mega_menu`;
                a.hasClass("template-index"),
                    i.width() < 1025 &&
                        ("default" == window.mobile_menu
                            ? window.addEventListener(
                                  "load",
                                  () => {
                                      e || o
                                          ? r()
                                          : document.body.addEventListener(
                                                "click",
                                                () => {
                                                    r();
                                                },
                                                !1
                                            );
                                  },
                                  !1
                              )
                            : window.addEventListener(
                                  "load",
                                  () => {
                                      e || o
                                          ? c()
                                          : document.body.addEventListener(
                                                "click",
                                                () => {
                                                    c();
                                                },
                                                !1
                                            );
                                  },
                                  !1
                              ));
            } else {
                d = window.routes.root + "/search?view=ajax_mega_menu";
                i.width() < 1025 &&
                    ("default" == window.mobile_menu
                        ? e || o
                            ? r()
                            : document.body.addEventListener(
                                  "click",
                                  () => {
                                      r();
                                  },
                                  !1
                              )
                        : window.addEventListener(
                              "load",
                              () => {
                                  e || o
                                      ? c()
                                      : document.body.addEventListener(
                                            "click",
                                            () => {
                                                c();
                                            },
                                            !1
                                        );
                              },
                              !1
                          ));
            }
        },
        initMobileMenuDefault: function (e) {
            const a = t("[data-navigation-mobile]"),
                o = t("#HeaderNavigation [data-navigation]"),
                i = null != o.attr("style") ? o.attr("style") : o.closest("#HeaderNavigation").attr("style");
            t(".list-menu-loading").remove(), a.append(`<nav class="header__inline-menu" data-navigation role="navigation" style="${null != i ? i : ""}">${null != o.html() ? o.html() : ""}</nav>`);
            const s = t(".top-language-currency"),
                r = t("#navigation-mobile .nav-currency-language");
            "" == r.text().trim() && s.length > 0 && r.append(`<div class="top-language-currency">${s.html()}</div>`);
            const c = document.querySelector(".header-nav-vertical-menu .vertical-menu .header__menu-vertical");
            if (c) {
                document.querySelector(".halo-sidebar.halo-sidebar_menu").classList.add("has-menu-vertical");
                const t = document.querySelector(".header-nav-vertical-menu .vertical-menu .categories-title__button .title").innerHTML,
                    e = document.querySelector(".site-nav-mobile.nav"),
                    a = e.querySelector(".menu-heading-mobile"),
                    o = document.createElement("span");
                o.classList.add("title"), (o.innerHTML = t), a.appendChild(o), e.appendChild(c);
                document.querySelector(".site-nav-mobile.nav .header__menu-vertical").classList.add("header__inline-menu");
                const i = document.querySelectorAll(".site-nav-mobile.nav .menu-heading-mobile .title"),
                    n = document.querySelectorAll(".site-nav-mobile.nav .header__inline-menu");
                i[0].classList.add("is-active"),
                    n[0].classList.add("is-active"),
                    i.forEach((t, e) => {
                        t.addEventListener("click", () => {
                            i.forEach((t) => t.classList.remove("is-active")), t.classList.add("is-active"), n.forEach((t) => t.classList.remove("is-active")), n[e].classList.add("is-active");
                        });
                    });
            }
            if (window.innerWidth < 1025) {
                var l = t(".menu-lv-item.has-megamenu");
                l.length > 0 &&
                    l.on("click", function (e) {
                        var a,
                            o = t(this).find(".menu-dropdown__block--content .products-carousel"),
                            i = o.data("product"),
                            s = o.data("collection");
                        o.hasClass("megamenu_1") ? i && (a = window.routes.root + "/products/" + i) : o.hasClass("megamenu_5") && s && (a = window.routes.root + "/collections/" + s), a && n.renderMegaMenuProductBlock(o, a);
                    });
            }
        },
        initMultiTabMobile: function () {
            if (i.width() < 1025 && "custom" == window.mobile_menu) {
                var e = !0,
                    a = t('[data-section-type="menu"]'),
                    o = t("[data-navigation-mobile]"),
                    s = t("[data-navigation-tab-mobile]");
                const i = () => {
                    if (e) {
                        e = !1;
                        const i = document.createElement("div"),
                            n = document.createElement("ul");
                        Object.assign(n, { className: "menu-tab list-unstyled" }),
                            n.setAttribute("role", "menu"),
                            a.each((t, e) => {
                                var a = e.querySelector("template").content.firstElementChild.cloneNode(!0);
                                0 == t ? a.classList.add("is-visible") : a.classList.add("is-hidden"), i.appendChild(a);
                            }),
                            i.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((t, e) => {
                                var a = t.dataset.heading,
                                    o = t.getAttribute("id"),
                                    i = document.createElement("li");
                                Object.assign(i, { className: "item" }),
                                    i.setAttribute("role", "menuitem"),
                                    0 == e && i.classList.add("is-active"),
                                    (i.innerHTML = `<a class="link" href="#" data-mobile-menu-tab data-target="${o}">${a}</a>`),
                                    n.appendChild(i);
                            }),
                            t(".list-menu-loading").remove(),
                            s.html(n),
                            o.html(i.innerHTML);
                    }
                };
                if (t(".header-nav-plain .header-language_currency").length > 0) {
                    const e = t(".top-language-currency"),
                        a = t("#navigation-mobile .nav-currency-language");
                    "" == a.text().trim() && e.length > 0 && a.append(`<div class="top-language-currency">${e.html()}</div>`);
                }
                document.body.matches(".menu_open") && i(),
                    document.body.addEventListener(
                        "click",
                        () => {
                            i();
                        },
                        !1
                    );
            }
            if (window.innerWidth < 1025) {
                var r = t(".menu-lv-item.has-megamenu");
                r.length > 0 &&
                    r.on("click", function (e) {
                        var a,
                            o = t(this).find(".menu-dropdown__block--content .products-carousel"),
                            i = o.data("product"),
                            s = o.data("collection");
                        o.hasClass("megamenu_1") ? i && (a = window.routes.root + "/products/" + i) : o.hasClass("megamenu_5") && s && (a = window.routes.root + "/collections/" + s), a && n.renderMegaMenuProductBlock(o, a);
                    });
            }
        },
        initMenu: function (e) {
            t(".header").hasClass("header-04") ||
                fetch(e)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = document.createElement("div");
                        e.innerHTML = t;
                        const a = e.querySelector("#HeaderNavigation");
                        a && a.innerHTML.trim().length && (document.querySelector("#HeaderNavigation").innerHTML = a.innerHTML);
                    })
                    .catch((t) => {
                        console.error(t);
                    });
        },
        clickedActiveProductTabs: function () {
            this.productBlock = document.querySelectorAll("[data-product-tab-block]");
            (this.observer = new IntersectionObserver(
                (e, a) => {
                    e.forEach((e) => {
                        if (e.isIntersecting) {
                            const l = t(e.target);
                            if (l.hasClass("ajax-loaded")) return;
                            var a = l.find(".list-product-tabs"),
                                o = a.find("[data-product-tabTop]"),
                                i = l.find("[data-product-TabContent]"),
                                s = l.data("limit"),
                                r = a.find(".tab-links.active"),
                                c = l.find(".product-tabs-content .tab-content.active");
                            l.hasClass("ajax-loaded") || n.doAjaxProductTabs(r.data("href"), c.find(".loading"), c.find(".products-load"), l.attr("sectionid"), s, l),
                                o.off("click").on("click", function (e) {
                                    if ((e.preventDefault(), e.stopPropagation(), !t(this).hasClass("active"))) {
                                        const e = t(this),
                                            a = t(e.data("target"));
                                        o.removeClass("active"),
                                            i.removeClass("active"),
                                            a.hasClass("loaded") || n.doAjaxProductTabs(e.data("href"), a.find(".loading"), a.find(".products-load"), l.attr("sectionid"), s),
                                            e.addClass("active"),
                                            a.addClass("active"),
                                            a.find(".slick-slider").slick("refresh");
                                    }
                                });
                        }
                    });
                },
                { threshold: 0.1 }
            )),
                this.productBlock.forEach((t) => {
                    this.observer.observe(t);
                });
        },
        doAjaxProductTabs: function (e, a, o, i, s, r) {
            t.ajax({
                type: "get",
                url: e,
                data: { constraint: `sectionId=${e}+limit=${s}` },
                beforeSend: function () {
                    null != r && r.addClass("ajax-loaded");
                },
                success: function (a) {
                    if ((o.parent().addClass("loaded"), "?view=ajax_product_block" != e)) {
                        if ("" === t(a).text().trim()) c(o);
                        else {
                            const e = n.handleResponse(t(a), 0, s);
                            o.html(e),
                                window.wishlist.show && n.setLocalStorageProductForWishlist(),
                                n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format");
                        }
                        n.swapHoverVideoProductCard();
                    }
                },
                complete: function () {
                    o.hasClass("products-carousel") && n.productBlockSilder(o.parent()), t("body").hasClass("cursor-fixed__show") && (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton());
                },
                error: function (t, e) {
                    c(o);
                },
            });
            const c = (t) => {
                t.html('<p class="loading center">Sorry, there are no products in this collection</p>');
            };
        },
        lookbookCarousel: function () {
            var e = t(".lookbook-carousel"),
                a = e.data("item-to-show"),
                o = e.data("item-dots"),
                i = e.data("item-dots-mb"),
                n = e.data("item-arrows"),
                s = e.data("item-arrows-mb");
            if (
                (e.length > 0 &&
                    e.not(".slick-initialized") &&
                    e.slick({
                        mobileFirst: !0,
                        adaptiveHeight: !0,
                        vertical: !1,
                        infinite: !0,
                        slidesToShow: a,
                        slidesToScroll: a,
                        arrows: s,
                        dots: i,
                        autoplay: !1,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [{ breakpoint: 1024, settings: { arrows: n, dots: o } }],
                    }),
                e.hasClass("enable_counter_number"))
            ) {
                var r = e.find(".slick-next");
                e.closest(".special-banner__item--lookbook_banner").find(".products-counter-number").appendTo(r),
                    e.on("afterChange", (t) => {
                        var a = e.find(".slick-current").data("slick-index");
                        e.find("#count-image").text(a + 1);
                    });
            }
            t("body").hasClass("cursor-fixed__show") && (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton());
        },
        productBlockSilder: function (e) {
            var a = e.find(".products-carousel"),
                o = a.data("item-to-show"),
                i = a.data("item-dots"),
                n = a.data("item-dots-mb"),
                s = a.data("item-arrows"),
                r = a.data("item-arrows-mb"),
                c = a.data("infinite"),
                l = a.find(".swatch .swatch-label"),
                d = document.body.classList.contains("product-card-layout-06");
            if (a.length > 0) {
                if (a.hasClass("slick-initialized")) return;
                if (a.not(".slick-initialized")) {
                    if (
                        (d &&
                            a.on("init", () => {
                                const t = a.find(".product .card-action").eq(0).height();
                                a.find(".slick-list").css("padding-bottom", t + "px"), a.attr("data-slider-padding-bottom", t);
                            }),
                        a.hasClass("enable_progress_bar"))
                    ) {
                        var u = e.find(".scrollbar-thumb");
                        a.on("init", (t, e) => {
                            var a = (e.currentSlide / (e.slideCount - o)) * 100 + "%";
                            u.css("--percent", a);
                        });
                    }
                    if (
                        (a.slick({
                            mobileFirst: !0,
                            adaptiveHeight: !0,
                            vertical: !1,
                            infinite: c,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: r,
                            dots: n,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive: [
                                {
                                    breakpoint: 1599,
                                    settings: {
                                        arrows: s,
                                        dots: i,
                                        get slidesToShow() {
                                            return (this.slidesToShow = null != o && "" !== o ? o : 1);
                                        },
                                        get slidesToScroll() {
                                            return (this.slidesToScroll = null != o && "" !== o && 2.5 !== o && 3.5 !== o && 4.5 !== o && 5.5 !== o ? o : 1);
                                        },
                                        get initialSlide() {
                                            return (this.initialSlide = 5.5 == o ? 0.5 : 0);
                                        },
                                    },
                                },
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        arrows: s,
                                        dots: i,
                                        get slidesToShow() {
                                            return null != o && "" !== o
                                                ? 5 == o || 6 == o
                                                    ? (this.slidesToShow = o - 1)
                                                    : a.parents(".collection-column-2").length
                                                    ? (this.slidesToShow = 2)
                                                    : (this.slidesToShow = o)
                                                : (this.slidesToShow = 1);
                                        },
                                        get slidesToScroll() {
                                            return null != o && "" !== o && 2.5 !== o && 3.5 !== o && 4.5 !== o && 5.5 !== o
                                                ? 5 == o || 6 == o
                                                    ? (this.slidesToScroll = o - 1)
                                                    : a.parents(".collection-column-2").length
                                                    ? (this.slidesToScroll = 2)
                                                    : (this.slidesToScroll = o)
                                                : (this.slidesToScroll = 1);
                                        },
                                        get initialSlide() {
                                            return (this.initialSlide = 5.5 == o ? 0.5 : 0);
                                        },
                                    },
                                },
                                {
                                    breakpoint: 991,
                                    settings: {
                                        arrows: r,
                                        dots: n,
                                        get slidesToShow() {
                                            return a.hasClass("has__banner_tab") || a.parents(".product-block-has__banner").length
                                                ? a.parents(".product-block-has__banner").length && a.parents(".product-block-has__banner").data("width-banner") > 40
                                                    ? (this.slidesToShow = 2)
                                                    : (this.slidesToShow = 2.5 == o ? 2 : 3)
                                                : a.parents(".collection-column-2").length
                                                ? (this.slidesToShow = 2)
                                                : (this.slidesToShow = 1 == o ? o : 3.5 == o || 4.5 == o ? 3 : 4);
                                        },
                                        get slidesToScroll() {
                                            return a.hasClass("has__banner_tab") || a.parents(".product-block-has__banner").length
                                                ? a.parents(".product-block-has__banner").length && a.parents(".product-block-has__banner").data("width-banner") > 40
                                                    ? (this.slidesToScroll = 2)
                                                    : (this.slidesToScroll = 2.5 == o ? 2 : 3)
                                                : a.parents(".collection-column-2").length
                                                ? (this.slidesToScroll = 2)
                                                : (this.slidesToScroll = 1 == o ? o : 3.5 == o || 4.5 == o ? 3 : 4);
                                        },
                                        get initialSlide() {
                                            return (this.initialSlide = 5.5 == o ? 0.5 : 0);
                                        },
                                    },
                                },
                                {
                                    breakpoint: 767,
                                    arrows: r,
                                    dots: n,
                                    settings: {
                                        get slidesToShow() {
                                            return a.hasClass("has__banner_tab") || a.parents(".product-block-has__banner").length ? (this.slidesToShow = 2) : (this.slidesToShow = 1 == o ? o : 3.5 == o || 4.5 == o ? 2 : 3);
                                        },
                                        get slidesToScroll() {
                                            return a.hasClass("has__banner_tab") || a.parents(".product-block-has__banner").length ? (this.slidesToScroll = 2) : (this.slidesToScroll = 1 == o ? o : 3.5 == o || 4.5 == o ? 2 : 3);
                                        },
                                        get initialSlide() {
                                            return (this.initialSlide = 5.5 == o ? 0.5 : 0);
                                        },
                                    },
                                },
                                {
                                    breakpoint: 320,
                                    arrows: r,
                                    dots: n,
                                    settings: {
                                        get slidesToShow() {
                                            return 1 == o
                                                ? a.hasClass("special-banner__products--slider") || a.hasClass("special-banner__products--grid")
                                                    ? (this.slidesToShow = 2)
                                                    : (this.slidesToShow = o)
                                                : (this.slidesToShow = 2.5 == o || 3.5 == o || 4.5 == o ? 1 : 2);
                                        },
                                        get slidesToScroll() {
                                            return (this.slidesToScroll = 1 == o ? o : 2.5 == o || 3.5 == o || 4.5 == o ? 1 : 2);
                                        },
                                    },
                                },
                            ],
                        }),
                        a.hasClass("enable_progress_bar") &&
                            a.on("afterChange", (t, e, a) => {
                                var i = (a / (e.slideCount - o)) * 100 + "%";
                                u.css("--percent", i);
                            }),
                        a.hasClass("enable_counter_number"))
                    ) {
                        var p = a.find(".slick-next");
                        a.closest(".halo-block, .special-banner__product, .cust-prod-widget__product").find(".products-counter-number").appendTo(p),
                            a.on("afterChange", (t) => {
                                var i = a.find(".slick-current").data("slick-index") + o,
                                    n = e.data("limit");
                                i > n && (i = n), a.find("#count-image").text(i);
                            });
                    }
                    t("body").hasClass("cursor-fixed__show") && (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton());
                }
            }
            if (l.length) {
                a.on("click", ".swatch .swatch-label", function () {
                    setTimeout(() => {
                        var e = (function () {
                            var e = 0;
                            return (
                                a.find(".slick-slide").each(function () {
                                    var a = t(this).outerHeight();
                                    a > e && (e = a);
                                }),
                                e
                            );
                        })();
                        a.find(".slick-list").css({ height: e + "px", transition: "500ms ease" });
                    }, 50);
                });
            }
        },
        productBlockInfiniteScroll: function () {
            t("[data-product-block], [data-product-tab-block]").each((e, a) => {
                var o = t(a),
                    i = o.find("[data-product-infinite]");
                i.length > 0 &&
                    i.find(".button").on("click", (e) => {
                        var a = t(e.target);
                        if (a.hasClass("view-all")) window.location = a.data("href");
                        else {
                            e.preventDefault(), e.stopPropagation(), a.addClass("is-loading");
                            var i = a.attr("data-collection"),
                                s = a.attr("data-limit"),
                                r = a.attr("data-swipe"),
                                c = a.attr("data-total"),
                                l = a.attr("data-image-ratio"),
                                d = a.attr("sectionId"),
                                u = parseInt(a.attr("data-page"));
                            n.doProductBlockInfiniteScroll(i, c, s, r, l, d, u, a, o);
                        }
                    });
            });
        },
        doProductBlockInfiniteScroll: function (e, a, o, i, s, r, c, l, d) {
            t.ajax({
                type: "get",
                url: window.routes.root + "/collections/" + e,
                cache: !1,
                data: { view: "ajax_product_block", constraint: "limit=" + o + "+page=" + c + "+sectionId=" + r + "+imageRatio=" + s + "+swipe=" + i },
                beforeSend: function () {},
                success: function (o) {
                    const i = l.closest(".tab-content").length ? l.closest(".tab-content").find(".products-grid") : l.closest(".halo-block-content").find(".products-grid");
                    let s = i.find(".product").length;
                    const r = n.handleResponse(t(o), s, i.data("products-to-show"));
                    if ((i.append(r), s + r.length < t(o).length)) {
                        var d = window.button_load_more.default;
                        l.removeClass("is-loading"), l.attr("data-page", c + 1), l.find("span").text(d);
                    } else if (Number(a) > t(o).length && t(o).length <= s + r.length) {
                        d = window.button_load_more.view_all;
                        l.find("span").text(d), l.removeClass("is-loading"), l.attr("data-href", window.routes.root + "/collections/" + e).addClass("view-all");
                    } else {
                        d = window.button_load_more.no_more;
                        l.find("span").text(d), l.removeClass("is-loading"), l.attr("disabled", "disabled");
                    }
                },
                complete: function () {
                    n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format");
                },
            });
        },
        doBeforeMegaMenuProductBlock: function () {
            var e = t(".menu-lv-item.has-megamenu");
            e.length > 0 &&
                window.innerWidth > 1025 &&
                e.mouseenter(function () {
                    var e,
                        a = t(this).find(".menu-dropdown__block--content .products-carousel"),
                        o = a.data("product"),
                        i = a.data("collection");
                    a.hasClass("megamenu_1") ? o && (e = window.routes.root + "/products/" + o) : a.hasClass("megamenu_5") && i && (e = window.routes.root + "/collections/" + i), e && n.renderMegaMenuProductBlock(a, e);
                });
        },
        renderMegaMenuProductBlock: function (e, a) {
            var o = e;
            if (!o.hasClass("ajax-loaded")) {
                var i = o.data("row");
                t.ajax({
                    type: "GET",
                    url: a,
                    cache: !1,
                    data: { view: "ajax_product_card_mega_menu", constraint: `limit=${i}+sectionId=list-result-block` },
                    beforeSend: () => {
                        o.addClass("ajax-loaded");
                    },
                    success: (e) => {
                        if (o.hasClass("megamenu_1")) o.html(e);
                        else if (o.hasClass("megamenu_5")) {
                            const a = n.handleResponse(t(e), 0, i);
                            o.html(a), n.productMenuSlider(o);
                        }
                        n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format");
                    },
                    complete: () => {
                        n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format");
                    },
                });
            }
        },
        productMenuSlider: function (t) {
            var e = t,
                a = e.data("row");
            e.length > 0 &&
                e.not(".slick-initialized") &&
                e.slick({
                    mobileFirst: !0,
                    adaptiveHeight: !0,
                    vertical: !1,
                    infinite: !1,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: !1,
                    dots: !0,
                    rtl: window.rtl_slick,
                    responsive: [
                        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                        { breakpoint: 1500, settings: { slidesToShow: a, slidesToScroll: 1, dots: !1 } },
                    ],
                });
        },
        buildRecommendationBlock: function () {
            if (null == document.querySelector("[data-recommendations-block]")) return;
            var e = document.querySelector("[data-recommendations-block]"),
                o = e.dataset.layout;
            swipe = e.dataset.swipe;
            new IntersectionObserver(
                ((i, s) => {
                    const r = e.querySelector(".wrapper-container");
                    i[0].isIntersecting &&
                        ("" == e.innerHTML.trim() || r.classList.contains("product-recommendations-loading") || r.classList.contains("has-product")) &&
                        (r.classList.add("has-product"),
                        fetch(e.dataset.url)
                            .then((t) => t.text())
                            .then((i) => {
                                const s = document.createElement("div");
                                s.innerHTML = i;
                                const r = s.querySelector("[data-recommendations-block]");
                                if (r && r.innerHTML.trim().length) {
                                    if (((e.innerHTML = r.innerHTML), !t(e).find(".product-item").eq(0).data("json-product"))) return t(e).remove();
                                    "slider" == o && n.productBlockSilder(t(e)),
                                        t(e)
                                            .find(".product-item")
                                            .each(async (e, a) => {
                                                var o = t(a),
                                                    i = o.data("product-id"),
                                                    s = o.data("json-product").handle;
                                                await t.ajax({
                                                    type: "get",
                                                    url: window.routes.root + "/products/" + s + "?view=ajax_variant_quantity",
                                                    beforeSend: function () {},
                                                    success: function (t) {
                                                        const e = new DOMParser().parseFromString(t, "text/html");
                                                        if (e.querySelector(`[data-quantity-product-id="${i}"]`)) {
                                                            const t = JSON.parse(e.querySelector(`[data-quantity-product-id="${i}"]`).innerHTML);
                                                            window[`quick_view_inven_array_${i}`] = t;
                                                        }
                                                    },
                                                    error: function (e, a) {
                                                        n.showWarning(t.parseJSON(e.responseText).description);
                                                    },
                                                    complete: function () {},
                                                });
                                            });
                                    const i = e.querySelectorAll(".media--loading-effect img");
                                    if ((this.observeImageLazyloaded(i), window.compare.show)) {
                                        var c = t("[data-compare-link]");
                                        n.setLocalStorageProductForCompare(c);
                                    }
                                    window.wishlist.show && n.setLocalStorageProductForWishlist(),
                                        t("body").hasClass("cursor-fixed__show") && (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton()),
                                        a.hasClass("product-card-layout-08") && n.productCountdownCard(),
                                        this.calculateTranslateYHeight();
                                }
                            })
                            .catch((t) => {
                                console.error(t);
                            }));
                }).bind(e),
                { threshold: 0.25 }
            ).observe(e);
        },
        initVideoPopup: function () {
            t(".video-open-popup").length &&
                (t(".video-open-popup .video-button")
                    .off("click")
                    .on("click", function () {
                        let e = t(this).attr("data-type"),
                            o = t(this).attr("data-src");
                        const i = `<div class="fluid-width-video-wrapper" style="padding-top: ${t(this).attr("aspect_ratio")}">\n                                    ${
                            "youtube" == e
                                ? `<iframe\n                                            id="player"\n                                            type="text/html"\n                                            width="100%"\n                                            frameborder="0"\n                                            webkitAllowFullScreen\n                                            mozallowfullscreen\n                                            allowFullScreen\n                                            src="https://www.youtube.com/embed/${o}?autoplay=1&mute=1">\n                                        </iframe>`
                                : `<iframe \n                                            src="https://player.vimeo.com/video/${o}?autoplay=1&mute=1" \n                                            class="js-vimeo" \n                                            allow="autoplay; \n                                            encrypted-media" \n                                            webkitallowfullscreen \n                                            mozallowfullscreen \n                                            allowfullscreen">\n                                        </iframe>`
                        }\n                                </div>`;
                        t("[data-popup-video]").find(".halo-popup-content").html(i), a.addClass("video-show");
                    }),
                t("[data-popup-video], [data-popup-video] .halo-popup-close, .background-overlay").on("click", function (e) {
                    let o = t("[data-popup-video] .halo-popup-content");
                    o.is(e.target) || o.has(e.target).length || (a.removeClass("video-show"), t("[data-popup-video] iframe").remove());
                }));
        },
        swapHoverVideoProductCard: function () {
            window.innerWidth > 1200 &&
                (t(".product-item .card:not(.has-first-video)").mouseenter(function () {
                    var e = t(this).find("video"),
                        a = t(this).find("video").get(0);
                    e.length > 0 && a.play();
                }),
                t(".product-item .card:not(.has-first-video)").mouseleave(function () {
                    var e = t(this).find("video"),
                        a = t(this).find("video").get(0);
                    e.length > 0 && a.pause();
                })),
                (t.fn.isInViewport = function () {
                    let e = t(this).offset().top,
                        a = e + t(this).outerHeight(),
                        o = t(window).scrollTop(),
                        i = o + t(window).height();
                    return a > o && e < i;
                }),
                t(".product-item .card.has-first-video").each(function () {
                    let e = t(this).find("video"),
                        a = t(this).find("img:first-child"),
                        o = t(this).find("video").get(0);
                    const i = () => {
                            a.length > 0 && a.css("opacity", "0"), e.length > 0 && (e.css("opacity", "1"), o.play());
                        },
                        n = () => {
                            e.length > 0 && o.pause();
                        };
                    t(this).isInViewport() ? i() : n(),
                        window.addEventListener("scroll", () => {
                            t(this).isInViewport() ? i() : n();
                        });
                });
        },
        initGlobalCheckbox: function () {
            o.on("change", ".global-checkbox--input", (e) => {
                var a = e.target.getAttribute("data-target");
                e.target.checked ? t(a).attr("disabled", !1) : t(a).attr("disabled", !0);
            }),
                o.on("click", "[data-term-condition]", (t) => {
                    t.preventDefault(), t.stopPropagation(), a.addClass("term-condition-show");
                }),
                o.on("click", "[data-close-term-condition-popup]", (t) => {
                    t.preventDefault(), t.stopPropagation(), a.removeClass("term-condition-show");
                }),
                o.on("click", (e) => {
                    setTimeout(() => {
                        a.hasClass("cart-sidebar-show") && 0 === t(e.target).closest("[data-term-condition-popup]").length && a.removeClass("term-condition-show"),
                            a.hasClass("term-condition-show") && 0 === t(e.target).closest("[data-term-condition-popup]").length && a.removeClass("term-condition-show");
                    }, 10);
                });
        },
        initColorSwatch: function () {
            o.ready(function () {
                t(".card .swatch-label.is-active").trigger("click");
            }),
                o.on("click", ".card .swatch-label", (e) => {
                    var o = t(e.currentTarget),
                        i = o.attr("title").replace(/^\s+|\s+$/g, ""),
                        s = o.closest(".product-item"),
                        r = s.data("json-product"),
                        c = s.find(".card-title"),
                        l = s.find("[data-btn-addtocart]"),
                        d = s.find(".card-product [data-btn-addtocart]"),
                        u = o.data("variant-id"),
                        p = s.find("a").attr("href"),
                        h = o.data("with-one-option"),
                        m = o.data("variant-img"),
                        w = [];
                    const f =
                        '<svg class="icon icon-cart" viewBox="0 0 286.74 356.73">                  <g data-name="Layer 1">                    <path d="m286.33,277.03l-.17-3.91c-.81-18.73-1.83-37.7-2.83-56.05l-.79-14.51c-.43-8.13-.9-16.26-1.37-24.4l-.24-4.18c-.84-14.79-1.71-30.08-2.35-45.1-.93-21.43-14.62-35.84-34.07-35.86h-20.65c-.42-20.33-5.78-38.81-15.94-54.94C189.14,8.27,157.22-5.8,126.6,2.23c-27.48,7.21-46.98,26.7-57.96,57.94-3.5,9.98-5.33,20.76-5.56,32.86h-9.52c-4.59,0-9.05-.01-12.39,0-16.64.12-30.01,12.35-31.79,29.06-1.42,13.39-2.1,27.29-2.7,39.55-.24,4.97-.5,9.95-.77,14.91-1.22,21.28-2.24,39.94-3.13,57.07-.29,5.45-.6,10.9-.92,16.36l-.02.3c-.82,13.9-1.67,28.28-1.82,42.5-.18,16.51,5.81,32.31,16.86,44.5,11.15,12.29,26.39,19.35,41.81,19.37,22.45.05,49.37.08,82.32.08s60.43-.02,87.24-.08c28.28-.04,53.63-23.49,57.72-53.39,1.19-8.74.78-17.61.37-26.23ZM63.13,130.98c.09,7.97,4.99,13.59,11.92,13.67h.12c6.97,0,11.9-5.57,11.99-13.53.04-3.2.04-6.33.04-9.63v-2.53s112.59,0,112.59,0v10.76c0,4.95,1.26,8.81,3.76,11.51,2.07,2.2,4.95,3.4,8.33,3.45h.11c5.72-.08,11.83-4.11,11.85-15.16v-10.77c.83-.01,1.68-.03,2.55-.04h.62c7.1-.1,15.15-.2,20.48.19,3.7.28,6.59,4.2,6.87,9.32.68,12.51,1.41,26.28,2.28,43.33l.1,2.01c.67,12.86,1.34,25.72,2.04,38.59.31,5.58.6,11.17.87,16.76.91,17.56,1.84,35.72,3.19,53.79,1.49,20.32-4.18,34.05-17.84,43.2-5.16,3.45-10.88,5.2-17.01,5.2h-15.06c-45.58.05-104.28.1-154.01-.02-9.16-.02-18.22-4.27-24.85-11.68-6.63-7.39-10.18-16.92-10-26.83.28-14.29,1.14-29.09,1.9-42.15.31-5.37.62-10.74.91-16.1.54-10.41,1.12-20.81,1.69-31.22l.07-1.28c.21-3.92.43-7.85.65-11.77.22-3.94.44-7.88.65-11.82.15-2.9.3-5.8.45-8.7.15-2.9.3-5.79.45-8.7.51-10.04,1.11-21.71,1.81-33.09.33-5.43,3.75-8.98,8.7-9.05,2.69-.04,6.15-.06,10-.06h11.79v3.83c0,1.68-.01,3.34,0,5h-.06l.04,3.54Zm24.05-38.1c.01-6.61,1.06-13.49,3.19-20.92,4.62-16.13,13.13-28.65,25.29-37.21,18.23-12.86,40.54-12.15,58.21,1.84,15.57,12.32,25.91,35.07,25.84,56.29h-112.53Z"></path>                  </g>                </svg>';
                    o.parents(".swatch").find(".swatch-label").removeClass("is-active"),
                        o.addClass("is-active"),
                        c.hasClass("card-title-change")
                            ? a.hasClass("style_2_text_color_varriant")
                                ? c.find("[data-change-title]").text(i)
                                : c.find("[data-change-title]").text(" - " + i)
                            : a.hasClass("style_2_text_color_varriant")
                            ? c.addClass("card-title-change").append("<span data-change-title>" + i + "</span>")
                            : c.addClass("card-title-change").append("<span data-change-title> - " + i + "</span>");
                    const v = r.variants.find((t) => t.id === u);
                    if (v.compare_at_price > v.price) {
                        s.find(".price").addClass("price--on-sale"),
                            s.find(".price__sale .price-item--regular").html(Shopify.formatMoney(v.compare_at_price, window.money_format)),
                            s.find(".price__sale .price-item--sale").html(Shopify.formatMoney(v.price, window.money_format));
                        const t = `(-${Math.round((100 * (v.compare_at_price - v.price)) / v.compare_at_price)}%)`;
                        s.find(".price__label_sale .label_sale").html(t);
                    } else
                        s.find(".price__regular .price-item").html(Shopify.formatMoney(v.price, window.money_format)),
                            null == v.compare_at_price && (s.find(".price").removeClass("price--on-sale"), s.find(".price__sale .price-item--regular").html(""));
                    if ((s.find("a:not(.single-action):not(.number-showmore):not(.vendor-text)").attr("href", p.split("?variant=")[0] + "?variant=" + u), null != h)) {
                        var g = o.data("quantity");
                        s.find('[name="id"]').val(h),
                            g > 0
                                ? window.notify_me.show
                                    ? l.removeClass("is-notify-me").addClass("is-visible")
                                    : l.removeClass("is-soldout").addClass("is-visible")
                                : window.notify_me.show
                                ? l.removeClass("is-visible").addClass("is-notify-me")
                                : l.removeClass("is-visible").addClass("is-soldout"),
                            l.hasClass("is-soldout") || l.hasClass("is-notify-me")
                                ? l.hasClass("is-notify-me")
                                    ? a.hasClass("product-card-layout-08")
                                        ? d.html(f).prop("disabled", !1)
                                        : l.text(window.notify_me.button)
                                    : a.hasClass("product-card-layout-08")
                                    ? d.html(f).prop("disabled", !0)
                                    : l.text(window.variantStrings.soldOut).prop("disabled", !0)
                                : a.hasClass("product-card-layout-08")
                                ? d.html(f).prop("disabled", !1)
                                : l.text(window.variantStrings.addToCart).prop("disabled", !1);
                    } else
                        null != r && window.quick_shop.show && n.checkStatusSwatchQuickShop(s, r),
                            s
                                .find('.swatch-element[data-value="' + i + '"]')
                                .find(".single-label")
                                .trigger("click");
                    if (null != r.media) w = r.media.filter((t, e) => e.alt === i);
                    if (w.length > 0) {
                        if (w.length > 1) var b = 2;
                        else b = w.length;
                        for (var C = 0; C < b; C++) s.find(".card-media img:eq(" + C + ")").attr("srcset", w[C].src);
                    } else m && s.find(".card-media img:nth-child(1)").attr("srcset", m).attr("data-srcset", m);
                    n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format");
                }),
                o.on("click", ".item-swatch-more .number-showmore", (e) => {
                    t(e.target).closest(".swatch").hasClass("show--more")
                        ? (t(e.target).closest(".swatch").removeClass("show--more"), t(e.target).find("span:eq(0)").text("+"))
                        : (t(e.target).closest(".swatch").addClass("show--more"), t(e.target).find("span:eq(0)").text("-"));
                });
        },
        checkPreOrderOfVariant: function (e, a, o) {
            const i = e.id,
                s = (t, e, a) => {
                    const o = t.parents(".product-item").find("[data-quickshop-popup]").length > 0;
                    null == e.inventory_management
                        ? t
                              .text(o ? window.variantStrings.add : window.variantStrings.addToCart)
                              .prop("disabled", !1)
                              .removeClass("is-notify-me")
                              .addClass("button--pre-untrack")
                        : e.available && a <= 0
                        ? t.text(window.variantStrings.preOrder).prop("disabled", !1).removeClass("is-notify-me").addClass("button--pre-untrack")
                        : (t.removeClass("button--pre-untrack"),
                          a > 0
                              ? window.notify_me.show
                                  ? t.removeClass("is-notify-me").addClass("is-visible")
                                  : t.removeClass("is-soldout").addClass("is-visible")
                              : window.notify_me.show
                              ? t.removeClass("is-visible").addClass("is-notify-me").prop("disabled", !1)
                              : t.removeClass("is-visible").addClass("is-soldout").prop("disabled", !0),
                          t.hasClass("is-soldout") || t.hasClass("is-notify-me")
                              ? t.hasClass("is-notify-me")
                                  ? t.text(window.notify_me.button).prop("disabled", !1).removeClass("btn-unavailable")
                                  : t.text(window.variantStrings.soldOut).prop("disabled", !0)
                              : t.text(o ? window.variantStrings.add : window.variantStrings.addToCart).prop("disabled", !1));
                },
                r = `quick_view_inven_array_${o.id}`;
            var c = window[r];
            if (null != c) {
                var l = c[i],
                    d = parseInt(l);
                s(a, e, d);
            } else
                t.ajax({
                    type: "get",
                    url: window.routes.root + "/products/" + o.handle + "?view=ajax_quick_shop_data",
                    beforeSend: function () {},
                    success: function (t) {
                        window[r] = JSON.parse(t.split("=")[1]);
                        var o = window[r][i],
                            n = parseInt(o);
                        s(a, e, n);
                    },
                    error: function (e, a) {
                        n.showWarning(t.parseJSON(e.responseText).description);
                    },
                    complete: function () {},
                });
        },
        initQuickShop: function () {
            window.quick_shop.show &&
                (o.on("click", "[data-quickshop-popup]", (e) => {
                    e.preventDefault(), e.stopPropagation();
                    var s = t(e.target),
                        r = s.parents(".product-item"),
                        c = r.data("json-product"),
                        l = r.find(".variants-popup");
                    const d = document.querySelector(".halo-quick-view-popup");
                    if (
                        (!document.body.matches(".qv-loaded", ".qs3-loaded") && d && (n.buildStyleSheet(d.dataset.urlStyleProduct, d), document.body.classList.add("qs3-loaded")),
                        a.hasClass("quick_shop_option_1") && (t(".productListing").hasClass("productList") || n.appendProductQuickShopOption2(r)),
                        r.hasClass("quickshop-popup-show"))
                    )
                        n.initAddToCartQuickShop(s, l);
                    else {
                        if ((t(".product-item").removeClass("quickshop-popup-show"), a.hasClass("quick_shop_option_2"))) {
                            var u = r.find(".card-media").outerHeight(!0),
                                p = l.find(".variants");
                            a.hasClass("product-card-layout-02")
                                ? i.width() > 1024
                                    ? (p.css("max-height", u - 114 + "px"), p.css("min-height", u - 114 + "px"))
                                    : (p.css("max-height", u - 70 + "px"), p.css("min-height", u - 70 + "px"))
                                : a.hasClass("product-card-layout-04")
                                ? i.width() > 1024
                                    ? (p.css("max-height", u - 116 + "px"), p.css("min-height", u - 116 + "px"))
                                    : (p.css("max-height", u - 70 + "px"), p.css("min-height", u - 70 + "px"))
                                : i.width() > 1024
                                ? (p.css("max-height", u - 74 + "px"), p.css("min-height", u - 74 + "px"))
                                : (p.css("max-height", u - 20 + "px"), p.css("min-height", u - 20 + "px")),
                                p[0].scrollHeight > p[0].clientHeight && p.addClass("scrollable"),
                                t(".productListing").hasClass("productList") || n.appendProductQuickShopOption2(r);
                        } else if (a.hasClass("quick_shop_option_3")) {
                            const e = s.data("product-handle");
                            t(".productListing").hasClass("productList") || n.updateContentQuickshopOption3(e),
                                o.on("click", "[data-close-quick-shop-popup]", (t) => {
                                    t.preventDefault(), t.stopPropagation(), a.removeClass("quickshop-popup-show");
                                }),
                                o.off("click.quickShopOverlay").on("click.quickShopOverlay", (e) => {
                                    a.hasClass("quickshop-popup-show") && 0 === t(e.target).closest("[data-quickshop-popup-option-3]").length && a.removeClass("quickshop-popup-show");
                                });
                        } else if (a.hasClass("quick_shop_bulk")) {
                            const e = s.data("product-handle");
                            t(".productListing").hasClass("productList") || n.updateContentQuickBulk(e, s),
                                o.on("click", "[data-close-quick-shop-popup]", (t) => {
                                    t.preventDefault(), t.stopPropagation(), a.removeClass("quickshop-popup-show");
                                }),
                                o.off("click.quickShopOverlay").on("click.quickShopOverlay", (e) => {
                                    a.hasClass("quickshop-popup-show") && 0 === t(e.target).closest("[data-halo-quick-bulk-popup]").length && a.removeClass("quickshop-popup-show");
                                });
                        }
                        a.hasClass("quick_shop_bulk") ||
                            (a.hasClass("quick_shop_option_3")
                                ? t(".productListing").hasClass("productList") && (i.width() < 767 ? n.appendToListViewModal(r) : r.addClass("quickshop-popup-show"))
                                : i.width() < 767 && t(".productListing").hasClass("productList")
                                ? n.appendToListViewModal(r)
                                : r.addClass("quickshop-popup-show")),
                            r.find(".swatch-label.is-active").trigger("click"),
                            n.checkStatusSwatchQuickShop(r, c);
                        let e = !1;
                        if ((a.hasClass("quick_shop_option_1") && i.width() < 767 && (e = !0), a.hasClass("quick_shop_option_2") || e || (t("productListing").hasClass("productList") && !t(".card-swatch").hasClass("quick_shop_type_3")))) {
                            if (i.width() < 767)
                                if (t(".productListing").hasClass("productList"))
                                    l.find(".selector-wrapper").each((e, a) => {
                                        t(a).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find(".single-label").trigger("click");
                                    });
                                else
                                    t("#halo-card-mobile-popup .variants-popup")
                                        .find(".selector-wrapper")
                                        .each((e, a) => {
                                            t(a).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find(".single-label").trigger("click");
                                        });
                            else
                                l.find(".selector-wrapper").each((e, a) => {
                                    t(a).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find(".single-label").trigger("click");
                                });
                            t(".productListing").hasClass("productList") || a.addClass("quick_shop_popup_mobile");
                        } else
                            l.find(".selector-wrapper:not(.option-color)").each((e, a) => {
                                t(a).find(".swatch-element:not(.soldout):not(.unavailable)").eq("0").find(".single-label").trigger("click");
                            });
                    }
                    n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format");
                }),
                o.on("click", "[data-cancel-quickshop-popup]", (e) => {
                    e.preventDefault(), e.stopPropagation();
                    var i = t(e.currentTarget).parents(".product-item"),
                        n = o.find("#halo-card-mobile-popup");
                    i.removeClass("quickshop-popup-show"),
                        o.find(".quickshop-popup-show").removeClass("quickshop-popup-show"),
                        a.removeClass("quickshop-list-view-show"),
                        (a.hasClass("quick_shop_option_1") || a.hasClass("quick_shop_option_2")) && (a.removeClass("quick_shop_popup_mobile"), n.removeClass("show"));
                }),
                o.on("click", (e) => {
                    0 === t(e.target).closest("[data-quickshop-popup]").length &&
                        0 === t(e.target).closest(".variants-popup").length &&
                        0 === t(e.target).closest(".card-swatch").length &&
                        0 === t(e.target).closest("[data-warning-popup]").length &&
                        (t(".product-item").removeClass("quickshop-popup-show"), a.hasClass("quick_shop_option_2") && a.removeClass("quick_shop_popup_mobile"));
                }),
                n.changeSwatchQuickShop());
        },
        appendToListViewModal: function (e) {
            const i = o.find("#list-view-popup"),
                n = e.clone();
            i.find(".halo-popup-content").empty(), i.find(".halo-popup-content").append(n);
            const s = i.find("[data-quickshop] .card-information .variants-popup form").eq("0"),
                r = s.attr("id") + "-mobile",
                c = s.find(".single-option"),
                l = s.find(".single-label"),
                d = (i.find(".card-product"), i.find(".variants-popup")),
                u = i.find("[data-btn-addtocart]");
            d.removeClass("card-list__hidden");
            let p = { selected1: !1, selected2: !1, selected3: !1 };
            s.attr("id", r),
                u.attr("data-form-id", u.attr("data-form-id") + "-mobile"),
                c.each((e, a) => {
                    t(a).attr("id", t(a).attr("id") + "-mobile"), t(a).attr("name", t(a).attr("name") + "-mobile"), a.checked && t(a).trigger("change");
                }),
                l.each((e, a) => {
                    t(a).attr("for", t(a).attr("for") + "-mobile");
                    const o = t(a).closest(".selector-wrapper");
                    t(a).closest(".swatch-element").hasClass("available") &&
                        (o.hasClass("selector-wrapper-1") && !p.selected1
                            ? ((p.selected1 = !0), t(a).trigger("click"))
                            : o.hasClass("selector-wrapper-2") && !p.selected2
                            ? ((p.selected2 = !0), t(a).trigger("click"))
                            : o.hasClass("selector-wrapper-3") && !p.selected3 && ((p.selected3 = !0), t(a).trigger("click")));
                }),
                a.addClass("quickshop-list-view-show"),
                t(".background-overlay")
                    .off("click.closeListViewModal")
                    .on("click.closeListViewModal", () => {
                        a.removeClass("quickshop-list-view-show");
                    });
        },
        changeSwatchQuickShop: function () {
            o.on("change", "[data-quickshop] .single-option", (e) => {
                var o,
                    s,
                    r = t(e.target),
                    c = r.parents(".product-item"),
                    l = c.data("json-product"),
                    d = c.find("[data-btn-addtocart]"),
                    u = c.find(".option-color").data("option-position"),
                    p = r.closest("[data-option-index]").data("option-index"),
                    h = c.find(".swatch-element"),
                    m = r.val(),
                    w = c.find("[name=id]");
                if (t(".productListing").hasClass("productList"))
                    var f = c.find(".card-information .selector-wrapper-1").find("input:checked").val(),
                        v = c.find(".card-information .selector-wrapper-2").find("input:checked").val(),
                        g = c.find(".card-information .selector-wrapper-3").find("input:checked").val();
                else (f = c.find(".selector-wrapper-1").find("input:checked").val()), (v = c.find(".selector-wrapper-2").find("input:checked").val()), (g = c.find(".selector-wrapper-3").find("input:checked").val());
                switch (
                    (a.hasClass("quick_shop_option_2") && t(".productListing").hasClass("productList")
                        ? (f = c.find(".selector-wrapper-1").eq("1").find("input:checked").val())
                        : t(".productListing").hasClass("productList") && i.width() < 767
                        ? ((f = c.find(".selector-wrapper-1").eq("1").find("input:checked").val()), (v = c.find('[data-option-index="1"]').eq("1").find("input:checked").val()))
                        : (f = c.find(".selector-wrapper-1").eq("0").find("input:checked").val()),
                    null != l && (o = l.variants),
                    h.removeClass("soldout"),
                    h.find('input[type="radio"]').prop("disabled", !1),
                    p)
                ) {
                    case 0:
                        if (
                            null !=
                            (b = o.find((t) => (1 == u ? (null != g ? t.option2 == m && t.option1 == v && t.option3 == g : t.option2 == m && t.option1 == v) : 2 == u ? t.option3 == m && t.option1 == v : t.option1 == m && t.option2 == v)))
                        )
                            s = b;
                        else s = o.find((t) => (1 == u ? t.option2 == m : 2 == u ? t.option3 == m : t.option1 == m));
                        break;
                    case 1:
                        if (null != (b = o.find((t) => (1 == u ? t.option2 == f && t.option1 == m && t.option3 == v : 2 == u ? t.option3 == f && t.option1 == m && t.option2 == v : t.option1 == f && t.option2 == m && t.option3 == v))))
                            s = b;
                        else s = o.find((t) => (1 == u ? t.option2 == f && t.option1 == m : 2 == u ? t.option3 == f && t.option1 == m : t.option1 == f && t.option2 == m));
                        break;
                    case 2:
                        var b;
                        null != (b = o.find((t) => (1 == u ? t.option2 == f && t.option1 == v && t.option3 == m : 2 == u ? t.option3 == f && t.option1 == v && t.option2 == m : t.option1 == f && t.option2 == v && t.option3 == m))) &&
                            (s = b);
                }
                if (null != s) {
                    w.val(s.id);
                    var C = r.val();
                    r.parents(".selector-wrapper").find(".form-label span").text(C),
                        s.available
                            ? (c.find("[data-btn-addtocart]").removeClass("btn-unavailable"), c.find("[data-quickshop] quickshop-update-quantity").removeClass("disabled"), c.find("[data-btn-addtocart]").attr("data-available", "true"))
                            : (c.find("[data-btn-addtocart]").addClass("btn-unavailable"), c.find("[data-quickshop] quickshop-update-quantity").addClass("disabled"), c.find("[data-btn-addtocart]").attr("data-available", "false")),
                        n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                        !a.hasClass("quick_shop_option_2") && !a.hasClass("quick_shop_option_3") && i.width(),
                        a.hasClass("quick_shop_option_2") &&
                            i.width() < 767 &&
                            (1 == t('.halo-popup-wrapper .card-product__wrapper [data-option-index="0"] .swatch-element').length &&
                                t('.halo-popup-wrapper .card-product__wrapper [data-option-index="0"] .swatch-element').eq("0").find(".single-label").trigger("click"),
                            1 == t('.halo-product-list-view-popup .product-options-wrapper .product-item .card-information [data-option-index="0"] .swatch-element').length &&
                                t('.halo-product-list-view-popup .product-options-wrapper .product-item .card-information [data-option-index="0"] .swatch-element').eq("0").find(".single-label").trigger("click")),
                        n.checkStatusSwatchQuickShop(c, l),
                        n.checkPreOrderOfVariant(s, d, l);
                }
            });
        },
        checkStatusSwatchQuickShop: function (e, o) {
            var n,
                s = e.find(".card-variant"),
                r = e.find("[data-option-index]"),
                c = e.find(".option-color").data("option-position"),
                l = e.find('[data-option-index="0"]').find("input:checked").val(),
                d = e.find('[data-option-index="1"]').find("input:checked").val(),
                u = e.find('[data-option-index="2"]').find("input:checked").val(),
                p = e.data("product-id");
            if (a.hasClass("quick_shop_option_2")) {
                var h = e.find(".card-media").outerHeight(!0);
                null != u
                    ? a.hasClass("product-card-layout-01")
                        ? h < 310
                            ? t("[data-quickshop]").addClass("active_option_3")
                            : t("[data-quickshop]").removeClass("active_option_3")
                        : h < 370
                        ? t("[data-quickshop]").addClass("active_option_3")
                        : t("[data-quickshop]").removeClass("active_option_3")
                    : i.width() > 1024
                    ? a.hasClass("product-card-layout-05")
                        ? h < 350 && null != d
                            ? t("[data-quickshop]").addClass("active_option_3")
                            : t("[data-quickshop]").removeClass("active_option_3")
                        : a.hasClass("product-card-layout-01")
                        ? h < 310 && null != d
                            ? t("[data-quickshop]").addClass("active_option_3")
                            : t("[data-quickshop]").removeClass("active_option_3")
                        : h < 370 && null != d
                        ? t("[data-quickshop]").addClass("active_option_3")
                        : t("[data-quickshop]").removeClass("active_option_3")
                    : a.hasClass("product-card-layout-01")
                    ? h < 310
                        ? null != l || null != d
                            ? t("[data-quickshop]").removeClass("active_option_3")
                            : t("[data-quickshop]").addClass("active_option_3")
                        : t("[data-quickshop]").removeClass("active_option_3")
                    : h < 370
                    ? null != l || null != d
                        ? t("[data-quickshop]").removeClass("active_option_3")
                        : t("[data-quickshop]").addClass("active_option_3")
                    : t("[data-quickshop]").removeClass("active_option_3");
            }
            if (
                (a.hasClass("quick_shop_option_2") && t(".productListing").hasClass("productList")
                    ? (l = e.find('[data-option-index="0"]').eq("1").find("input:checked").val())
                    : t(".productListing").hasClass("productList") && i.width() < 767
                    ? ((l = e.find('[data-option-index="0"]').eq("1").find("input:checked").val()), (d = e.find('[data-option-index="1"]').eq("1").find("input:checked").val()))
                    : (l = e.find('[data-option-index="0"]').eq("0").find("input:checked").val()),
                null != o && (n = o.variants),
                r.each((e, a) => {
                    var o = t(a).data("option-index"),
                        i = t(a).find(".swatch-element");
                    switch (o) {
                        case 0:
                            i.each((e, a) => {
                                var o = t(a),
                                    i = o.data("value"),
                                    s = n.find((t) => (1 == c ? t.option2 == i && t.available : 2 == c ? t.option3 == i && t.available : t.option1 == i && t.available)),
                                    r = n.find((t) => (1 == c ? t.option2 == i : 2 == c ? t.option3 == i : t.option1 == i));
                                null == s
                                    ? null == r
                                        ? (o.removeClass("soldout available").addClass("unavailable"), o.find('input[type="radio"]').prop("checked", !1))
                                        : (o.removeClass("unavailable available").addClass("soldout").find(".single-action").attr("data-variant-id", r.title), o.find('input[type="radio"]').prop("disabled", !1))
                                    : (o.removeClass("soldout unavailable").addClass("available"), o.find('input[type="radio"]').prop("disabled", !1));
                            });
                            break;
                        case 1:
                            i.each((e, a) => {
                                var o = t(a),
                                    i = o.data("value"),
                                    s = n.find((t) => (1 == c ? t.option2 == l && t.option1 == i && t.available : 2 == c ? t.option3 == l && t.option1 == i && t.available : t.option1 == l && t.option2 == i && t.available)),
                                    r = n.find((t) => (1 == c ? t.option2 == l && t.option1 == i : 2 == c ? t.option3 == l && t.option1 == i : t.option1 == l && t.option2 == i));
                                null == s
                                    ? null == r
                                        ? (o.removeClass("soldout available").addClass("unavailable"), o.find('input[type="radio"]').prop("checked", !1))
                                        : (o.removeClass("unavailable available").addClass("soldout").find(".single-action-selector").attr("data-variant-id", r.title), o.find('input[type="radio"]').prop("disabled", !1))
                                    : (o.removeClass("soldout unavailable").addClass("available"), o.find('input[type="radio"]').prop("disabled", !1));
                            });
                            break;
                        case 2:
                            i.each((e, a) => {
                                var o = t(a),
                                    i = o.data("value"),
                                    s = n.find((t) =>
                                        1 == c
                                            ? t.option2 == l && t.option1 == d && t.option3 == i && t.available
                                            : 2 == c
                                            ? t.option3 == l && t.option1 == d && t.option2 == i && t.available
                                            : t.option1 == l && t.option2 == d && t.option3 == i && t.available
                                    ),
                                    r = n.find((t) => (1 == c ? t.option2 == l && t.option1 == d && t.option3 == i : 2 == c ? t.option3 == l && t.option1 == d && t.option2 == i : t.option1 == l && t.option2 == d && t.option3 == i));
                                null == s
                                    ? null == r
                                        ? (o.removeClass("soldout available").addClass("unavailable"), o.find('input[type="radio"]').prop("checked", !1))
                                        : (o.removeClass("unavailable available").addClass("soldout").find(".single-action-selector").attr("data-variant-id", r.title), o.find('input[type="radio"]').prop("disabled", !1))
                                    : (o.removeClass("unavailable soldout").addClass("available"), o.find('input[type="radio"]').prop("disabled", !1));
                            });
                    }
                }),
                s.find(".selector-wrapper:not(.option-color)").each((e, a) => {
                    var o = t(a);
                    o.find(".swatch-element").find("input:checked").length < 1 &&
                        (o.find(".swatch-element.available").length > 0
                            ? o.find(".swatch-element.available").eq("0").find(".single-label").trigger("click")
                            : o.find(".swatch-element.soldout").eq("0").find(".single-label").trigger("click"));
                }),
                a.hasClass("quick_shop_option_2"))
            ) {
                var m = e.find("[data-quickshop]").eq(1).find('[name="id"]').val(),
                    w = window[`quick_view_inven_array_${p}`];
                if (null != w) {
                    var f = w[m],
                        v = parseInt(f),
                        g = e.find('input[name="quantity"]').eq(0);
                    g.attr("data-inventory-quantity", v), g.val() > v && (v > 0 ? g.val(v) : g.val(1));
                }
            }
        },
        initAddToCartQuickShop: function (t, e) {
            var a = e.find('[name="id"]').val();
            n.actionAddToCart(t, a, 1);
        },
        initAddToCart: function () {
            o.off("click.addToCart").on("click.addToCart", "[data-btn-addtocart]", (e) => {
                e.preventDefault(), e.stopPropagation();
                var a = t(e.target);
                a.parents(".product-item"), o.find("#halo-card-mobile-popup"), o.find(".quickshop-popup-show");
                if (a.closest("product-form").length > 0) {
                    var i = a.closest("form");
                    n.actionAddToCart2(a, i);
                } else if (a.hasClass("is-notify-me") || a.hasClass("is-soldout")) a.hasClass("is-notify-me") && n.notifyInStockPopup(a);
                else {
                    var s = a.parents("form"),
                        r = s.find('[name="id"]').val(),
                        c = s.find('[name="quantity"]').val(),
                        l = s.find('[name="quantity"]').eq(0);
                    null == c && (c = 1), t(".recipient-form").length > 0 ? t("#product-add-to-cart").trigger("click") : n.actionAddToCart(a, r, c, l);
                }
            }),
                o.on("click", "[data-close-add-to-cart-popup]", (t) => {
                    t.preventDefault(), t.stopPropagation(), a.removeClass("add-to-cart-show");
                }),
                o.on("click", (e) => {
                    a.hasClass("add-to-cart-show") && 0 === t(e.target).closest("[data-add-to-cart-popup]").length && a.removeClass("add-to-cart-show");
                });
        },
        actionAddToCart: function (e, i, s, r) {
            window.variantStrings.submit, window.variantStrings.addingToCart, window.variantStrings.addedToCart;
            e.hasClass("button-text-change") && e.text(),
                e.addClass("is-loading"),
                a.hasClass("quick-view-show")
                    ? Shopify.addItem(
                          i,
                          s,
                          e,
                          () => {
                              switch (window.after_add_to_cart.type) {
                                  case "cart":
                                      n.redirectTo(window.routes.cart);
                                      break;
                                  case "quick_cart":
                                      window.quick_cart.show
                                          ? Shopify.getCart((o) => {
                                                "popup" == window.quick_cart.type || (a.addClass("cart-sidebar-show"), n.updateSidebarCart(o)),
                                                    o.item_count >= 100 && a.find(".cart-count-bubble [data-cart-count]").text(window.cartStrings.item_99),
                                                    e.removeClass("is-loading"),
                                                    t(".background-overlay").removeClass("hold");
                                            })
                                          : (n.showWarning(window.after_add_to_cart.message_2),
                                            e.removeClass("is-loading"),
                                            n.showWarning(window.after_add_to_cart.message_2),
                                            Shopify.getCart((t) => {
                                                a.find("[data-cart-count]").text(t.item_count),
                                                    t.item_count >= 100 && a.find(".cart-count-bubble [data-cart-count]").text(window.cartStrings.item_99),
                                                    1 == t.item_count ? a.find("[data-cart-text]").text(window.cartStrings.item) : a.find("[data-cart-text]").text(window.cartStrings.items);
                                            }));
                                      break;
                                  case "popup_cart_1":
                                      Shopify.getCart((o) => {
                                          n.updatePopupCart(o, 1, i),
                                              a.addClass("add-to-cart-show"),
                                              a.removeClass("quick-view-show"),
                                              e.removeClass("is-loading"),
                                              o.item_count >= 100 && a.find(".cart-count-bubble [data-cart-count]").text(window.cartStrings.item_99),
                                              t(".background-overlay").removeClass("hold");
                                      });
                              }
                          },
                          r
                      )
                    : a.hasClass("template-cart")
                    ? Shopify.addItem(
                          i,
                          s,
                          e,
                          () => {
                              n.redirectTo(window.routes.cart);
                          },
                          r
                      )
                    : Shopify.addItem(
                          i,
                          s,
                          e,
                          () => {
                              switch (
                                  (e.removeClass("is-loading"),
                                  a.hasClass("quickshop-popup-show") && a.hasClass("quick_shop_option_3") && (a.removeClass("quickshop-popup-show"), t(".quickshop-popup-show").removeClass("quickshop-popup-show")),
                                  a.hasClass("quickshop-list-view-show") && a.removeClass("quickshop-list-view-show"),
                                  a.hasClass("show-mobile-options") && (a.removeClass("show-mobile-options"), t(".background-overlay").addClass("hold")),
                                  ((a.hasClass("quick_shop_popup_mobile") && a.hasClass("quick_shop_option_1")) || a.hasClass("quick_shop_option_2")) &&
                                      (a.removeClass("quick_shop_popup_mobile"),
                                      o.find("#halo-card-mobile-popup").removeClass("show"),
                                      o.find(".quickshop-popup-show").each((e, a) => {
                                          t(a).removeClass("quickshop-popup-show");
                                      })),
                                  window.after_add_to_cart.type)
                              ) {
                                  case "cart":
                                      n.redirectTo(window.routes.cart);
                                      break;
                                  case "quick_cart":
                                      window.quick_cart.show
                                          ? Shopify.getCart((o) => {
                                                "popup" == window.quick_cart.type || (a.addClass("cart-sidebar-show"), n.updateSidebarCart(o)),
                                                    e.removeClass("is-loading"),
                                                    t(".background-overlay").removeClass("hold"),
                                                    o.item_count >= 100 && a.find(".cart-count-bubble [data-cart-count]").text(window.cartStrings.item_99);
                                            })
                                          : (n.showWarning(window.after_add_to_cart.message_2),
                                            Shopify.getCart((t) => {
                                                a.find("[data-cart-count]").text(t.item_count),
                                                    t.item_count >= 100 && a.find(".cart-count-bubble [data-cart-count]").text(window.cartStrings.item_99),
                                                    1 == t.item_count ? a.find("[data-cart-text]").text(window.cartStrings.item) : a.find("[data-cart-text]").text(window.cartStrings.items);
                                            }));
                                      break;
                                  case "popup_cart_1":
                                      Shopify.getCart((o) => {
                                          n.updatePopupCart(o, 1, i),
                                              a.addClass("add-to-cart-show"),
                                              e.removeClass("is-loading"),
                                              t(".background-overlay").removeClass("hold"),
                                              o.item_count >= 100 && a.find(".cart-count-bubble [data-cart-count]").text(window.cartStrings.item_99);
                                      });
                              }
                          },
                          r
                      );
        },
        actionAddToCart2: function (e, o) {
            const i = fetchConfig("javascript");
            (i.headers["X-Requested-With"] = "XMLHttpRequest"), delete i.headers["Content-Type"];
            window.variantStrings.submit, window.variantStrings.addingToCart, window.variantStrings.addedToCart;
            e.hasClass("button-text-change") && e.text(), e.addClass("is-loading");
            let s = document.querySelector('[data-type="add-to-cart-form"]'),
                r = new FormData(s);
            document.querySelectorAll('.line-item-property__field input[name^="properties"]').forEach((t) => {
                null != t.value && ("file" == t.type ? r.append(t.name, t.files[0]) : r.append(t.name, t.value));
            });
            if (!n.checkSufficientStock(o) && a.hasClass("quickshop-popup-show")) return alert(window.cartStrings.addProductOutQuantity), void e.removeClass("is-loading");
            const c = (t) => {
                fetch(window.Shopify.routes.root + "cart/add.js", { ...i, method: "POST", body: r })
                    .then((t) => t.json())
                    .catch((t) => {
                        console.error("Error:", t);
                    })
                    .finally(() => {
                        if ((a.hasClass("quickshop-popup-show") && a.removeClass("quickshop-popup-show"), a.hasClass("quick-view-show")))
                            "cart" == window.after_add_to_cart.type
                                ? n.redirectTo(window.routes.cart)
                                : Shopify.getCart((t) => {
                                      a.find("[data-cart-count]").text(t.item_count), e.removeClass("is-loading"), cart.item_count >= 100 && a.find(".cart-count-bubble [data-cart-count]").text(window.cartStrings.item_99);
                                  });
                        else
                            switch (window.after_add_to_cart.type) {
                                case "cart":
                                    n.redirectTo(window.routes.cart);
                                    break;
                                case "quick_cart":
                                    window.quick_cart.show
                                        ? Shopify.getCart((t) => {
                                              "popup" == window.quick_cart.type || (a.addClass("cart-sidebar-show"), n.updateSidebarCart(t)),
                                                  t.item_count >= 100 && a.find(".cart-count-bubble [data-cart-count]").text(window.cartStrings.item_99),
                                                  e.removeClass("is-loading");
                                          })
                                        : n.redirectTo(window.routes.cart);
                                    break;
                                case "popup_cart_1":
                                    Shopify.getCart((o) => {
                                        n.updatePopupCart(o, 1, t),
                                            n.updateSidebarCart(o),
                                            a.addClass("add-to-cart-show"),
                                            e.removeClass("is-loading"),
                                            o.item_count >= 100 && a.find(".cart-count-bubble [data-cart-count]").text(window.cartStrings.item_99);
                                    });
                            }
                    });
            };
            fetch(window.Shopify.routes.root + "cart.js", { method: "GET" })
                .then((t) => t.json())
                .then((e) => {
                    const a = parseInt(t(s).serialize().split("id=")[1]),
                        i = e.items.find((t) => t.variant_id == a),
                        n = i?.quantity,
                        r = i?.product_id,
                        l = parseInt(o.find("[data-inventory-quantity]").val()),
                        d = parseInt(o.find("[data-inventory-quantity]").data("inventory-quantity")),
                        u = ("true" === document.getElementById("product-add-to-cart").dataset.available) | !1;
                    if (!n || !d || u) return c(a);
                    if ("deny" == window[`selling_array_${r}`][a])
                        if (n + l > d) {
                            if (!(d < 0)) {
                                const t = d - n;
                                throw new Error(`You ${t > 0 ? `can only add ${t}` : "cannot add"} more of the items into the cart`);
                            }
                            c(a);
                        } else c(a);
                    else c(a);
                })
                .catch((t) => {
                    this.showWarning(t);
                })
                .finally(() => {
                    e.removeClass("is-loading");
                });
        },
        checkSufficientStock: function (t) {
            return t.find("[data-inventory-quantity]").data("inventory-quantity") >= parseInt(t.find("[data-inventory-quantity]").val());
        },
        updateContentQuickshopOption3: function (e) {
            var o = t("#halo-quickshop-popup-option-3"),
                i = o.find(".halo-popup-content");
            t.ajax({
                type: "get",
                url: window.routes.root + "/products/" + e + "?view=ajax_quick_shop",
                beforeSend: function () {
                    t("[data-quick-view-popup] .halo-popup-content").empty();
                },
                success: function (t) {
                    i.html(t);
                },
                error: function (e, a) {
                    n.showWarning(t.parseJSON(e.responseText).description);
                },
                complete: function () {
                    var t = o.find(".quickshop");
                    n.productImageGallery(t),
                        setTimeout(() => {
                            a.addClass("quickshop-popup-show");
                        }, 150);
                },
            });
        },
        updateContentQuickBulk: function (e, a) {
            const o = t("#halo-quick-bulk-popup"),
                i = o.find(".halo-popup-content");
            t.ajax({
                type: "get",
                url: window.routes.root + "/products/" + e + "?view=ajax_quick_bulk",
                beforeSend: function () {
                    a.addClass("is-loading"), t("[data-quick-view-popup] .halo-popup-content").empty();
                },
                success: function (t) {
                    i.html(t);
                },
                error: function (e, a) {
                    n.showWarning(t.parseJSON(e.responseText).description);
                },
                complete: function () {
                    var t = o.find(".quickshop");
                    n.productImageGallery(t),
                        setTimeout(() => {
                            a.removeClass("is-loading");
                        }, 100);
                },
            });
        },
        appendProductQuickShopOption2: function (e) {
            if (window.innerWidth <= 767) {
                var i = o.find("#halo-card-mobile-popup"),
                    n = e.clone();
                i.find(".halo-popup-content").empty(), n.find(".card-product__group").remove(), i.find(".halo-popup-content").append(n);
                var s = i.find("[data-quickshop] form").eq("0"),
                    r = s.attr("id") + "mobile";
                s.attr("id", r);
                var c = s.find(".single-option"),
                    l = s.find(".single-label");
                c.each((e, a) => {
                    t(a).attr("id", t(a).attr("id") + "-mobile");
                }),
                    l.each((e, a) => {
                        t(a).attr("for", t(a).attr("for") + "-mobile");
                    }),
                    i.addClass("show"),
                    a.addClass("quick_shop_popup_mobile"),
                    o.on("click", (o) => {
                        t(o.target).hasClass("background-overlay") && (i.removeClass("show"), a.removeClass("quick_shop_popup_mobile"), e.removeClass("quickshop-popup-show"));
                    });
            }
        },
        isRunningInIframe: function () {
            try {
                return window.self !== window.top;
            } catch (t) {
                return !0;
            }
        },
        redirectTo: function (t) {
            n.isRunningInIframe() && !window.iframeSdk ? (window.top.location = t) : (window.location = t);
        },
        initQuickCart: function () {
            window.quick_cart.show && ("popup" == window.quick_cart.type || n.initSidebarCart()), n.initEventQuickCart();
        },
        initEventQuickCart: function () {
            n.removeItemQuickCart(), n.updateQuantityItemQuickCart(), n.editQuickCart();
        },
        productCollectionCartSlider: function () {

            t("[data-product-collection-cart]").each((e, a) => {
                var o = t(a).find(".products-carousel"),
                    i = o.data("item-dots"),
                    n = o.data("item-arrows");
                o.length > 0 &&
                    (o.hasClass("slick-initialized") ||
                        o.slick({
                            mobileFirst: !0,
                            adaptiveHeight: !1,
                            infinite: !1,
                            vertical: !1,
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            dots: !0,
                            arrows: !1,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive: [{ breakpoint: 1025, settings: { dots: i, arrows: n } }],
                        }));
            });
            updateStickyCart();
        },
        updatePopupCart: function (e, o, i) {
            var n = e.items.filter((t) => t.id == i)[0],
                s = t("[data-add-to-cart-popup]").find(".product-added"),
                r = s.find(".product-title"),
                c = s.find(".product-image"),
                l = n.title || n.product_title,
                d = n.featured_image,
                u = '<img src="' + d.url + '" alt="' + d.alt + '" title="' + d.alt + '"/>';
            c.attr("href", n.url).html(u),
                r.find(".title").attr("href", n.url).empty().append(l),
                Shopify.getCart((t) => {
                    a.find("[data-cart-count]").text(t.item_count);
                });
        },
        initSidebarCart: function () {
            var e = t("[data-cart-sidebar]");
            let i = !0;
            e.on("click", () => {
                i &&
                    ((i = !1),
                    Shopify.getCart((t) => {
                        n.updateSidebarCart(t);
                    }),
                    t("body").hasClass("cursor-fixed__show") && (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton()));
            }),
                a.hasClass("template-cart")
                    ? (e.on("click", (e) => {
                          e.preventDefault(), e.stopPropagation(), t("html, body").animate({ scrollTop: 0 }, 700);
                      }),
                      n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"))
                    : e.on("click", (t) => {
                          t.preventDefault(), t.stopPropagation(), a.addClass("cart-sidebar-show");
                      }),
                o.on("click", "[data-close-cart-sidebar]", (t) => {
                    t.preventDefault(), t.stopPropagation(), a.hasClass("cart-sidebar-show") && a.removeClass("cart-sidebar-show");
                }),
                a.on("click", ".background-overlay", (e) => {
                    !a.hasClass("cart-sidebar-show") ||
                        a.hasClass("quickshop-popup-show") ||
                        a.hasClass("quick_shop_popup_mobile") ||
                        a.hasClass("edit-cart-show") ||
                        a.hasClass("term-condition-show") ||
                        a.hasClass("has-warning") ||
                        (0 === t(e.target).closest("#halo-cart-sidebar").length &&
                            0 === t(e.target).closest("[data-cart-sidebar]").length &&
                            0 === t(e.target).closest("[data-edit-cart-popup]").length &&
                            0 === t(e.target).closest("[data-warning-popup]").length &&
                            0 === t(e.target).closest("[data-term-condition-popup]").length &&
                            a.removeClass("cart-sidebar-show"));
                });
        },
        updateSidebarCart: function (e) {
            if (!t.isEmptyObject(e)) {
                const o = t("#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper"),
                    i =
                        '<div class="loading-overlay loading-overlay--custom">                        <div class="loading-overlay__spinner">                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>                            </svg>                        </div>                    </div>',
                    s = "is-loading";
                o.addClass(s).prepend(i),
                    t.ajax({
                        type: "GET",
                        url: window.routes.root + "/cart?view=ajax_side_cart",
                        cache: !1,
                        success: function (e) {
                            var a = t(e);
                            o.removeClass(s).html(a), n.dispatchChangeForShippingMessage();
                        },
                        error: function (e, a) {
                            n.showWarning(t.parseJSON(e.responseText).description);
                        },
                        complete: function () {
                            a.find("[data-cart-count]").text(e.item_count),
                                e.item_count >= 100 && a.find(".cart-count-bubble [data-cart-count]").text(window.cartStrings.item_99),
                                1 == e.item_count ? a.find("[data-cart-text]").text(window.cartStrings.item) : a.find("[data-cart-text]").text(window.cartStrings.items),
                                n.productCollectionCartSlider(),
                                n.updateGiftWrapper(),
                                n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                                document.dispatchEvent(new CustomEvent("cart-update", { detail: e })),
                                t("body").hasClass("cursor-fixed__show") && (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton());
                        },
                    });
            }
        },
        dispatchChangeForShippingMessage: function () {
            document.querySelectorAll("[data-free-shipping-wrapper]").forEach((t) => {
                const e = new Event("change", { bubbles: !0 });
                t.dispatchEvent(e);
            });
        },
        updateGiftWrapper: function () {
            let e;
            t("#gift-wrapping")
                .off("click")
                .on("click", (a) => {
                    a.stopPropagation(), a.preventDefault();
                    const o = t(a.currentTarget);
                    clearTimeout(e),
                        (e = setTimeout(() => {
                            const t = a.target.dataset.giftId;
                            Shopify.addItem(t, 1, o, () => {
                                Shopify.getCart((t) => {
                                    n.updateSidebarCart(t);
                                });
                            });
                        }, 250));
                }),
                t("#cart-gift-wrapping")
                    .off("click")
                    .on("click", (a) => {
                        a.stopPropagation(), a.preventDefault();
                        var o = t(a.currentTarget),
                            i = o.attr("data-adding-text");
                        o.text(i),
                            clearTimeout(e),
                            (e = setTimeout(() => {
                                const t = a.target.dataset.giftId;
                                Shopify.addItem(t, 1, o, () => {
                                    Shopify.getCart((t) => {
                                        n.updateCart(t);
                                    });
                                });
                            }, 250));
                    });
        },
        removeItemQuickCart: function () {
            o.on("click", "[data-cart-remove]", (e) => {
                e.preventDefault(), e.stopPropagation();
                var o = t(e.currentTarget),
                    i = (o.attr("data-cart-remove-id"), t("#cart-gift-wrapping").attr("data-add-text")),
                    s = o.data("line"),
                    r = o.data("index");
                t("#cart-gift-wrapping").text(i),
                    Shopify.removeItem(s, r, (t) => {
                        a.hasClass("template-cart") ? n.updateCart(t) : a.hasClass("cart-modal-show") || (a.hasClass("cart-sidebar-show") && n.updateSidebarCart(t));
                    });
            });
        },
        updateCart: function (e) {
            if (!t.isEmptyObject(e)) {
                const o = t("#main-cart-items").data("id"),
                    i = t("[data-cart]"),
                    s = i.find("[data-cart-content]"),
                    r = i.find("[data-cart-total]"),
                    c =
                        '<div class="loading-overlay loading-overlay--custom">                        <div class="loading-overlay__spinner">                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>                            </svg>                        </div>                    </div>',
                    l = "is-loading";
                i.addClass(l).prepend(c),
                    t.ajax({
                        type: "GET",
                        url: `/cart?section_id=${o}`,
                        cache: !1,
                        success: function (a) {
                            var o = a.replaceAll("cart-coupon-discount", "div"),
                                n = t(o);
                            if ((i.removeClass(l), i.find(".loading-overlay").remove(), e.item_count > 0)) {
                                var c = n.find("[data-cart-content] .cart").html(),
                                    d = n.find("[data-cart-total] .cart-total-subtotal").html(),
                                    u = n.find("[data-cart-total] .cart-total-grandtotal").html(),
                                    p = n.find("[data-cart-total] .cart-total-savings").html();
                                if ((s.find(".cart").html(c), r.find(".cart-total-subtotal").html(d), r.find(".cart-total-grandtotal").html(u), r.find(".cart-total-savings").html(p), n.find(".haloCalculatorShipping").length > 0)) {
                                    var h = n.find(".haloCalculatorShipping");
                                    i.find(".haloCalculatorShipping").replaceWith(h);
                                }
                            } else {
                                c = n.find("#main-cart-items").html();
                                var m = n.find(".page-header").html();
                                (cartCountdownText1 = n.find(".cart-countdown").data("coundown-text-empty-1")),
                                    (cartCountdownText2 = n.find(".cart-countdown").data("coundown-text-empty-2")),
                                    (cartCountdownProductUrl = n.find(".cart-countdown").data("coundown-prd-empty-url")),
                                    (cartCountdownProductTitle = n.find(".cart-countdown").data("coundown-prd-empty-title"));
                                var w =
                                    cartCountdownText1 +
                                    ' <a href="' +
                                    cartCountdownProductUrl +
                                    '" class="cart-countdown-product link-effect p-relative"><span class="text">' +
                                    cartCountdownProductTitle +
                                    "</span></a> " +
                                    cartCountdownText2;
                                t("#main-cart-items").html(c), t(".page-header").html(m), t(".cart-countdown .text-wrap").html(w);
                            }
                        },
                        error: function (e, a) {
                            n.showWarning(t.parseJSON(e.responseText).description);
                        },
                        complete: function () {
                            if (
                                (a.find("[data-cart-count]").text(e.item_count),
                                n.dispatchChangeForShippingMessage(),
                                n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                                a.hasClass("template-cart"))
                            ) {
                                const o = document.getElementById("cart-gift-wrapping"),
                                    i = o?.dataset.isChecked,
                                    n = o?.dataset.giftId;
                                if ("true" === i) {
                                    t("#is-a-gift").hide();
                                    const e = document.querySelector(`[data-cart-remove-id="${n}"]`),
                                        a = document.querySelector(`[data-cart-quantity-id="${n}"]`);
                                    e?.addEventListener("click", () => {
                                        o.dataset.isChecked = "false";
                                    }),
                                        a?.addEventListener("change", (t) => {
                                            Number(t.target.value) <= 0 && (o.dataset.isChecked = "false");
                                        });
                                } else t("#is-a-gift").show();
                                e.item_count >= 100 && a.find(".cart-count-bubble [data-cart-count]").text(window.cartStrings.item_99);
                            }
                            document.dispatchEvent(new CustomEvent("cart-update", { detail: e }));
                        },
                    });
            }
        },
        updateQuantityItemQuickCart: function () {
            o.on("change", "[data-cart-quantity]", (e) => {
                e.preventDefault(), e.stopPropagation();
                var o = t(e.currentTarget),
                    i = (o.attr("data-cart-quantity-id"), o.data("line")),
                    s = parseInt(o.val()),
                    r = parseInt(o.data("inventory-quantity")),
                    c = o.data("index");
                let l = !0;
                if (!o.parents(".quick-order-list__contents").length) {
                    if (r < s && r > 0) {
                        var d = `cart_selling_array_${e.currentTarget.closest("cart-update-quantity").dataset.product}`;
                        "deny" == window[d][e.currentTarget.closest("cart-update-quantity").dataset.variant] && ((s = r), (l = !1));
                    }
                    Shopify.changeItem(i, s, c, (t) => {
                        a.hasClass("template-cart") ? n.updateCart(t) : a.hasClass("cart-modal-show") || (a.hasClass("cart-sidebar-show") && n.updateSidebarCart(t)),
                            l || n.showWarning(`${window.cartStrings.addProductOutQuantity.replace("[maxQuantity]", s)}`);
                    });
                }
            });
        },
        editQuickCart: function () {
            let e = !0;
            o.on("click", "[data-open-edit-cart]", (o) => {
                o.preventDefault(), o.stopPropagation();
                var i = t(o.currentTarget),
                    s = i.data("edit-cart-url"),
                    r = i.data("edit-cart-id"),
                    c = i.data("line"),
                    l = i.data("index"),
                    d = i.data("edit-cart-quantity");
                i.parents(".previewCartItem").find("previewCartItem-variant").text();
                const u = t("[data-edit-cart-popup]").find(".halo-popup-content");
                if (e) {
                    e = !1;
                    const t = document.querySelector(".halo-edit-cart-popup"),
                        a = t.dataset.urlStyleEditCart,
                        o = t.dataset.urlScriptEditCart;
                    n.buildStyleSheet(a, t), n.buildScript(o);
                }
                t.ajax({
                    type: "get",
                    url: s,
                    cache: !1,
                    dataType: "html",
                    beforeSend: function () {
                        a.hasClass("template-cart");
                    },
                    success: function (t) {
                        u.html(t), u.find("[data-template-cart-edit]").attr({ "data-cart-update-id": r, "data-line": c, "data-index": l }), u.find(".product-edit-item").find('input[name="quantity"]').val(d);
                    },
                    error: function (e, o) {
                        n.showWarning(t.parseJSON(e.responseText).description), a.hasClass("template-cart");
                    },
                    complete: function () {
                        a.addClass("edit-cart-show"),
                            a.hasClass("template-cart"),
                            n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format"),
                            t("body").hasClass("cursor-fixed__show") && (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton());
                    },
                });
            }),
                o.on("click", "[data-close-edit-cart]", (t) => {
                    t.preventDefault(), t.stopPropagation(), a.removeClass("edit-cart-show");
                }),
                o.on("click", (e) => {
                    a.hasClass("edit-cart-show") && 0 === t(e.target).closest("[data-edit-cart-popup]").length && 0 === t(e.target).closest("[data-open-edit-cart]").length && a.removeClass("edit-cart-show");
                }),
                n.addMoreItemEditCart(),
                n.addAllItemCartEdit();
        },
        addMoreItemEditCart: function () {
            o.on("click", "[data-edit-cart-add-more]", (e) => {
                e.preventDefault(), e.stopPropagation();
                var a = t("[data-template-cart-edit]"),
                    o = t(e.target).parents(".product-edit-item"),
                    i = parseInt(a.attr("data-count")),
                    s = o.clone().removeClass("product-edit-itemFirst");
                (cloneProductId = s.attr("id") + i),
                    s.attr("id", cloneProductId),
                    n.updateClonedProductAttributes(s, i),
                    s.insertAfter(o),
                    (i += 1),
                    a.attr("data-count", i),
                    t("body").hasClass("cursor-fixed__show") && (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton());
            }),
                o.on("click", "[data-edit-cart-remove]", (e) => {
                    e.preventDefault(), e.stopPropagation(), t(e.target).parents(".product-edit-item").remove();
                });
        },
        updateClonedProductAttributes: function (e, a) {
            var o = t(".shopify-product-form", e),
                i = o.attr("id") + a;
            o.attr("id", i),
                t(".product-form__radio", e).each((e, o) => {
                    var i = t(o),
                        n = i.next(),
                        s = n.attr("for") + a,
                        r = i.attr("name");
                    n.attr("for", s), i.attr({ id: s, name: r + a });
                });
        },
        addAllItemCartEdit: function () {
            o.on("click", "#add-all-to-cart", (e) => {
                e.preventDefault(), e.stopPropagation();
                var o = t(e.currentTarget),
                    i = t("[data-template-cart-edit]"),
                    s = i.find(".product-edit-item.isChecked"),
                    r = (i.attr("data-cart-update-id"), i.data("line")),
                    c = i.data("index");
                s.length > 0
                    ? (o.addClass("is-loading"),
                      Shopify.removeItem(r, c, (e) => {
                          if (!t.isEmptyObject(e)) {
                              var i = [];
                              s.each((e, a) => {
                                  var o,
                                      n = t(a),
                                      s = n.find('input[name="id"]').val(),
                                      r = parseInt(n.find('input[name="quantity"]').val());
                                  i.push(((o = { type: "post", url: window.routes.root + "/cart/add.js", data: "quantity=" + r + "&id=" + s, dataType: "json", async: !1 }), t.ajax(o)));
                              }),
                                  i.length > 0 &&
                                      t.when.apply(t, i).done((t) => {
                                          setTimeout(function () {
                                              o.removeClass("is-loading");
                                          }, 1e3),
                                              Shopify.getCart((t) => {
                                                  a.removeClass("edit-cart-show"), a.hasClass("template-cart") ? n.updateCart(t) : a.hasClass("cart-modal-show") || (a.hasClass("cart-sidebar-show") && n.updateSidebarCart(t));
                                              });
                                      });
                          }
                      }))
                    : alert(window.variantStrings.addToCart_message);
            });
        },
        initNotifyInStock: function () {
            o.on("click", "[data-open-notify-popup]", (e) => {
                e.preventDefault(), e.stopPropagation();
                var a = t(e.currentTarget);
                n.notifyInStockPopup(a);
            }),
                o.on("click", "[data-close-notify-popup]", (e) => {
                    e.preventDefault(),
                        e.stopPropagation(),
                        a.removeClass("notify-me-show"),
                        setTimeout(() => {
                            t(".halo-notify-popup .form-field").removeClass("hidden"), t(".halo-notify-popup .form-message").addClass("hidden");
                        }, 700);
                }),
                o.on("click", (e) => {
                    a.hasClass("notify-me-show") &&
                        0 === t(e.target).closest("[data-open-notify-popup]").length &&
                        0 === t(e.target).closest("[data-notify-popup]").length &&
                        (a.removeClass("notify-me-show"),
                        setTimeout(() => {
                            t(".halo-notify-popup .form-field").removeClass("hidden"), t(".halo-notify-popup .form-message").addClass("hidden");
                        }, 700));
                });
        },
        notifyInStockPopup: function (e) {
            var o,
                i = e.parents(".product-item"),
                n = i.find(".card-title").data("product-title"),
                s = window.location.host + i.find(".card-title").data("product-url"),
                r = t("[data-notify-popup]");
            (o = e.hasClass("is-notify-me") ? i.find(".card-swatch .swatch-label.is-active").attr("title") : e.data("variant-id")),
                r.find(".halo-notify-product-title").val(t.trim(n)),
                r.find(".halo-notify-product-link").val(s),
                o && r.find(".halo-notify-product-variant").val(o),
                a.addClass("notify-me-show");
        },
        initAskAnExpert: function () {
            o.on("click", "[data-open-ask-an-expert]", (e) => {
                e.preventDefault(), e.stopPropagation();
                var o,
                    i = t("[data-ask-an-expert-popup]").find(".halo-popup-content");
                if (a.hasClass("template-product")) {
                    var n = t(".productView").data("product-handle");
                    o = window.routes.root + "/products/" + n + "?view=ajax_ask_an_expert";
                } else if (a.hasClass("quick-view-show")) {
                    n = t(".halo-quickView").data("product-quickview-handle");
                    o = window.routes.root + "/products/" + n + "?view=ajax_ask_an_expert";
                } else o = window.routes.root + "/search?view=ajax_ask_an_expert";
                t.ajax({
                    type: "get",
                    url: o,
                    beforeSend: function () {
                        i.empty();
                    },
                    success: function (t) {
                        i.html(t);
                    },
                    error: function (e, a) {
                        alert(t.parseJSON(e.responseText).description);
                    },
                    complete: function () {
                        a.addClass("ask-an-expert-show");
                    },
                });
            }),
                o.on("click", "[data-close-ask-an-expert]", (t) => {
                    t.preventDefault(), t.stopPropagation(), a.removeClass("ask-an-expert-show"), a.hasClass("recently-popup-mb-show") && a.removeClass("recently-popup-mb-show");
                }),
                o.on("click", (e) => {
                    a.hasClass("ask-an-expert-show") && 0 === t(e.target).closest("[data-open-ask-an-expert]").length && 0 === t(e.target).closest("#halo-ask-an-expert-popup").length && a.removeClass("ask-an-expert-show");
                });
        },
        resetForm: function (e) {
            t(".form-field", e).removeClass("form-field--success form-field--error"), t("input[type=email], input[type=text], textarea", e).val("");
        },
        formMessage: function () {
            const e = window.location.href.indexOf("form_type=contact") > -1;
            if (window.location.href.indexOf("contact_posted=true") > -1 || e) {
                const o = t(`[data-form-message="${t.cookie("contact_form")}"]`);
                let i = 400;
                switch ((a.hasClass("template-product") && (i = 1600), o.data("form-message"))) {
                    case "ask":
                        setTimeout(() => {
                            a.addClass("ask-an-expert-show");
                        }, i),
                            this.changeStateforContactForm(o, e),
                            t(".halo-notify-popup .form-message").addClass("hidden");
                        break;
                    case "contact":
                        o.removeClass("hidden"), this.changeStateforContactForm(o, e), t(".halo-notify-popup .form-message").addClass("hidden");
                        break;
                    case "notifyMe":
                        t(".halo-notify-popup .form-field").addClass("hidden"),
                            setTimeout(() => {
                                a.addClass("notify-me-show");
                            }, i),
                            this.changeStateforContactForm(o, e);
                }
            }
            t(document).on("click", "[data-button-message]", (e) => {
                t.cookie("contact_form", t(e.target).data("button-message"), { expires: 1, path: "/" });
            });
        },
        changeStateforContactForm(e, a) {
            window.history.pushState("object", document.title, location.href.split("?")[0]),
                a && (t(".newsletter-form__message--error").addClass("hidden"), t("html, body").animate({ scrollTop: e.offset().top - window.innerHeight / 2 }, 700));
        },
        initCompareProduct: function () {
            var e = t("[data-compare-link]");
            window.compare.show &&
                (n.setLocalStorageProductForCompare(e),
                n.setAddorRemoveProductForCompare(e),
                n.setProductForCompare(),
                o.on("click", "[data-close-compare-product-popup]", (t) => {
                    t.preventDefault(), t.stopPropagation(), a.removeClass("compare-product-show");
                }),
                o.on("click", (e) => {
                    a.hasClass("compare-product-show") && 0 === t(e.target).closest("[data-compare-link]").length && 0 === t(e.target).closest("[data-compare-product-popup]").length && a.removeClass("compare-product-show");
                }));
        },
        setLocalStorageProductForCompare: function (e) {
            var a = JSON.parse(localStorage.getItem("compareItem")),
                o = t("[data-product-compare-handle]");
            null !== a &&
                o.length > 0 &&
                (o.each((e, o) => {
                    var i = t(o),
                        n = i.data("product-compare-handle");
                    a.indexOf(n) >= 0
                        ? (i.find(".compare-icon").addClass("is-checked"), i.find(".text").text(window.compare.added), i.find("input").prop("checked", !0))
                        : (i.find(".compare-icon").removeClass("is-checked"), i.find(".text").text(window.compare.add), i.find("input").prop("checked", !1));
                }),
                n.updateCounterCompare(e));
        },
        setAddorRemoveProductForCompare: function (e) {
            o.on("change", "[data-product-compare] input", (a) => {
                var o = t(a.currentTarget),
                    i = o.parents(".card-compare"),
                    s = o.val(),
                    r = JSON.parse(localStorage.getItem("compareItem"));
                (r = n.uniqueArray(r)),
                    a.currentTarget.checked
                        ? (i.find(".compare-icon").addClass("is-checked"), i.find(".text").text(window.compare.added), i.find("input").prop("checked", !0), n.incrementCounterCompare(r, s, e))
                        : (i.find(".compare-icon").removeClass("is-checked"), i.find(".text").text(window.compare.add), i.find("input").prop("checked", !1), n.decrementCounterCompare(r, s, e));
            });
        },
        setProductForCompare: function () {
            o.on("click", "[data-compare-link]", (t) => {
                t.preventDefault(), t.stopPropagation();
                var e = JSON.parse(localStorage.getItem("compareItem"));
                if (e.length <= 1) return alert(window.compare.message), !1;
                n.updateContentCompareProduct(e, 0);
            }),
                o.on("click", "[data-compare-remove]", (e) => {
                    e.preventDefault(), e.stopPropagation();
                    var o = t(e.currentTarget).data("compare-item"),
                        i = t("[data-compare-product-popup] .compareTable"),
                        s = i.find('.compareTable-row[data-product-compare-id="' + o + '"]'),
                        r = s.data("compare-product-handle");
                    if (1 == i.find("tbody .compareTable-row").length) {
                        s.remove();
                        var c = (d = JSON.parse(localStorage.getItem("compareItem"))).indexOf(r),
                            l = t("[data-compare-link]");
                        c > -1 && (d.splice(c, 1), (d = n.uniqueArray(d)), localStorage.setItem("compareItem", JSON.stringify(d)), n.setLocalStorageProductForCompare(l), n.updateCounterCompare(l)), a.removeClass("compare-product-show");
                    } else {
                        s.remove();
                        var d;
                        (c = (d = JSON.parse(localStorage.getItem("compareItem"))).indexOf(r)), (l = t("[data-compare-link]"));
                        c > -1 && (d.splice(c, 1), (d = n.uniqueArray(d)), localStorage.setItem("compareItem", JSON.stringify(d)), n.setLocalStorageProductForCompare(l), n.updateCounterCompare(l));
                    }
                });
        },
        updateCounterCompare: function (t) {
            var e = JSON.parse(localStorage.getItem("compareItem"));
            e.length > 1 ? (t.parent().addClass("is-show"), t.find("span.countPill").html(e.length)) : t.parent().removeClass("is-show");
        },
        uniqueArray: function (e) {
            var a = [];
            return (
                t.each(e, function (e, o) {
                    -1 == t.inArray(o, a) && a.push(o);
                }),
                a
            );
        },
        incrementCounterCompare: function (t, e, a) {
            t.indexOf(e);
            t.push(e), (t = n.uniqueArray(t)), localStorage.setItem("compareItem", JSON.stringify(t)), n.updateCounterCompare(a);
        },
        decrementCounterCompare: function (t, e, a) {
            const o = t.indexOf(e);
            o > -1 && (t.splice(o, 1), (t = n.uniqueArray(t)), localStorage.setItem("compareItem", JSON.stringify(t)), n.updateCounterCompare(a));
        },
        updateContentCompareProduct: function (e, o) {
            const i = t("[data-compare-product-popup] .compareTable"),
                s = window.routes.root + "/products/" + e[o] + "?view=ajax_product_card_compare";
            0 == o && i.find("tbody").empty(),
                e.length > o
                    ? t.ajax({
                          type: "get",
                          url: s,
                          cache: !1,
                          success: function (t) {
                              i.find("tbody").append(t), o++, n.updateContentCompareProduct(e, o);
                          },
                      })
                    : a.addClass("compare-product-show"),
                t("body").hasClass("cursor-fixed__show") && (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton());
        },
        initProductView: function (t) {
            n.productImageGallery(t),
                n.productLastSoldOut(t),
                n.productCustomerViewing(t),
                n.productCountdown(t),
                n.productSizeChart(t),
                n.productCustomCursor(t),
                n.productVideoGallery(t),
                n.initVariantImageGroup(t, window.variant_image_group);
        },
        initQuickView: function () {
            let e = !0;
            o.on("click", "[data-open-quick-view-popup]", (a) => {
                if ((a.preventDefault(), a.stopPropagation(), e)) {
                    e = !1;
                    const t = document.querySelector(".halo-quick-view-popup"),
                        a = t.dataset.urlStyleProduct,
                        o = t.dataset.urlStyleQuickView,
                        i = t.dataset.urlVariantsQuickView,
                        s = "https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js";
                    document.body.matches(".qs3-loaded") || n.buildStyleSheet(a, t),
                        n.buildStyleSheet(o, t),
                        n.buildScript(i),
                        document.body.classList.add("qv-loaded"),
                        document.body.matches(".sortable-loader") || (document.body.classList.add("sortable-loader"), n.buildScript(s));
                }
                var o = t(a.currentTarget).data("product-handle");
                n.updateContentQuickView(o);
            }),
                o.on("click", "[data-close-quick-view-popup]", (t) => {
                    t.preventDefault(), t.stopPropagation(), a.removeClass("quick-view-show");
                }),
                t(".background-overlay")
                    .off("click.closeQuickView")
                    .on("click.closeQuickView", (t) => {
                        !a.hasClass("quick-view-show") ||
                            a.hasClass("cart-sidebar-show") ||
                            a.hasClass("ask-an-expert-show") ||
                            a.hasClass("size-chart-show") ||
                            a.hasClass("compare-color-show") ||
                            a.hasClass("term-condition-show") ||
                            a.removeClass("quick-view-show");
                    });
        },
        updateContentQuickView: function (e) {
            var o = t("[data-quick-view-popup]"),
                i = o.find(".halo-popup-content");
            t.ajax({
                type: "get",
                url: window.routes.root + "/products/" + e + "?view=ajax_quick_view",
                beforeSend: function () {
                    i.empty(), t("#halo-quickshop-popup-option-3").find(".halo-popup-content").empty();
                },
                success: function (t) {
                    i.html(t);
                },
                error: function (e, a) {
                    alert(t.parseJSON(e.responseText).description);
                },
                complete: function () {
                    var i = o.find(".quickView");
                    const s = t(".halo-popup-content .halo-compare-color-popup li.item"),
                        r = t(".halo-popup-content .halo-compare-color-popup #sortTableList"),
                        c = t(".halo-popup-content .halo-compare-color-popup"),
                        l = t(".halo-popup-content .halo-size-chart-popup");
                    if (
                        (n.productImageGallery(i),
                        n.productLastSoldOut(i),
                        n.productCustomerViewing(i),
                        n.productCountdown(i),
                        n.productSizeChart(i),
                        n.setProductForWishlist(e),
                        n.initVariantImageGroup(i, window.variant_image_group_quick_view),
                        a.addClass("quick-view-show"),
                        window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
                        r.attr("id", "quickViewSortTableList"),
                        s.each((e, a) => {
                            const o = t(a).find(".swatch-compare-color-option"),
                                i = t(a).find(".swatch-compare-color-label"),
                                n = o.attr("id");
                            o.attr("id", `quickView-${n}`).attr("name", `quickView-${n}`), i.attr("for", `quickView-${n}`);
                        }),
                        c.attr("id", "quickView-halo-compare-color-popup"),
                        l.attr("id", "quickView-halo-size-chart-popup"),
                        t(".halo-productView .addthis_inline_share_toolbox").length)
                    ) {
                        var d = t(".halo-productView .addthis_inline_share_toolbox").html();
                        t(".halo-popup-content .share-button__button").click(function () {
                            t(".halo-popup-content .addthis_inline_share_toolbox").append(d);
                        });
                    }
                    const u = document.getElementById("quickViewSortTableList"),
                        p = t(".halo-popup-content .halo-compareColors-image");
                    window.innerWidth >= 1025 && u
                        ? new Sortable(u, { animation: 150 })
                        : p.on("click", ".item", (e) => {
                              e.preventDefault();
                              var a = `swatch-compare-color-${e.currentTarget.classList[1].replace("item-", "")}`;
                              t(document.getElementById(a)).trigger("click");
                          }),
                        t("body").hasClass("cursor-fixed__show") && (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton());
                },
            });
        },
        productImageGallery: function (a) {
            var o = a.find(".productView-nav"),
                s = a.find('.productView-for:not(".mobile")'),
                r = a.find(".productView-for.mobile");
            if (!s.hasClass("slick-initialized") && !o.hasClass("slick-initialized")) {
                const f = o.data("arrows-desk"),
                    v = o.data("arrows-mobi"),
                    g = o.data("counter-mobi"),
                    b = o.data("media-count"),
                    C = parseInt(s.data("max-thumbnail-to-show"));
                let y, k, _;
                var c;
                (e = o.html()), (_ = o.hasClass("productView-nav-gallery") ? Math.round(b / 2) : b), (_ = o.hasClass("productView-horizontal-tabs") && 2 == b ? 1 : b);
                let S =
                    '<div class="slick-counter">\n                    <span class="slick-counter--current">1</span>\n                    <span aria-hidden="true">/</span>\n                    <span class="slick-counter--total">' +
                    _ +
                    "</span>\n                </div>";
                const x = () => {
                        setTimeout(() => {
                            let e = t(".productView-nav .slick-slide").length;
                            o.hasClass("productView-nav-gallery") && (e = Math.round(e / 2)),
                                (S =
                                    '<div class="slick-counter">\n                            <span class="slick-counter--current">1</span>\n                            <span aria-hidden="true">/</span>\n                            <span class="slick-counter--total">' +
                                    e +
                                    "</span>\n                        </div>");
                        }, 1e3);
                    },
                    T = () => {
                        clearTimeout(c),
                            (c = setTimeout(() => {
                                o.append(S);
                            }, 1e3));
                    };
                if (
                    (o.on("init", () => {
                        window.innerWidth < 768 &&
                            g &&
                            (variant_image_group && x(),
                            T(),
                            o.on("reInit afterChange", function (t, e, a, i) {
                                var n = (a || 0) + 1;
                                o.find(".slick-counter--current").text(n);
                            }));
                    }),
                    o.on("reInit", () => {
                        window.innerWidth < 768 && g && (variant_image_group && x(), T());
                    }),
                    (k = !o.closest(".productView").is(".layout-4") && s),
                    o.hasClass("productView-nav-gallery"))
                ) {
                    var l = (p = a.find(".productView-nav.productView-nav-gallery")).data("media-count"),
                        d = 2,
                        u = 2;
                    1 == l && ((d = 1), (u = 1)),
                        2 == l && ((d = 2), (u = 1)),
                        p.data("1-item-mobi") && window.innerWidth < 551 && ((d = 1), (u = 1)),
                        p.slick({
                            dots: !0,
                            rows: u,
                            arrows: f,
                            infinite: !0,
                            slidesPerRow: 1,
                            slidesToShow: d,
                            focusOnSelect: !1,
                            asNavFor: k,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive: [{ breakpoint: 767, settings: { arrows: v } }],
                        }),
                        (y = p);
                } else if (o.hasClass("productView-horizontal-tabs")) {
                    var p;
                    (d = 2), (u = 1);
                    (p = a.find(".productView-nav.productView-horizontal-tabs")).slick({
                        dots: !0,
                        rows: u,
                        arrows: f,
                        infinite: !1,
                        slidesPerRow: 1,
                        slidesToShow: d,
                        focusOnSelect: !1,
                        asNavFor: k,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [{ breakpoint: 767, settings: { arrows: v } }],
                    }),
                        (y = p);
                } else
                    !o.is(".style-2, .style-3") || window.innerWidth < 768
                        ? (o.slick({
                              fade: !0,
                              dots: !1,
                              arrows: f,
                              infinite: !0,
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              asNavFor: k,
                              nextArrow: window.arrows.icon_next,
                              prevArrow: window.arrows.icon_prev,
                              rtl: window.rtl_slick,
                              responsive: [{ breakpoint: 768, settings: { arrows: v } }],
                          }),
                          (y = o))
                        : (y = !1);
                if (
                    (a.hasClass("layout-1") || a.hasClass("layout-2")
                        ? (s.on("init", (t, e) => {
                              s.find(".animated-loading").removeClass("animated-loading");
                          }),
                          s.slick({
                              slidesToShow: C,
                              slidesToScroll: 1,
                              asNavFor: y,
                              arrows: !0,
                              dots: !1,
                              draggable: !1,
                              adaptiveHeight: !1,
                              focusOnSelect: !0,
                              vertical: !0,
                              verticalSwiping: !0,
                              infinite: !0,
                              nextArrow: window.arrows.icon_next,
                              prevArrow: window.arrows.icon_prev,
                              responsive: [
                                  { breakpoint: 1600, settings: { slidesToShow: C > 3 ? C - 1 : C, slidesToScroll: 1 } },
                                  { breakpoint: 1280, settings: { vertical: !1, verticalSwiping: !1, rtl: window.rtl_slick } },
                                  { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1, vertical: !1, verticalSwiping: !1, rtl: window.rtl_slick } },
                              ],
                          }))
                        : a.hasClass("layout-3") &&
                          (s.on("init", (t, e) => {
                              s.find(".animated-loading").removeClass("animated-loading");
                          }),
                          s.slick({
                              slidesToShow: C,
                              slidesToScroll: 1,
                              asNavFor: y,
                              arrows: !0,
                              dots: !1,
                              focusOnSelect: !0,
                              infinite: !0,
                              nextArrow: window.arrows.icon_next,
                              prevArrow: window.arrows.icon_prev,
                              rtl: window.rtl_slick,
                              responsive: [
                                  { breakpoint: 1600, settings: { slidesToShow: C > 3 ? C - 1 : C, slidesToScroll: 1 } },
                                  { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                              ],
                          })),
                    r.on("init", (t, e) => {
                        r.find(".animated-loading").removeClass("animated-loading");
                    }),
                    r.slick({
                        slidesToShow: parseInt(r.data("max-thumbnail-to-show")),
                        slidesToScroll: 1,
                        asNavFor: y,
                        arrows: !0,
                        dots: !1,
                        draggable: !1,
                        adaptiveHeight: !1,
                        focusOnSelect: !0,
                        vertical: !0,
                        verticalSwiping: !0,
                        infinite: !0,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            { breakpoint: 1600, settings: { slidesToShow: C > 3 ? C - 1 : C, slidesToScroll: 1 } },
                            { breakpoint: 1280, settings: { vertical: !1, verticalSwiping: !1 } },
                            { breakpoint: 767, settings: { slidesToShow: 2.2, slidesToScroll: 1, vertical: !1, verticalSwiping: !1 } },
                        ],
                    }),
                    a.hasClass("layout-1") || a.hasClass("layout-2"))
                ) {
                    var h = s.outerHeight(),
                        m = (o.outerHeight() - h) / 2,
                        w = m + 80;
                    i.width() > 1279
                        ? s.find(".slick-arrow").length > 0
                            ? (s.parent().addClass("arrows-visible"), s.parent().css("top", m))
                            : (s.parent().addClass("arrows-disable"), s.parent().css("top", w))
                        : s.find(".slick-arrow").length > 0
                        ? s.parent().css("top", "unset")
                        : s.parent().css("top", w);
                }
                if (o.find("[data-youtube]").length > 0)
                    if (void 0 === window.onYouTubeIframeAPIReady) {
                        window.onYouTubeIframeAPIReady = n.initYoutubeCarousel.bind(window, o);
                        const t = document.createElement("script");
                        t.src = "https://www.youtube.com/player_api";
                        const e = document.getElementsByTagName("script")[0];
                        e.parentNode.insertBefore(t, e);
                    } else n.initYoutubeCarousel(o);
                o.find("[data-vimeo]").length > 0 &&
                    (o.on("beforeChange", (e, a) => {
                        var o, i;
                        (i = { method: "pause", value: "true" }), null != (o = t(a.$slider).find(".slick-current").find("iframe").get(0)) && o.contentWindow.postMessage(JSON.stringify(i), "*");
                    }),
                    o.on("afterChange", (e, a) => {
                        var o, i;
                        (i = { method: "play", value: "true" }), null != (o = t(a.$slider).find(".slick-current").find("iframe").get(0)) && o.contentWindow.postMessage(JSON.stringify(i), "*");
                    })),
                    o.find("[data-mp4]").length > 0 &&
                        (o.on("beforeChange", (e, a) => {
                            var o;
                            null != (o = t(a.$slider).find(".slick-current").find("video").get(0)) && o.pause();
                        }),
                        o.on("afterChange", (e, a) => {
                            var o;
                            null != (o = t(a.$slider).find(".slick-current").find("video").get(0)) && o.play();
                        }));
            }
            var f = a.find("[data-fancybox]");
            f.length > 0 && f.fancybox({ buttons: ["zoom", "share", "slideShow", "fullScreen", "thumbs", "close"], loop: !0, thumbs: { autoStart: !0 } });
            var v = a.find("[data-zoom-image]");
            i.width() > 1024 &&
                v.each((e, a) => {
                    var o = t(a);
                    i.width() > 1024 ? o.zoom({ url: o.attr("data-zoom-image"), touch: !1 }) : o.trigger("zoom.destroy");
                }),
                i.on("resize", () => {
                    (a.hasClass("layout-1") || a.hasClass("layout-2")) &&
                        (i.width() > 1279
                            ? setTimeout(() => {
                                  if (s.find(".slick-arrow").length > 0) {
                                      var t = s.outerHeight(),
                                          e = (o.outerHeight() - t) / 2;
                                      s.parent().addClass("arrows-visible"), s.parent().css("top", e);
                                  } else s.parent().addClass("arrows-disable");
                              }, 200)
                            : setTimeout(() => {
                                  s.find(".slick-arrow").length > 0 && s.parent().css("top", "unset");
                              }, 200));
                });
        },
        productVideoGallery: function (e) {
            const o = e.find("[data-video-thumbnail]").length,
                n = t(".productView-video").length;
            if (o) {
                const o = e.find(".productView-image-wrapper"),
                    s = t("[data-popup-video]"),
                    r = e.find(".productView-nav");
                let c = o.offset().top + o.outerHeight();
                n && a.addClass("has-product-video"),
                    i.on("scroll", (o) => {
                        const i = t(o.currentTarget),
                            n = e.find(".slick-current .productView-video"),
                            l = n.data("type"),
                            d = n.data("video-url");
                        if (null != d)
                            if (i.scrollTop() > c) {
                                if (!s.is(".is-show")) {
                                    const t = r.find(".slick-slide.slick-active").data("youtube-player"),
                                        e = parseInt(t.getCurrentTime()),
                                        o = `<div class="fluid-width-video-wrapper" style="padding-top: 56.24999999999999%">\n                                                    ${
                                            "youtube" == l
                                                ? `<iframe\n                                                            id="player"\n                                                            type="text/html"\n                                                            width="100%"\n                                                            frameborder="0"\n                                                            webkitAllowFullScreen\n                                                            mozallowfullscreen\n                                                            allowFullScreen\n                                                            src="https://www.youtube.com/embed/${d}?autoplay=1&mute=1&start=${e}">\n                                                        </iframe>`
                                                : `<iframe \n                                                            src="https://player.vimeo.com/video/${d}?autoplay=1&mute=1" \n                                                            class="js-vimeo" \n                                                            allow="autoplay; \n                                                            encrypted-media" \n                                                            webkitallowfullscreen \n                                                            mozallowfullscreen \n                                                            allowfullscreen">\n                                                        </iframe>`
                                        }\n                                                </div>`;
                                    s.addClass("is-show"), s.find(".halo-popup-content").html(o), a.addClass("video-show product-video-show"), t.pauseVideo();
                                }
                            } else {
                                const t = r.find(".slick-slide.slick-active").data("youtube-player");
                                s.removeClass("is-show"), s.find(".halo-popup-content").empty(), a.removeClass("video-show product-video-show"), t.playVideo();
                            }
                    });
            }
        },
        initVariantImageGroup: function (a, i = !1) {
            if (i) {
                var s,
                    r = a.find("[data-filter]:checked"),
                    c = a.find(".productView-for"),
                    l = a.find(".productView-nav"),
                    d = a.find(".productView-product .productView-options"),
                    u = a.find("[data-filter]:checked").data("metafields-vig");
                switch (!0) {
                    case l.hasClass("productView-nav-gallery"):
                        s = "gallery";
                        break;
                    case 1 == l.closest(".product-full-width").length || 1 == l.closest(".product-full-width-2").length:
                        s = "full-width";
                        break;
                    default:
                        s = "default";
                }
                const i = () => {
                        c.slick("slickUnfilter"), ("full-width" == s && window.innerWidth > 767) || (l.hasClass("slick-filter") && l.find(".slick-counter").remove(), l.slick("slickUnfilter").removeClass("slick-filter"));
                    },
                    p = (a) => {
                        switch (s) {
                            case "gallery":
                                l.slick("unslick")
                                    .empty()
                                    .html(e)
                                    .find(".productView-image")
                                    .each(function () {
                                        t(this).is(a) || t(this).remove();
                                    });
                                const o = l.data("arrows-desk"),
                                    i = l.data("arrows-mobi"),
                                    s = l.data("media-count"),
                                    r = 2,
                                    d = 2;
                                1 == s && ((r = 1), (d = 1)),
                                    2 == s && ((r = 2), (d = 1)),
                                    l.data("1-item-mobi") && window.innerWidth < 551 && ((r = 1), (d = 1)),
                                    l.slick({
                                        dots: !0,
                                        rows: d,
                                        arrows: o,
                                        infinite: !0,
                                        slidesPerRow: 1,
                                        slidesToShow: r,
                                        focusOnSelect: !1,
                                        asNavFor: c,
                                        nextArrow: window.arrows.icon_next,
                                        prevArrow: window.arrows.icon_prev,
                                        rtl: window.rtl_slick,
                                        responsive: [{ breakpoint: 767, settings: { arrows: i } }],
                                    }),
                                    t(".cursor-wrapper").length && n.productCustomCursor(t(".halo-productView"));
                                break;
                            case "full-width":
                                if (window.innerWidth > 767) {
                                    let o = 1,
                                        i = 0;
                                    l.empty().html(e),
                                        e.length &&
                                            (a.split(",").forEach((t) => {
                                                e.includes(t.replace(/\./g, "")) && i++;
                                            }),
                                            0 == i
                                                ? l.removeClass("media-filter")
                                                : (l.addClass("media-filter"),
                                                  l.find(".productView-image").each(function () {
                                                      t(this).is(a) ? (t(this).attr("data-index", o), t(this).find("img").attr("data-index", o), o++) : t(this).remove();
                                                  }))),
                                        t(".cursor-wrapper").length && (t(".cursor-wrapper .counter-total").text(l.find(".productView-image").length), n.productCustomCursor(t(".halo-productView")));
                                    break;
                                }
                            default:
                                l.slick("slickFilter", a).slick("refresh").addClass("slick-filter");
                        }
                        c && c.slick("slickFilter", a).slick("refresh");
                    },
                    h = (t, e) => {
                        let a = t.split(","),
                            o = [];
                        a.forEach((t) => {
                            o.push(`.filter-${t.toLowerCase().replace(/[^A-Z0-9]/gi, "-")}`);
                        }),
                            e && i(),
                            p(o.join(","));
                    },
                    m = (t, e) => {
                        d.data("lang") != d.data("default-lang") && e.data("value-default-lang") && (t = `.filter-${e.data("value-default-lang")}`), i(), void 0 !== t && (l.find(t).length || c.find(t).length || "full-width" == s) && p(t);
                    };
                if (r.length > 0) {
                    let t = r.data("filter");
                    u && u.length ? h(u, !1) : m(t, r);
                }
                o.on("change", "input[data-filter]", (e) => {
                    let a = t(e.currentTarget).data("filter"),
                        o = t(e.currentTarget).data("metafields-vig");
                    o && o.length ? h(o, !0) : m(a, t(e.currentTarget));
                });
            }
        },
        initYoutubeCarousel: function (e) {
            e.each((e, a) => {
                const o = t(a);
                o.find("[data-youtube]").length > 0 && (o.addClass("slick-slider--video"), n.initYoutubeCarouselEvent(a));
            });
        },
        initYoutubeCarouselEvent: function (e) {
            var a = t(e),
                i = a.find("[data-youtube]");
            function n(e) {
                t(e.target.getIframe()).closest(".slick-slide").data("youtube-player", e.target),
                    setTimeout(function () {
                        t(e.target.getIframe()).closest(".slick-slide").hasClass("slick-active") && (a.slick("slickPause"), e.target.playVideo());
                    }, 200);
            }
            function s(t) {
                t.data === YT.PlayerState.PLAYING && a.slick("slickPause"), t.data === YT.PlayerState.ENDED && a.slick("slickNext");
            }
            function r() {
                i.each((e, a) => {
                    const o = t(a),
                        i = `youtube_player_${Math.floor(100 * Math.random())}`;
                    o.attr("id", i);
                    new YT.Player(i, {
                        host: "http://www.youtube.com",
                        videoId: o.data("youtube"),
                        wmode: "transparent",
                        playerVars: { autoplay: 0, controls: 0, disablekb: 1, enablejsapi: 1, fs: 0, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1, wmode: "transparent" },
                        events: { onReady: n, onStateChange: s },
                    });
                });
            }
            function c() {
                const t = a.find(".slick-slide.slick-active").data("youtube-player");
                t && (t.stopVideo(), a.removeClass("slick-slider--playvideo"));
            }
            function l() {
                const t = a.find(".slick-slide.slick-active").data("youtube-player");
                t && (a.slick("slickPause"), a.addClass("slick-slider--playvideo"), t.playVideo());
            }
            !(function () {
                a.hasClass("slick-initialized") && r();
                o.on("init", a, r), o.on("beforeChange", a, c), o.on("afterChange", a, l);
            })();
        },
        productSizeChart: function (e) {
            window.sizeChart = function () {
                e.find("[data-open-size-chart-popup]").on("click", (e) => {
                    e.preventDefault(),
                        e.stopPropagation(),
                        document.body.classList.add("size-chart-show"),
                        document.body.classList.contains("quick-view-show") ? t(".halo-popup-content .halo-size-chart-popup").addClass("is-show") : t("#MainContent .halo-size-chart-popup").addClass("is-show");
                }),
                    o.on("click", "[data-close-size-chart-popup]", () => {
                        a.removeClass("size-chart-show"), t(".halo-size-chart-popup").removeClass("is-show");
                    }),
                    o.on("click", (e) => {
                        a.hasClass("size-chart-show") && 0 === t(e.target).closest("[data-open-size-chart-popup]").length && 0 === t(e.target).closest("[data-size-chart-popup]").length && a.removeClass("size-chart-show");
                    });
            };
            var i = document.body.classList.contains("quick-view-show"),
                n = t(".halo-productView .productView-sizeChart").length;
            document.body.classList.contains("template-product") ? ((!i && n) || (i && 0 === n)) && window.sizeChart() : window.sizeChart();
        },
        productLastSoldOut: function (t) {
            var e = t.find("[data-sold-out-product]");
            if (e.length > 0) {
                var a = e.data("item").toString().split(","),
                    o = Math.floor(Math.random() * a.length),
                    i = e.data("hours").toString().split(","),
                    n = Math.floor(Math.random() * i.length);
                e.find("[data-sold-out-number]").text(a[o]), e.find("[data-sold-out-hours]").text(i[n]), e.show();
            }
        },
        productCustomerViewing: function (t) {
            var e = t.find("[data-customer-view]");
            if (e.length > 0) {
                var a = e.data("customer-view"),
                    o = JSON.parse("[" + a + "]"),
                    i = e.data("customer-view-time"),
                    n = 1e3 * parseInt(i);
                setInterval(function () {
                    var t = Math.floor(Math.random() * o.length);
                    e.find(".text").text(window.customer_view.text.replace("[number]", o[t]));
                }, n);
            }
        },
        productCountdown: function (t) {
            var e = t.find("[data-countdown-id]"),
                a = e.data("countdown"),
                o = new Date(a).getTime(),
                i = window.countdown.text;
            if (e.length > 0)
                var n = setInterval(function () {
                    var t = new Date().getTime(),
                        a = o - t;
                    if (a < 0) clearInterval(n), e.remove();
                    else {
                        var s,
                            r = Math.floor(a / 864e5),
                            c = Math.floor((a % 864e5) / 36e5),
                            l = Math.floor((a % 36e5) / 6e4),
                            d = Math.floor((a % 6e4) / 1e3);
                        (s = e.is(".style-2, .style-3")
                            ? '<span class="text"><span>' +
                              i +
                              '</span></span><span class="num">' +
                              r +
                              "<span>" +
                              window.countdown.day_2 +
                              '</span></span>                                <span class="num">' +
                              c +
                              "<span>" +
                              window.countdown.hour_2 +
                              '</span></span>                                <span class="num">' +
                              l +
                              "<span>" +
                              window.countdown.min_2 +
                              '</span></span>                                <span class="num">' +
                              d +
                              "<span>" +
                              window.countdown.sec_2 +
                              "</span></span>"
                            : '<span class="text"><span>' +
                              i +
                              '</span></span><span class="num">' +
                              r +
                              "<span>" +
                              window.countdown.day +
                              '</span></span>                                <span class="num">' +
                              c +
                              "<span>" +
                              window.countdown.hour +
                              '</span></span>                                <span class="num">' +
                              l +
                              "<span>" +
                              window.countdown.min +
                              '</span></span>                                <span class="num">' +
                              d +
                              "<span>" +
                              window.countdown.sec +
                              "</span></span>"),
                            e.html(s),
                            e.addClass("show");
                    }
                }, 1e3);
        },
        productCustomCursor: function (e) {
            if (0 == t(".cursor-wrapper").length) return;
            const { Back: a } = window;
            (this.cursorWrapper = document.querySelector(".cursor-wrapper")),
                (this.innerCursor = document.querySelector(".custom-cursor__inner")),
                (this.outerCursor = document.querySelector(".custom-cursor__outer")),
                (this.cursorWrapperBox = this.cursorWrapper.getBoundingClientRect()),
                (this.innerCursorBox = this.innerCursor.getBoundingClientRect()),
                (this.outerCursorBox = this.outerCursor.getBoundingClientRect()),
                document.addEventListener("mousemove", (t) => {
                    (this.clientX = t.clientX), (this.clientY = t.clientY);
                });
            const o = () => {
                TweenMax.set(this.cursorWrapper, { x: this.clientX, y: this.clientY }), requestAnimationFrame(o);
            };
            requestAnimationFrame(o), (this.fullCursorSize = 60), (this.enlargeCursorTween = TweenMax.to(this.outerCursor, 0.3, { width: this.fullCursorSize, height: this.fullCursorSize, ease: this.easing, paused: !0 }));
            const i = () => {
                    this.enlargeCursorTween.play(), t(".cursor-wrapper").addClass("handleMouseEnter").removeClass("handleMouseLeave");
                },
                n = () => {
                    this.enlargeCursorTween.reverse(), t(".cursor-wrapper").addClass("handleMouseLeave").removeClass("handleMouseEnter");
                };
            document.querySelectorAll(".productView-image").forEach((t) => {
                t?.querySelector(".productView-video") || (t.addEventListener("mouseenter", i), t.addEventListener("mouseleave", n));
            }),
                (this.bumpCursorTween = TweenMax.to(this.outerCursor, 0.1, {
                    scale: 0.7,
                    paused: !0,
                    onComplete: () => {
                        TweenMax.to(this.outerCursor, 0.2, { scale: 1, ease: this.easing });
                    },
                })),
                t(document).on("mouseover", "[data-cursor-image]", (e) => {
                    var a = t(e.currentTarget),
                        o = new Array();
                    o.push(a.attr("data-index")), t("#count-image").text(o[0]);
                }),
                (t.fn.isInViewport = function (e) {
                    var a = t(this).offset().top,
                        o = a + t(this).height(),
                        i = t(document).scrollTop(),
                        n = i + t(window).height();
                    if (e) {
                        var s = (o - i) / t(this).height();
                        return o > i && a < n && s > 0.5;
                    }
                    return o > i && a < n;
                }),
                (t(".product-full-width").length > 0 || t(".product-full-width-2").length > 0) &&
                    t(window).on("resize scroll", function () {
                        var e = new Array();
                        t(".productView-image").each(function () {
                            t(this).isInViewport(!0) && (e.push(t(this).attr("data-index")), t("#count-image").text(e[0]));
                        });
                    });
        },
        initWishlist: function () {
            window.wishlist.show &&
                (n.setLocalStorageProductForWishlist(),
                o.on("click", "[data-wishlist]", (e) => {
                    e.preventDefault(), e.stopPropagation(), t(e.currentTarget).hasClass("is-in-grid") || t("[data-wishlist-items-display]").removeClass("is-loaded");
                    var a = t(e.currentTarget),
                        o = a.data("product-id"),
                        i = a.data("wishlist-handle"),
                        s = localStorage.getItem("wishlistItem") ? JSON.parse(localStorage.getItem("wishlistItem")) : [];
                    if (((index = s.indexOf(i)), (wishlistContainer = t("[data-wishlist-container]")), (wishlistLayout = wishlistContainer.attr("data-wishlist-layout")), a.hasClass("wishlist-added"))) {
                        if ((a.removeClass("wishlist-added").find(".text").text(window.wishlist.add), wishlistContainer.length > 0 && t('[data-wishlist-added="wishlist-' + o + '"]').length > 0)) {
                            t('[data-wishlist-added="wishlist-' + o + '"]').remove();
                            t(`[data-wishlist][data-product-id=${o}]`).closest(".product").remove();
                        }
                        s.splice(index, 1), localStorage.setItem("wishlistItem", JSON.stringify(s));
                        const e = new CustomEvent("updatepagination", { bubbles: !0 });
                        if ((document.dispatchEvent(e), wishlistContainer.length > 0))
                            if ((s = localStorage.getItem("wishlistItem") ? JSON.parse(localStorage.getItem("wishlistItem")) : []).length > 0) {
                                const t = new Event("updatewishlistmail", { bubbles: !0 });
                                document.dispatchEvent(t);
                            } else
                                t("[data-wishlist-container]")
                                    .addClass("is-empty")
                                    .html(
                                        `                                    <div class="wishlist-content-empty text-center">                                        <span class="wishlist-content-text">${window.wishlist.empty}</span>                                        <div class="wishlist-content-actions">                                            <a class="button button-2 button-continue" href="${window.routes.collection_all}">                                                ${window.wishlist.continue_shopping}                                            </a>                                        </div>                                    </div>                                `
                                    ),
                                    t("[data-wishlist-footer]").hide();
                    } else {
                        if ((a.addClass("wishlist-added").find(".text").text(window.wishlist.added), wishlistContainer.length > 0)) {
                            const t = new CustomEvent("addwishlistitem", { detail: { handle: i }, bubbles: !0 });
                            document.dispatchEvent(t);
                        }
                        s.push(i), localStorage.setItem("wishlistItem", JSON.stringify(s));
                        const t = new CustomEvent("updatewishlistmail", { bubbles: !0 });
                        document.dispatchEvent(t);
                    }
                    t("[data-wishlist-count]").text(s.length), n.setProductForWishlist(i);
                }));
        },
        calculateCard06Padding() {
            if (!a.hasClass("product-card-layout-06")) return;
            const t = document.querySelector(".card .card-action.card-grid__hidden");
            t.classList.remove("card-grid__hidden");
            const e = t.scrollHeight;
            document.querySelector("[data-wishlist-items-grid-display]").style.setProperty("--card-06-padding", e + "px"), t.classList.add("card-grid__hidden");
        },
        setProductForWishlist: function (e) {
            var a = JSON.parse(localStorage.getItem("wishlistItem")),
                o = t('[data-wishlist-handle="' + e + '"]'),
                i = a?.indexOf(e);
            null != i && null != a && (i >= 0 ? o.addClass("wishlist-added").find(".text").text(window.wishlist.added) : o.removeClass("wishlist-added").find(".text").text(window.wishlist.add));
        },
        setLocalStorageProductForWishlist: function () {
            var e = localStorage.getItem("wishlistItem") ? JSON.parse(localStorage.getItem("wishlistItem")) : [];
            localStorage.setItem("wishlistItem", JSON.stringify(e)),
                e.length > 0 &&
                    (e = JSON.parse(localStorage.getItem("wishlistItem"))).forEach((t) => {
                        n.setProductForWishlist(t);
                    }),
                t("[data-wishlist-count]").text(e.length);
        },
        initCountdown: function () {
            var e = t("[data-countdown-announcement]"),
                a = t("[data-countdown]").not("[data-countdown-id]"),
                o = t("[data-countdown-time]");
            if (
                (e.length &&
                    e.each(function () {
                        var e = t(this),
                            a = e.data("countdown-value"),
                            o = new Date(a).getTime(),
                            i = setInterval(function () {
                                var t = new Date().getTime(),
                                    a = o - t;
                                if (a < 0)
                                    if ((clearInterval(i), e.hasClass("hide--countdown"))) e.remove();
                                    else {
                                        const t = e.parents(".announcement-bar__message"),
                                            a = e.parents("[data-announcement-bar]");
                                        a.is(".slick-initialized") ? a.slick("slickRemove", t.data("slick-index")) : t.remove();
                                    }
                                else {
                                    var n,
                                        s = Math.floor(a / 864e5),
                                        r = `0${Math.floor((a % 864e5) / 36e5)}`.slice(-2),
                                        c = `0${Math.floor((a % 36e5) / 6e4)}`.slice(-2),
                                        l = `0${Math.floor((a % 6e4) / 1e3)}`.slice(-2);
                                    (n =
                                        '<div class="clock-item"><span class="num">' +
                                        s +
                                        '</span><span class="text">' +
                                        window.countdown.days +
                                        '</span></div>                                            <div class="clock-item"><span class="num">' +
                                        r +
                                        '</span><span class="text">' +
                                        window.countdown.hours +
                                        '</span></div>                                            <div class="clock-item"><span class="num">' +
                                        c +
                                        '</span><span class="text">' +
                                        window.countdown.mins +
                                        '</span></div>                                            <div class="clock-item"><span class="num">' +
                                        l +
                                        '</span><span class="text">' +
                                        window.countdown.secs +
                                        "</span></div>"),
                                        e.html(n);
                                }
                            }, 1e3);
                    }),
                a.length &&
                    a.each(function () {
                        var e = t(this),
                            a = e.data("countdown-value"),
                            o = new Date(a).getTime(),
                            i = setInterval(function () {
                                var a = new Date().getTime(),
                                    n = o - a;
                                if (n < 0) clearInterval(i), e.hasClass("hide--countdown") ? e.remove() : e.parents(".shopify-section").remove();
                                else {
                                    var s = Math.floor(n / 864e5),
                                        r = `0${Math.floor((n % 864e5) / 36e5)}`.slice(-2),
                                        c = `0${Math.floor((n % 36e5) / 6e4)}`.slice(-2),
                                        l = `0${Math.floor((n % 6e4) / 1e3)}`.slice(-2),
                                        d = "";
                                    (d = e.hasClass("product-countdown-block")
                                        ? t(".halo-block-header").hasClass("countdown_style_2")
                                            ? '<div class="clock-item"><span class="num">' +
                                              s +
                                              window.countdown.d +
                                              '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' +
                                              r +
                                              window.countdown.h +
                                              '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' +
                                              c +
                                              window.countdown.m +
                                              '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' +
                                              l +
                                              window.countdown.s +
                                              '</span><span class="icon"></span></div>'
                                            : `<div class="clock-item"><span class="num">${s}d&nbsp;</span></div>\n                                    <div class="clock-item"><span class="num">${r}:</span></div>\n                                    <div class="clock-item"><span class="num">${c}:</span></div>\n                                    <div class="clock-item"><span class="num">${l}</span></div>`
                                        : '<div class="clock-item"><span class="num">' +
                                          s +
                                          '</span><span class="text">' +
                                          window.countdown.days +
                                          '</span></div>                                                <div class="clock-item"><span class="num">' +
                                          r +
                                          '</span><span class="text">' +
                                          window.countdown.hours +
                                          '</span></div>                                                <div class="clock-item"><span class="num">' +
                                          c +
                                          '</span><span class="text">' +
                                          window.countdown.mins +
                                          '</span></div>                                                <div class="clock-item"><span class="num">' +
                                          l +
                                          '</span><span class="text">' +
                                          window.countdown.secs +
                                          "</span></div>"),
                                        e.html(d);
                                }
                            }, 1e3);
                    }),
                o.length)
            ) {
                o.each(function () {
                    !(function (e) {
                        const a = t(e),
                            o = new Date(a.data("countdown-time")).getTime(),
                            i = setInterval(function () {
                                const t = new Date().getTime(),
                                    e = o - t;
                                if (e < 0) clearInterval(i), a.remove();
                                else {
                                    const t = Math.floor(e / 864e5),
                                        o = Math.floor((e % 864e5) / 36e5),
                                        i = Math.floor((e % 36e5) / 6e4),
                                        n = Math.floor((e % 6e4) / 1e3),
                                        s = `\n                          <span class="item pos-relative d-inline-block v-a-top left w-auto">\n                            <span class="num dis-i-block">${t}</span>\n                            <span class="dis-block text uppercase">${window.countdown.day}ays</span>\n                          </span>\n                          <span class="item pos-relative d-inline-block v-a-top left w-auto">\n                            <span class="num dis-i-block">${o}</span>\n                            <span class="dis-block text uppercase">${window.countdown.hour}ours</span>\n                          </span>\n                          <span class="item pos-relative d-inline-block v-a-top left w-auto">\n                            <span class="num dis-i-block">${i}</span>\n                            <span class="dis-block text uppercase">${window.countdown.min}ins</span>\n                          </span>\n                          <span class="item pos-relative d-inline-block v-a-top left w-auto">\n                            <span class="num dis-i-block">${n}</span>\n                            <span class="dis-block text uppercase">${window.countdown.sec}econds</span>\n                          </span>`;
                                    a.find(".countdown").html(s), a.parent().removeClass("hidden"), a.find(".countdown").addClass("show");
                                }
                            }, 1e3);
                    })(this);
                });
            }
        },
        collectionCountdown: function () {
            var e = t("[data-collection-countdown]");
            e.length &&
                e.each(function () {
                    var e = t(this),
                        a = (t) => {
                            var e = t.data("collection-countdown-value"),
                                o = new Date(e).getTime(),
                                i = (window.countdown.text, o - new Date().getTime());
                            if (i < 0) clearInterval(a), t.hasClass("hide--countdown") && t.remove();
                            else {
                                var n = Math.floor(i / 864e5),
                                    s = `0${Math.floor((i % 864e5) / 36e5)}`.slice(-2),
                                    r = `0${Math.floor((i % 36e5) / 6e4)}`.slice(-2),
                                    c = `0${Math.floor((i % 6e4) / 1e3)}`.slice(-2),
                                    l = "";
                                t.hasClass("collection-countdown") &&
                                    (l =
                                        '<div class="clock-item"><span class="num">' +
                                        n +
                                        '</span><span class="text">' +
                                        window.countdown.days +
                                        '</span></div>                                                <div class="clock-item"><span class="num">' +
                                        s +
                                        '</span><span class="text">' +
                                        window.countdown.hours +
                                        '</span></div>                                                <div class="clock-item"><span class="num">' +
                                        r +
                                        '</span><span class="text">' +
                                        window.countdown.mins +
                                        '</span></div>                                                <div class="clock-item"><span class="num">' +
                                        c +
                                        '</span><span class="text">' +
                                        window.countdown.secs +
                                        "</span></div>"),
                                    t.html(l);
                            }
                        };
                    setInterval(() => {
                        a(e);
                    }, 1e3);
                });
        },
        handleScrollDown: function () {
            var e = "[data-scroll-down]",
                a = t(e);
            a.each(function () {
                var e = t(this),
                    o = e.closest(".shopify-section").next(".shopify-section").attr("id");
                e.attr("href", "#" + o),
                    a.on("click", function (e) {
                        e.preventDefault();
                        var a = t(this.getAttribute("href"));
                        a.length && t("html, body").stop().animate({ scrollTop: a.offset().top }, 400);
                    });
            });
        },
        toggleSidebarMobile: function () {
            o.on("click", "[data-sidebar]", (t) => {
                t.preventDefault(), t.stopPropagation(), a.addClass("open-mobile-sidebar");
            }),
                o.on("click", "[data-close-sidebar]", (t) => {
                    t.preventDefault(), t.stopPropagation(), a.removeClass("open-mobile-sidebar");
                }),
                o.on("click", (e) => {
                    a.hasClass("open-mobile-sidebar") && 0 === t(e.target).closest("[data-sidebar]").length && 0 === t(e.target).closest("#halo-sidebar").length && a.removeClass("open-mobile-sidebar");
                });
        },
        initBlogMasonry: function () {
            const e = t(".blog-layout-masonry .blog-block-item"),
                o = a.hasClass("layout_rtl");
            e.masonry({ columnWidth: ".blog-grid-sizer", itemSelector: "[data-masonry-item]", isRTL: o, originLeft: !o });
        },
        articleGallery: function () {
            const e = t(".articleGallery-block"),
                a = t(".articleGallery-slider"),
                o = e.length,
                i = a.data("col");
            o > 0 &&
                a.not(".slick-initialized") &&
                a.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: !0,
                    arrows: !0,
                    infinite: !1,
                    mobileFirst: !0,
                    focusOnSelect: !1,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: [
                        { breakpoint: 767, settings: { slidesToShow: i, slidesToScroll: i } },
                        { breakpoint: 319, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                    ],
                });
        },
        initCollapseSidebarBlock: function () {
            o.on("click", ".sidebarBlock-headingWrapper .sidebarBlock-heading", (e) => {
                var a = t(e.currentTarget),
                    o = a.parent().siblings(),
                    i = a.parents(".sidebarBlock");
                a.hasClass("is-clicked") ? (a.removeClass("is-clicked"), o.slideUp("slow")) : (a.addClass("is-clicked"), o.slideDown("slow"), i.hasClass("sidebar-product") && i.find(".products-carousel").slick("refresh"));
            }),
                o.on("click", ".sidebarBlock-headingWrapper-slide .sidebarBlock-heading", (e) => {
                    var a = t(e.currentTarget),
                        o = a.closest(".halo-sidebar-wrapper"),
                        i = a.parent().siblings(),
                        n = i.find(".sidebarBlock-slide__content-close"),
                        s = a.parents(".sidebarBlock");
                    i.toggleClass("is-show"),
                        o.toggleClass("disable-scroll"),
                        s.toggleClass("has-slide"),
                        n.on("click", function () {
                            i.removeClass("is-show"), o.removeClass("disable-scroll"), s.removeClass("has-slide");
                        });
                });
        },
        initCategoryActive: function () {
            t(".all-categories-list").length > 0 &&
                (o.on("click", ".all-categories-list .icon-dropdown", (e) => {
                    var a = t(e.currentTarget).parent();
                    a.siblings().removeClass("is-clicked current-cate"), a.toggleClass("is-clicked"), a.siblings().find("> .dropdown-category-list").slideUp("slow"), a.find("> .dropdown-category-list").slideToggle("slow");
                }),
                t(".all-categories-list li").each((e, a) => {
                    t(a).hasClass("current-cate") && t(a).find("> .dropdown-category-list").slideToggle("slow"), t(a).hasClass("is-clicked") && (t(a).closest(".navPages-item").addClass("is-clicked"), t(a).parent().slideDown("slow"));
                }));
        },
        productBlockSilderSidebar: function () {
            var e = t("[data-product-slider-sidebar]"),
                a = e.data("item-to-show"),
                o = e.data("item-dots"),
                i = e.data("item-arrows");
            e.length > 0 &&
                e.not(".slick-initialized") &&
                e.slick({
                    mobileFirst: !0,
                    adaptiveHeight: !0,
                    vertical: !1,
                    infinite: !1,
                    slidesToShow: a,
                    slidesToScroll: 1,
                    arrows: i,
                    dots: o,
                    autoplay: !0,
                    autoplaySpeed: 2e3,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                }),
                t("body").hasClass("cursor-fixed__show") && (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton());
        },
        productBlockSilderArticle: function () {
            var e = t("[data-product-slider-article]"),
                a = e.data("item-to-show"),
                o = e.data("item-dots"),
                i = e.data("item-arrows");
            e.length > 0 &&
                e.not(".slick-initialized") &&
                e.slick({
                    adaptiveHeight: !0,
                    vertical: !1,
                    infinite: !1,
                    slidesToShow: a,
                    slidesToScroll: 1,
                    arrows: i,
                    dots: o,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: [
                        { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                        { breakpoint: 551, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                    ],
                });
        },
        articleGallery: function () {
            const e = t(".articleGallery-block"),
                a = t(".articleGallery-slider"),
                o = e.length,
                i = a.data("col");
            o > 0 &&
                a.not(".slick-initialized") &&
                a.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: !0,
                    arrows: !0,
                    infinite: !1,
                    mobileFirst: !0,
                    focusOnSelect: !1,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: [
                        { breakpoint: 767, settings: { slidesToShow: i, slidesToScroll: i } },
                        { breakpoint: 319, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                    ],
                });
        },
        initInfiniteScrolling: function () {
            t(!0) &&
                i.on("scroll load", () => {
                    var e = i.scrollTop(),
                        a = t(".pagination-infinite"),
                        o = a.find("[data-infinite-scrolling]");
                    if (o.length > 0 && !o.hasClass("is-loading") && e > a.offset().top - 500) {
                        var s = o.attr("href");
                        n.doAjaxInfiniteScrollingGetContent(s, o);
                    }
                }),
                o.on("click", "[data-infinite-scrolling]", (e) => {
                    var a = t(e.currentTarget),
                        o = a.attr("href");
                    e.preventDefault(), e.stopPropagation(), n.doAjaxInfiniteScrollingGetContent(o, a);
                });
        },
        doAjaxInfiniteScrollingGetContent: function (e, a) {
            t.ajax({
                type: "GET",
                url: e,
                beforeSend: function () {
                    a.text(a.attr("data-loading-more")), a.addClass("is-loading");
                },
                success: function (t) {
                    n.ajaxInfiniteScrollingMapData(t);
                },
                error: function (e, a) {
                    alert(t.parseJSON(e.responseText).description);
                },
                complete: function () {
                    a.text(a.attr("data-load-more")), a.removeClass("is-loading"), document.querySelector(".collection-masonry") && resizeAllGridItems();
                },
            });
        },
        ajaxInfiniteScrollingMapData: function (e) {
            var a = t("#CollectionProductGrid"),
                o = a.find(".productListing"),
                i = a.find(".pagination"),
                s = t(e).find("#CollectionProductGrid"),
                r = s.find(".productListing"),
                c = s.find(".pagination"),
                l = r.children(".product");
            if (l.length > 0) {
                if ((o.append(l), i.replaceWith(c), t("[data-total-start]").text(1), window.compare.show)) {
                    var d = t("[data-compare-link]");
                    n.setLocalStorageProductForCompare(d);
                }
                window.wishlist.show && n.setLocalStorageProductForWishlist(), n.checkNeedToConvertCurrency() && Currency.convertAll(window.shop_currency, t("#currencies .active").attr("data-currency"), "span.money", "money_format");
            }
        },
        initQuickShopProductList: function () {
            o.on("click", "[data-open-quickshop-popup-list]", (e) => {
                e.preventDefault(), e.stopPropagation();
                var a = t(e.currentTarget).data("product-handle"),
                    o = t(e.currentTarget).closest(".card");
                o.hasClass("quick-shop-show") || n.updateContentQuickShop(o, a);
            }),
                o.on("click", "[data-close-quickshop-popup-list]", (e) => {
                    e.preventDefault(), e.stopPropagation();
                    var a = t(e.currentTarget).closest(".card");
                    a.removeClass("quick-shop-show"), a.find(".card-popup-content").empty();
                }),
                o.on("click", (e) => {
                    t(".card").hasClass("quick-shop-show") &&
                        0 === t(e.target).closest("[data-open-quickshop-popup-list]").length &&
                        0 === t(e.target).closest(".card-popup").length &&
                        (t(".card").removeClass("quick-shop-show"), t(".card").find(".card-popup-content").empty());
                });
        },
        updateContentQuickShop: function (e, a) {
            var o = e.find(".card-popup").find(".card-popup-content");
            t.ajax({
                type: "get",
                url: window.routes.root + "/products/" + a + "?view=ajax_quick_shop",
                beforeSend: function () {
                    t(".card").removeClass("quick-shop-show");
                },
                success: function (t) {
                    o.append(t);
                },
                error: function (e, a) {
                    alert(t.parseJSON(e.responseText).description);
                },
                complete: function () {
                    e.addClass("quick-shop-show");
                },
            });
        },
        toggleVariantsForExpressOrder: function () {
            t(document).on("click", "[data-toggle-variant]", function (e) {
                e.preventDefault(), e.stopPropagation();
                var a = t(this),
                    o = a.data("target");
                a.hasClass("show-options-btn")
                    ? (a.text(window.inventory_text.hide_options),
                      t(o).slideDown(700, function () {
                          a.addClass("hide-options-btn").removeClass("show-options-btn");
                      }))
                    : (a.text(window.inventory_text.show_options),
                      t(o).slideUp(700, function () {
                          a.addClass("show-options-btn").removeClass("hide-options-btn");
                      }));
            });
        },
        initExpressOrderAddToCart: function () {
            var e = "[data-express-addtocart]";
            t(document)
                .off("click.addToCartExpress", e)
                .on("click.addToCartExpress", e, function (e) {
                    e.preventDefault();
                    var a = t(this);
                    if ("disabled" != a.attr("disabled")) {
                        var o = a.closest(".product-item");
                        0 == o.length && (o = a.closest(".col-options"));
                        var i = o.find("form"),
                            s = i.find("select[name=id]").val();
                        s || (s = i.find("input[name=id]").val());
                        var r = o.find("input[name=quantity]");
                        0 == r.length && (r = o.siblings(".col-qtt").find("input[name=quantity]"));
                        var c = r.val();
                        c || (c = 1), 0 !== parseInt(c) ? ("none" == window.ajax_cart ? i.submit() : (n.expressAjaxAddToCart(s, c, a, i), i.next(".feedback-text").show())) : i.next(".feedback-text").text("Quantity cannot be blank").show();
                    }
                    return !1;
                });
        },
        expressAjaxAddToCart: function (e, o, i, s) {
            t.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + o + "&id=" + e,
                dataType: "json",
                beforeSend: function () {
                    window.setTimeout(function () {
                        i.text(window.inventory_text.adding + "...");
                    }, 100);
                },
                success: function (t) {
                    switch (
                        (window.setTimeout(function () {
                            i.text(window.inventory_text.thank_you), i.addClass("add_more"), s.next(".feedback-text").text(window.inventory_text.cart_feedback).addClass("is-added");
                        }, 600),
                        window.setTimeout(function () {
                            i.text(window.inventory_text.add_more + "...");
                        }, 1e3),
                        window.after_add_to_cart.type)
                    ) {
                        case "cart":
                            n.redirectTo(window.routes.cart);
                            break;
                        case "quick_cart":
                            window.quick_cart.show
                                ? Shopify.getCart((t) => {
                                      "popup" == window.quick_cart.type || (a.addClass("cart-sidebar-show"), n.updateSidebarCart(t));
                                  })
                                : n.redirectTo(window.routes.cart);
                            break;
                        case "popup_cart_1":
                            Shopify.getCart((t) => {
                                n.updatePopupCart(t, 1, e), n.updateSidebarCart(t), a.addClass("add-to-cart-show");
                            });
                    }
                },
                error: function (e, a) {
                    alert(t.parseJSON(e.responseText).description),
                        window.setTimeout(function () {
                            i.text(window.inventory_text.add_to_cart);
                        }, 400);
                },
            });
        },
        initProductBundle: function () {
            var e = t("[data-product-bundle]"),
                a = e.find("[data-bundle-slider]"),
                o = a.data("dots"),
                i = a.data("arrows");
            a.length > 0 &&
                (a.hasClass("slick-initialized") ||
                    (a.slick({
                        dots: !0,
                        arrows: i,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        mobileFirst: !0,
                        infinite: !1,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 1, dots: o } },
                            { breakpoint: 551, settings: { slidesToShow: 3, slidesToScroll: 1, dots: o } },
                        ],
                    }),
                    e.find(".bundle-product-wrapper").removeClass("has-halo-block-loader"),
                    a.on("afterChange", function () {
                        a.find(".bundle-product-item").removeClass("is-open");
                    })));
        },
        initDynamicBrowserTabTitle: function () {
            if (window.dynamic_browser_title.show) {
                var t = document.title;
                window.dynamic_browser_title.text;
                (window.onblur = function () {
                    document.title = window.dynamic_browser_title.text;
                }),
                    (window.onfocus = function () {
                        document.title = t;
                    });
            }
        },
        initWarningPopup: function () {
            (this.warningPopup = document.querySelector("[data-warning-popup]")),
                (this.warningPopupContent = this.warningPopup.querySelector("[data-halo-warning-content]")),
                (this.warningPopupCloseButton = this.warningPopup.querySelector("[data-close-warning-popup]")),
                this.warningPopupCloseButton.addEventListener("click", () => {
                    document.body.classList.remove("has-warning");
                }),
                document.body.addEventListener("click", () => {
                    event.target.closest("[data-warning-popup]") || document.body.classList.remove("has-warning");
                }),
                (this.warningTime = 3e3),
                (this.warningTimeout = void 0),
                (window.warningTimeout = this.warningTimeout);
        },
        showWarning: function (t, e = this.warningTime) {
            this.warningTimeout && clearTimeout(this.warningTimeout),
                (this.warningPopupContent.textContent = t),
                document.body.classList.add("has-warning"),
                e &&
                    (this.warningTimeout = setTimeout(() => {
                        document.body.classList.remove("has-warning");
                    }, e));
        },
        backgroundOverlayHoverEffect: function () {
            const t = document.querySelector(".background-overlay"),
                e = t.firstChild,
                a = () => {
                    e.classList.remove("enlarge-cursor");
                },
                o = (t, a) => {
                    requestAnimationFrame(() => {
                        e.style.setProperty("--translate-y", a), e.style.setProperty("--translate-x", t);
                    });
                },
                i = (t) => {
                    o(t.clientX, t.clientY);
                };
            t.addEventListener("mouseenter", (t) => {
                o(t.clientX, t.clientY), e.classList.add("enlarge-cursor");
            }),
                t.addEventListener("mouseleave", (t) => {
                    o(t.clientX, t.clientY), e.removeEventListener("mousemove", i), a();
                }),
                t.addEventListener("mousemove", i),
                t.addEventListener("click", a);
        },
        backgroundOverlayHoverEffect1: function () {
            const t = document.querySelector(".background-overlay1");
            if (!t) return;
            const e = t.firstChild,
                a = () => {
                    e.classList.remove("enlarge-cursor");
                },
                o = (t, a) => {
                    requestAnimationFrame(() => {
                        e.style.setProperty("--translate-y", a), e.style.setProperty("--translate-x", t);
                    });
                },
                i = (t) => {
                    o(t.clientX, t.clientY);
                };
            t.addEventListener("mouseenter", (t) => {
                o(t.clientX, t.clientY), e.classList.add("enlarge-cursor");
            }),
                t.addEventListener("mouseleave", (t) => {
                    o(t.clientX, t.clientY), e.removeEventListener("mousemove", i), a();
                }),
                t.addEventListener("mousemove", i),
                t.addEventListener("click", a);
        },
        productCustomInformation() {
            const e = t("[data-custom-information]"),
                i = t("#halo-product-custom-information");
            e.on("click", (e) => {
                const o = t(e.currentTarget),
                    n = o.find(".title")[0].innerText,
                    s = o.find(".product-customInformation__popup").html();
                "" !== s && null != s && (i.addClass("is-show"), i.find(".halo-popup-title").text(n), i.find(".halo-popup-content").html(s), a.addClass("is-custom-information"));
            }),
                o.on("click", "[data-close-custom-information]", () => {
                    a.removeClass("is-custom-information"), i.removeClass("is-show");
                }),
                o.on("click", (e) => {
                    a.hasClass("is-custom-information") && 0 === t(e.target).closest("#halo-product-custom-information").length && 0 === t(e.target).closest("[data-custom-information]").length && a.removeClass("is-custom-information");
                });
        },
        initLazyloadObserver(t, e) {
            const a = (t) => {
                t.closest(".card").classList.add("ajax-loaded");
            };
            this.lazyloadedObserver = new MutationObserver((t, e) => {
                t.forEach((t) => {
                    if ("attributes" == t.type) {
                        if (!t.target.classList.contains("lazyloaded")) return;
                        a(t.target);
                    }
                });
            });
            const o = new MutationObserver((t) => {
                t.forEach((t) => {
                    if ("childList" == t.type) {
                        [...t.addedNodes]
                            .map((t) => t.querySelector(".media--loading-effect img"))
                            .forEach((t) => {
                                t && this.lazyloadedObserver.observe(t, { childList: !0, attributes: !0 });
                            });
                    }
                });
            });
            e && o.observe(e, { subtree: !1, childList: !0 }),
                t.length > 0 &&
                    t.forEach((t) => {
                        t.classList.contains("lazyloaded") ? a(t) : this.lazyloadedObserver.observe(t, { childList: !0, attributes: !0 });
                    });
        },
        observeImageLazyloaded(t) {
            t.forEach((t) => {
                this.lazyloadedObserver.observe(t, { childList: !0, attributes: !0 });
            });
        },
        iconZoomClickMobile() {
            t(".productView-iconZoom").on("click", (t) => {
                document.querySelector(".productView-image .productView-img-container .media").click();
            });
        },
        calculateTranslateYHeight() {
            const t = document.querySelectorAll(".card .card-action:not(.variants-popup-form)");
            let e = 0;
            t.length &&
                (t.forEach((t) => {
                    t.classList.add("temporary-show");
                    const a = t.clientHeight;
                    a > e && (e = a), t.classList.remove("temporary-show");
                }),
                document.body.style.setProperty("--translate-y-height", -1 * e + "px"));
        },
        checkScrollLayoutForRecenlyViewed() {
            const t = document.getElementById("recently-viewed-products-list-2");
            if (t && t.classList.contains("products-flex")) {
                const e = new MutationObserver((t, e) => {
                    const a = t[0];
                    "attributes" == a.type && a.target.classList.contains("recently-viewed-loaded") && e.disconnect();
                });
                e.observe(t, { attributes: !0 });
            }
        },
        clickIconScrollSection() {
            if (!document.querySelector(".arrow-icon-scroll")) return;
            let e = "next";
            const a = document.querySelectorAll(".wrapper-body .shopify-section"),
                i = a.length,
                n = a[0]?.getBoundingClientRect().height || 0,
                s = a[i - 1]?.getBoundingClientRect().height || 0,
                r = document.querySelectorAll(".shopify-section-group-footer-group")[0]?.getBoundingClientRect().height || 0;
            function c(t, e) {
                window.scrollTo({ top: t, behavior: "smooth" });
            }
            function l(t) {
                (e = t), "next" == t ? document.querySelector(".arrow-icon-scroll").classList.remove("rotate") : document.querySelector(".arrow-icon-scroll").classList.add("rotate");
            }
            window.pageYOffset + s >= document.documentElement.scrollHeight - r && l("prev"),
                t(window).scroll(function () {
                    window.pageYOffset + s >= document.documentElement.scrollHeight - r ? l("prev") : window.pageYOffset <= n / 2 && l("next");
                }),
                o.on("click", ".arrow-icon-scroll", (t) => {
                    let o = !0;
                    const n = window.innerWidth > 1024 ? document.querySelectorAll("sticky-header")[0]?.getBoundingClientRect().height : document.querySelector("sticky-header-mobile")?.getBoundingClientRect().height || 0,
                        s = document.querySelectorAll(".shopify-section-group-footer-group")[0]?.getBoundingClientRect().top || -1;
                    a.forEach((t, r) => {
                        if (!o) return;
                        t.getBoundingClientRect().top >= 0
                            ? ((o = !1),
                              "next" == e
                                  ? (null != t.nextElementSibling && c(t.nextElementSibling.offsetTop - n), i == r + 2 || null == t.nextElementSibling ? l("prev") : l("next"))
                                  : (null != t.previousElementSibling && c(t.previousElementSibling.offsetTop - n), 1 == r || null == t.previousElementSibling ? l("next") : l("prev")))
                            : s >= 0 && c(a[i - 1].offsetTop - n);
                    });
                });
        },
        specialBanner() {
            const t = document.querySelectorAll("[sticky-special-banner]"),
                e = window.innerWidth,
                a = window.innerHeight,
                o = e > 1024 ? document.querySelectorAll("sticky-header")[0]?.getBoundingClientRect().height : document.querySelector("sticky-header-mobile")?.getBoundingClientRect().height || 0;
            function i(t, e) {
                t.classList.add("is-sticky"), (t.style.top = `${e}px`);
            }
            t &&
                t.forEach((t) => {
                    const n = t.querySelector(".special-banner__img_box"),
                        s = t.querySelector(".special-banner__img"),
                        r = t.closest(".special-banner__wrapper").getBoundingClientRect().height,
                        c = s.getBoundingClientRect().height;
                    let l = o || 0;
                    e >= 1200 ? r > c && (a > c && (l = (a - c) / 2), i(n, l)) : e >= 768 && e < 1200 ? r > c && i(n, l) : (t.classList.remove("is-sticky"), (t.style.top = ""));
                });
        },
        specialBannerSlider() {
            const e = t(".special-banner__products--grid"),
                a = window.innerWidth;
            e &&
                e.each(function (e, o) {
                    const i = t(o),
                        n = i.closest(".special-banner__product");
                    n.hasClass("ajax-loaded") &&
                        (a < 1200
                            ? i.hasClass("slick-initialized") ||
                              (i.addClass("products-carousel"),
                              (function (t) {
                                  let e = t.find(".products-carousel"),
                                      a = e.data("item-to-show"),
                                      o = e.data("item-dots"),
                                      i = e.data("item-dots-mb"),
                                      n = e.data("item-arrows"),
                                      s = e.data("item-arrows-mb");
                                  e.slick({
                                      mobileFirst: !0,
                                      adaptiveHeight: !0,
                                      infinite: !0,
                                      slidesToShow: 2,
                                      slidesToScroll: 2,
                                      arrows: s,
                                      dots: i,
                                      nextArrow: window.arrows.icon_next,
                                      prevArrow: window.arrows.icon_prev,
                                      rtl: window.rtl_slick,
                                      responsive: [{ breakpoint: 767, settings: { arrows: n, dots: o, slidesToShow: a, slidesToScroll: a } }],
                                  });
                              })(n))
                            : i.hasClass("slick-initialized") && (i.slick("unslick"), i.removeClass("products-carousel")));
                });
        },
        unsymmetricalSlider() {
            const e = t(".unsymmetrical-slider"),
                a = t(window).width();
            if (e) {
                e.each(function (e, o) {
                    const i = t(o),
                        n = i.closest(".halo-block-content");
                    n.hasClass("ajax-loaded") &&
                        (a < 1200
                            ? i.hasClass("slick-initialized") ||
                              (i.addClass("products-carousel"),
                              setTimeout(() => {
                                  !(function (t) {
                                      let e = t.find(".products-carousel"),
                                          o = e.data("item-to-show"),
                                          i = e.data("item-dots"),
                                          n = e.data("item-arrows");
                                      if (e.hasClass("enable_progress_bar")) {
                                          var s = t.find(".scrollbar-thumb");
                                          e.on("init", (t, e) => {
                                              var a = (e.currentSlide / (e.slideCount - 1)) * 100 + "%";
                                              s.css("--percent", a);
                                          });
                                      }
                                      e.slick({
                                          mobileFirst: !0,
                                          adaptiveHeight: !0,
                                          infinite: !0,
                                          slidesToShow: 1.5,
                                          slidesToScroll: 1,
                                          arrows: n,
                                          nextArrow: window.arrows.icon_next,
                                          prevArrow: window.arrows.icon_prev,
                                          rtl: window.rtl_slick,
                                          dots: i,
                                          get initialSlide() {
                                              return (this.initialSlide = 0.5);
                                          },
                                          responsive: [
                                              {
                                                  breakpoint: 767,
                                                  settings: {
                                                      arrows: n,
                                                      slidesToShow: o,
                                                      dots: i,
                                                      slidesToScroll: o,
                                                      get slidesToScroll() {
                                                          return (this.slidesToScroll = null != o && "" !== o && 1.5 !== o && 2.5 !== o && 3.5 !== o ? o : 1);
                                                      },
                                                      get initialSlide() {
                                                          return (this.initialSlide = (1.5 !== o && 2.5 == o) || 3.5 == o ? 0.5 : 0);
                                                      },
                                                  },
                                              },
                                          ],
                                      }),
                                          e.hasClass("enable_progress_bar") &&
                                              e.on("afterChange", (t, e, i) => {
                                                  let n = 0;
                                                  n = a > 767 ? (1.5 == o || 2.5 == o || 3.5 == o ? 0.5 : 0) : 0.5;
                                                  var r = ((i - n) / (e.slideCount - 1)) * 100 + "%";
                                                  s.css("--percent", r);
                                              });
                                  })(n);
                              }, 1e3))
                            : i.hasClass("slick-initialized") && (i.slick("unslick"), i.removeClass("products-carousel")));
                });
            }
        },
        productCountdownCard: function () {
            var e = t(".card .card-countDown").find("[data-countdown-id]"),
                a = e.data("countdown"),
                o = new Date(a).getTime(),
                i = window.countdown.text;
            if (e.length > 0)
                var n = setInterval(function () {
                    var t = new Date().getTime(),
                        a = o - t;
                    if (a < 0) clearInterval(n), e.remove();
                    else {
                        var s,
                            r = Math.floor(a / 864e5),
                            c = Math.floor((a % 864e5) / 36e5),
                            l = Math.floor((a % 36e5) / 6e4),
                            d = Math.floor((a % 6e4) / 1e3);
                        (s =
                            '<span class="text"><span>' +
                            i +
                            '</span></span><span class="num">' +
                            r +
                            "<span>" +
                            window.countdown.day +
                            '</span></span>                                <span class="num">' +
                            c +
                            '<span class="icon">:</span></span>                                <span class="num">' +
                            l +
                            '<span class="icon">:</span></span>                                <span class="num">' +
                            d +
                            "</span>"),
                            e.html(s),
                            e.addClass("show");
                    }
                }, 1e3);
        },
        typingAnimation() {
            t.fn.textType = function (a, o) {
                return this.each(function () {
                    var i = t(this);
                    new e(i, a, o);
                });
            };
            var e = function (e, a, o) {
                (this.rotate = a), (this.$element = t(e)), (this.loopNum = 0), (this.period = parseInt(o, 10) || 2e3), (this.text = ""), this.tick(), (this.isDeleting = !1);
            };
            (e.prototype.tick = function () {
                var t = this.loopNum % this.rotate.length,
                    e = this.rotate[t];
                this.isDeleting ? (this.text = e.substring(0, this.text.length - 1)) : (this.text = e.substring(0, this.text.length + 1)), this.$element.find("[data-text-convert]").html(`<span class="text">${this.text}</span>`);
                var a = this,
                    o = 200 - 100 * Math.random();
                this.isDeleting && (o /= 2),
                    this.isDeleting || this.text !== e ? this.isDeleting && "" === this.text && ((this.isDeleting = !1), this.loopNum++, (o = 500)) : ((o = this.period), (this.isDeleting = !0)),
                    setTimeout(function () {
                        a.tick();
                    }, o);
            }),
                t("type-writer").length &&
                    t("type-writer").each(function (a, o) {
                        const i = t(this).attr("data-type"),
                            n = t(this).attr("data-period");
                        i && new e(t(this), JSON.parse(i), n);
                    });
        },
        spotlightproductSlider: function () {
            var e = t("[data-spotlight-product]");
            !e.length > 0 ||
                (e.each((e, a) => {
                    var o = t(a).find(".spotlight-products__products--slider"),
                        i = o.data("item-dots"),
                        n = o.data("item-dots-mb"),
                        s = o.data("item-arrows"),
                        r = o.data("item-arrows-mb");
                    o.length > 0 &&
                        (o.hasClass("slick-initialized") ||
                            (o.slick({
                                mobileFirst: !0,
                                adaptiveHeight: !1,
                                infinite: !1,
                                vertical: !1,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: n,
                                arrows: r,
                                nextArrow: window.arrows.icon_next,
                                prevArrow: window.arrows.icon_prev,
                                rtl: window.rtl_slick,
                                focusOnSelect: !0,
                                responsive: [{ breakpoint: 1025, settings: { dots: i, arrows: s } }],
                            }),
                            o.on("beforeChange", function (e, a, o, i) {
                                const n = t(e.target).parents(".spotlight-products");
                                n.find(".point-button").removeClass("active"), n.find(`[data-slide="${i + 1}"]`).addClass("active");
                            })));
                }),
                t(".spotlight-products__product_point .point-button").click(function (e) {
                    e.preventDefault();
                    const a = t(this);
                    a.parents(".spotlight-products")
                        .find(".spotlight-products__products--slider")
                        .slick("slickGoTo", a.data("slide") - 1);
                }));
        },
        activeCheckboxStickyCartMobile: function () {
            if (t(".enable_sticky_buttton").length) {
                var e = t(".button-disable"),
                    a = t(".sticky_button_checkout_mb"),
                    o = t(".halo-sticky-toolbar-mobile"),
                    i = o.outerHeight();
                e.on("click", function () {
                    a.addClass("active");
                }),
                    o.length > 0 ? a.css("bottom", i) : a.css("bottom", "0px");
            }
        },
    };
})(jQuery);
// const observer = new MutationObserver((t) => {
//     t.forEach((t) => {
//         t.addedNodes.forEach((t) => {
//             if (t.nodeType === Node.ELEMENT_NODE) {
//                 if (t.matches('.kitenzo-component[data-component="StepName"]') || t.matches('.kitenzo-component[data-component="DynamicStepper"]')) {
//                     attachClickListener(t);
//                     checkAndInitializeSwipers();
//                 } else {
//                     t.querySelectorAll('.kitenzo-component[data-component="StepName"], .kitenzo-component[data-component="DynamicStepper"]').forEach((t) => {
//                         attachClickListener(t);
//                         checkAndInitializeSwipers();
//                     });
//                 }
//             }
//         });
//     });
// });
// observer.observe(document.body, { childList: !0, subtree: !0, characterData: !0, attributes: !0 });
// const attachClickListener = (t) => {
//     t.addEventListener("click", () => {
//         const e = document.querySelectorAll('.kitenzo-component[data-component="GridListSwitch"]'),
//             a = t.closest(".kitenzo-stepper-item");
//         if (a) {
//             const t = a.querySelector('.kitenzo-component[data-component="GridListSwitch"]');
//             if (t) {
//                 const a = -120,
//                     o = t.getBoundingClientRect().top + window.pageYOffset + a;
//                 t.style.maxHeight && "0px" !== t.style.maxHeight
//                     ? ((t.style.maxHeight = "0px"),
//                       e.forEach((t) => {
//                           t.style.maxHeight = "0px";
//                       }))
//                     : ((t.style.maxHeight = `${t.scrollHeight}px`), window.scrollTo({ top: o, behavior: "smooth" }));
//             } else console.log("GridListSwitch element not found");
//         }
//     });
// };

// const stepperObserver = new MutationObserver((t) => {
//     t.forEach((t) => {
//         t.addedNodes.forEach((t) => {
//             if (t.nodeType === Node.ELEMENT_NODE && t.getAttribute("data-component") === "DynamicStepper") {
//                 prependDynamicStepper(t);
//                 console.log("DynamicStepper matched and processed.");
//             } else {
//                 // console.log("DynamicStepper not matched.");
//             }
//         });
//     });
// });
// stepperObserver.observe(document.body, { childList: !0, subtree: !0, characterData: !0, attributes: !0 });

// const prependDynamicStepper = (element) => {
//     if (!element.closest(".kitenzo-stepper-item").querySelector(".Container-module__kitenzo-container-component")) {
//         console.log("checkingggg");
//         const dynamicStepper = document.createElement("div");
//         dynamicStepper.classList.add("kitenzo-component");
//         dynamicStepper.setAttribute("data-component", "DynamicStepper");
//         dynamicStepper.innerHTML = "<h2 class='custom-heading'>Select the category below</h2>";
//         element.closest(".kitenzo-stepper-item").prepend(dynamicStepper);
//     }
// };

function checkAndInitializeSwipers() {
    window.innerWidth <= 768 && initializeSwipers();
}
function initializeSwipers() {
    document.querySelectorAll(".TemplateList-module__template-list-container").forEach((t) => {
        if (!t.classList.contains("swiper-initialized")) {
            const e = document.createElement("div");
            for (e.classList.add("swiper-wrapper"); t.firstChild; ) {
                const a = document.createElement("div");
                a.classList.add("swiper-slide"), a.appendChild(t.firstChild), e.appendChild(a);
            }
            const a = document.createElement("div");
            a.classList.add("swiper-container"), a.appendChild(e), t.appendChild(a);
            const o = document.createElement("div");
            o.classList.add("swiper-button-next"), a.appendChild(o);
            const i = document.createElement("div");
            i.classList.add("swiper-button-prev"), a.appendChild(i);
            const n = document.createElement("div");
            n.classList.add("swiper-pagination"),
                a.appendChild(n),
                new Swiper(a, { loop: !0, slidesPerView: 1, spaceBetween: 10, navigation: { nextEl: o, prevEl: i }, pagination: { el: n, clickable: !0 } }),
                t.classList.add("swiper-initialized");
        }
    });
}
document.addEventListener("DOMContentLoaded", function () {
    const t = document.getElementById("quantity"),
        e = document.getElementById("increase-quantity"),
        a = document.getElementById("decrease-quantity");
    if (!t || !e || !a) return;
    const o = parseInt(t.getAttribute("min")),
        i = parseInt(t.getAttribute("max"));
    function n() {
        let n = parseInt(t.value);
        (e.disabled = n >= i), (a.disabled = n <= o);
    }
    t.addEventListener("input", function () {
        let t = parseInt(this.value);
        isNaN(t) || t < o ? (this.value = o) : t > i && (this.value = i), n();
    }),
        e.addEventListener("click", function () {
            let e = parseInt(t.value);
            e < i && (t.value = e + 1), n();
        }),
        a.addEventListener("click", function () {
            let e = parseInt(t.value);
            e > o && (t.value = e - 1), n();
        }),
        n();
}),
    document.addEventListener("DOMContentLoaded", function () {
        checkAndInitializeSwipers(), window.addEventListener("resize", checkAndInitializeSwipers);
    });
let mobile = 0;
const discountObserver = new MutationObserver((t) => {
        t.forEach((t) => {
            ("childList" !== t.type && "characterData" !== t.type && "attributes" !== t.type) || calculateTotal(mobile),
                t.removedNodes.forEach((t) => {
                    t.nodeType === Node.ELEMENT_NODE && t.matches(".SidebarKitSummary-module__pricing-row.SidebarKitSummary-module__discount-pricing-row") && ((mobile = 0), removeTotalDiv(mobile)),
                        t.nodeType === Node.ELEMENT_NODE && t.matches(".SidebarKitSummary-module__footer-pricing-row.SidebarKitSummary-module__discount-pricing-row") && ((mobile = 1), removeTotalDiv(mobile));
                });
        });
    }),
    documentObserver = new MutationObserver((t) => {
        t.forEach((t) => {
            t.addedNodes.forEach((t) => {
                t.nodeType === Node.ELEMENT_NODE &&
                    t.matches(".SidebarKitSummary-module__pricing-row.SidebarKitSummary-module__discount-pricing-row") &&
                    (discountObserver.observe(t, { childList: !0, subtree: !0, characterData: !0, attributes: !0 }), (mobile = 0), calculateTotal(mobile)),
                    t.nodeType === Node.ELEMENT_NODE &&
                        t.matches(".SidebarKitSummary-module__footer-pricing-row.SidebarKitSummary-module__discount-pricing-row") &&
                        (discountObserver.observe(t, { childList: !0, subtree: !0, characterData: !0, attributes: !0 }), (mobile = 1), calculateTotal(mobile));
            }),
                t.removedNodes.forEach((t) => {
                    t.nodeType === Node.ELEMENT_NODE && t.matches(".SidebarKitSummary-module__pricing-row.SidebarKitSummary-module__discount-pricing-row") && ((mobile = 0), removeTotalDiv(mobile)),
                        t.nodeType === Node.ELEMENT_NODE && t.matches(".SidebarKitSummary-module__footer-pricing-row.SidebarKitSummary-module__discount-pricing-row") && ((mobile = 1), removeTotalDiv(mobile));
                });
        });
    });
function calculateTotal(t) {
    let e, a;
    if (
        (t && 1 == t
            ? ((e = document.querySelector(".SidebarKitSummary-module__footer-pricing-row.SidebarKitSummary-module__discount-pricing-row .money")),
              (a = document.querySelector(".SidebarKitSummary-module__footer-pricing-row.SidebarKitSummary-module__subtotal-pricing-row .money")))
            : ((e = document.querySelector(".SidebarKitSummary-module__pricing-row.SidebarKitSummary-module__discount-pricing-row .money")),
              (a = document.querySelector(".SidebarKitSummary-module__pricing-row.SidebarKitSummary-module__subtotal-pricing-row .money"))),
        e && a)
    ) {
        var o = e.textContent.replace(/[^\d]/g, ""),
            i = a.textContent.replace(/[^\d]/g, ""),
            n = parseInt(o, 10),
            s = parseInt(i, 10);
        n = Math.floor(n / 100);
        var r = (s = Math.floor(s / 100)) + n;
        if (t && 1 == t) {
            let t = document.getElementById("total-mobile");
            if (t) {
                t.querySelector("#total-mobile-price").textContent = `Rs.${r.toFixed(2)}`;
            } else {
                (t = document.createElement("div")),
                    (t.id = "total-mobile"),
                    (t.className = ".KitPrice-module__kitenzo-kitprice"),
                    (t.innerHTML = `\n              <span class="money-total" id="total-mobile-price" style="font-size: 20px; text-decoration: line-through;">Rs.${r.toFixed(2)}</span>\n          `);
                const e = a.closest(".KitPrice-module__kitenzo-kitprice");
                e.parentNode.insertBefore(t, e);
            }
        } else {
            let t = document.getElementById("total-div");
            if (t) {
                t.querySelector("#total").textContent = `Rs.${r.toFixed(2)}`;
            } else {
                (t = document.createElement("div")),
                    (t.id = "total-div"),
                    (t.className = "SidebarKitSummary-module__pricing-row"),
                    (t.innerHTML = `\n              <div class="Text-module__kitenzo-text-component" style="--font-color: inherit; --font-size: 20px;">\n                  <span>Total</span>\n              </div>\n              <span class="money" id="total" style="font-size: 20px;">Rs.${r.toFixed(
                        2
                    )}</span>\n          `);
                const a = e.closest(".SidebarKitSummary-module__pricing-row");
                a.parentNode.insertBefore(t, a);
            }
        }
    }
}
function removeTotalDiv() {
    const t = document.getElementById("total-div"),
        e = document.getElementById("total-mobile");
    t && t.remove(), e && e.remove();
}
documentObserver.observe(document.body, { childList: !0, subtree: !0 });
const priceObserver = new MutationObserver((t, e) => {
    for (const e of t)
        if ("childList" === e.type) {
            const t = document.querySelector(".SidebarKitSummary-module__footer-pricing-row.SidebarKitSummary-module__subtotal-pricing-row .money");
            if (t) {
                const e = t.textContent.replace(/[^\d]/g, "");
                var a = parseInt(e, 10) / 100;
                console.log("moneyElement found:", a);
                new MutationObserver((e) => {
                    for (const o of e)
                        if ("childList" === o.type || "characterData" === o.type) {
                            const e = t.textContent.replace(/[^\d]/g, "");
                            var a = parseInt(e, 10) / 100;
                            console.log("Change detected in moneyElement:", a);
                        }
                }).observe(t, { childList: !0, subtree: !0, characterData: !0 }),
                    priceObserver.disconnect();
            }
        }
});

  
// priceObserver.observe(document.body, { childList: !0, subtree: !0 }),
//     document.addEventListener("DOMContentLoaded", function () {
//         document.querySelectorAll("div[id*='zoko']").forEach(function (t) {
//             t.style.display = "none";
//         });
//     }),
//     document.addEventListener("DOMContentLoaded", (t) => {
//         const e = document.querySelector(".list-menu .menu-lv-item:first-child");
//         if (e) {
//             e.classList.add("color-red");
//             const t = e.querySelector("a");
//             if (t) {
//                 const e = document.createElement("span");
//                 (e.className = "menu-off-blinking-text blink"), (e.innerText = "upto 25% OFF"), t.appendChild(e);
//             }
//         }
//     }),
// document.addEventListener("DOMContentLoaded", function () {
//     const t = 30,
//         e = 1,
//         a = [".form-input.quantity__input", ".form-input.quantity", ".form-input.quantity.cart-item-qty-input"],
//         o = ".minus.btn-quantity",
//         i = ".plus.btn-quantity";

//     function n(a) {
//         if (!a.dataset.listenerAdded) {
//             a.addEventListener("input", function () {
//                 let a = parseInt(this.value) || 0;
//                 a > t ? (this.value = t) : a < e && (this.value = e);
//             });
//             a.dataset.listenerAdded = true;
//         }
//     }

//     function s(a, o) {
//         let i;
//         if (
//             (a.closest(".quantity__container")
//                 ? (i = a.closest(".quantity__container").querySelector("input"))
//                 : a.closest("cart-update-quantity")
//                 ? (i = a.closest("cart-update-quantity").querySelector("input"))
//                 : a.closest(".cart-item-qty") && (i = a.closest(".cart-item-qty").querySelector("input")),
//             i)
//         ) {
//             let a = parseInt(i.value) || 0;
//             (a = o ? a + 1 : a - 1), a > t ? (a = t) : a < e && (a = e), (i.value = a), i.dispatchEvent(new Event("input"));
//         }
//     }

//     function addListeners() {
//         a.forEach((t) => {
//             document.querySelectorAll(t).forEach(n);
//         });
//         document.querySelectorAll(o).forEach((t) => {
//             if (!t.dataset.listenerAdded) {
//                 t.addEventListener("click", function () {
//                     s(t, !1);
//                 });
//                 t.dataset.listenerAdded = true;
//             }
//         });
//         document.querySelectorAll(i).forEach((t) => {
//             if (!t.dataset.listenerAdded) {
//                 t.addEventListener("click", function () {
//                     s(t, !0);
//                 });
//                 t.dataset.listenerAdded = true;
//             }
//         });
//     }

//     addListeners();

//     new MutationObserver(function (t) {
//         t.forEach(function (t) {
//             t.addedNodes.forEach(function (t) {
//                 if (t.nodeType === 1) {
//                     a.forEach((e) => {
//                         t.matches(e) && n(t);
//                         t.querySelectorAll(e).forEach(n);
//                     });
//                     if (t.matches(o) && !t.dataset.listenerAdded) {
//                         t.addEventListener("click", function () {
//                             s(t, !1);
//                         });
//                         t.dataset.listenerAdded = true;
//                     }
//                     if (t.matches(i) && !t.dataset.listenerAdded) {
//                         t.addEventListener("click", function () {
//                             s(t, !0);
//                         });
//                         t.dataset.listenerAdded = true;
//                     }
//                     t.querySelectorAll(o).forEach((t) => {
//                         if (!t.dataset.listenerAdded) {
//                             t.addEventListener("click", function () {
//                                 s(t, !1);
//                             });
//                             t.dataset.listenerAdded = true;
//                         }
//                     });
//                     t.querySelectorAll(i).forEach((t) => {
//                         if (!t.dataset.listenerAdded) {
//                             t.addEventListener("click", function () {
//                                 s(t, !0);
//                             });
//                             t.dataset.listenerAdded = true;
//                         }
//                     });
//                 }
//             });
//         });
//     }).observe(document.body, { childList: true, subtree: true });
// });

document.addEventListener("DOMContentLoaded", function () {
    const maxQuantity = 30;
    const minQuantity = 1;
    const quantitySelectors = [
        ".form-input.quantity__input",
        ".form-input.quantity",
        ".form-input.quantity.cart-item-qty-input"
    ];
    const decrementButtonSelector = ".minus.btn-quantity";
    const incrementButtonSelector = ".plus.btn-quantity";

    function handleQuantityInput(event) {
        let value = parseInt(event.target.value) || 0;
        if (value > maxQuantity) {
            event.target.value = maxQuantity;
        } else if (value < minQuantity) {
            event.target.value = minQuantity;
        }
    }

    function adjustQuantity(button, increment) {
        let inputField;
        if (button.closest(".quantity__container")) {
            inputField = button.closest(".quantity__container").querySelector("input");
        } else if (button.closest("cart-update-quantity")) {
            inputField = button.closest("cart-update-quantity").querySelector("input");
        } else if (button.closest(".cart-item-qty")) {
            inputField = button.closest(".cart-item-qty").querySelector("input");
        }
        
        if (inputField) {
            let value = parseInt(inputField.value) || 0;
            // value = increment ? value + 1 : value - 1;
            if (value > maxQuantity) {
                value = maxQuantity;
            } else if (value < minQuantity) {
                value = minQuantity;
            }
            inputField.value = value;
            inputField.dispatchEvent(new Event("input"));
        }
    }

    function addListenersToQuantityFields() {
        quantitySelectors.forEach(selector => {
            document.querySelectorAll(selector).forEach(inputField => {
                if (!inputField.dataset.listenerAdded) {
                    inputField.addEventListener("input", handleQuantityInput);
                    inputField.dataset.listenerAdded = "true";
                }
            });
        });

        document.querySelectorAll(decrementButtonSelector).forEach(button => {
            if (!button.dataset.listenerAdded) {
                button.addEventListener("click", function () {
                    adjustQuantity(button, false);
                });
                button.dataset.listenerAdded = "true";
            }
        });

        document.querySelectorAll(incrementButtonSelector).forEach(button => {
            if (!button.dataset.listenerAdded) {
                button.addEventListener("click", function () {
                    adjustQuantity(button, true);
                });
                button.dataset.listenerAdded = "true";
            }
        });
    }

    addListenersToQuantityFields();

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) { // Element node
                    quantitySelectors.forEach(selector => {
                        if (node.matches(selector)) {
                            handleQuantityInput({ target: node });
                            if (!node.dataset.listenerAdded) {
                                node.addEventListener("input", handleQuantityInput);
                                node.dataset.listenerAdded = "true";
                            }
                        }
                        node.querySelectorAll(selector).forEach(inputField => {
                            handleQuantityInput({ target: inputField });
                            if (!inputField.dataset.listenerAdded) {
                                inputField.addEventListener("input", handleQuantityInput);
                                inputField.dataset.listenerAdded = "true";
                            }
                        });
                    });

                    if (node.matches(decrementButtonSelector)) {
                        if (!node.dataset.listenerAdded) {
                            node.addEventListener("click", function () {
                                adjustQuantity(node, false);
                            });
                            node.dataset.listenerAdded = "true";
                        }
                    }
                    if (node.matches(incrementButtonSelector)) {
                        if (!node.dataset.listenerAdded) {
                            node.addEventListener("click", function () {
                                adjustQuantity(node, true);
                            });
                            node.dataset.listenerAdded = "true";
                        }
                    }
                    node.querySelectorAll(decrementButtonSelector).forEach(button => {
                        if (!button.dataset.listenerAdded) {
                            button.addEventListener("click", function () {
                                adjustQuantity(button, false);
                            });
                            button.dataset.listenerAdded = "true";
                        }
                    });
                    node.querySelectorAll(incrementButtonSelector).forEach(button => {
                        if (!button.dataset.listenerAdded) {
                            button.addEventListener("click", function () {
                                adjustQuantity(button, true);
                            });
                            button.dataset.listenerAdded = "true";
                        }
                    });
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

// product page sticky image on scroll 

document.addEventListener("DOMContentLoaded", function () {
    const leftDiv = document.querySelector(".template-product .halo-productView-left");
    const rightDiv = document.querySelector(".template-product .halo-productView-right");

    function handleScroll() {
        if (window.innerWidth <= 768) {
            leftDiv.style.position = "relative"; // Reset for smaller screens
            rightDiv.style.position = "relative";
            return;
        }

        let rightRect = rightDiv.getBoundingClientRect();
        let leftRect = leftDiv.getBoundingClientRect();

        if (rightRect.bottom <= window.innerHeight) {
            leftDiv.style.position = "relative";
            leftDiv.style.top = (rightDiv.offsetHeight - leftDiv.offsetHeight) + "px";
        } else {
            leftDiv.style.position = "sticky";
            leftDiv.style.top = "20px"; // Adjust as needed
        }
    }

    if(leftDiv && rightDiv){
      window.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", handleScroll); // Re-check on resize
    }
});


// product page sticky image on scroll ends

document.addEventListener("DOMContentLoaded", (t) => {
    const e = document.querySelector(".list-menu .menu-lv-item:first-child");
    if (e) {
        e.classList.add("color-red");
        const t = e.querySelector("a");
        if (t) {
            const e = document.createElement("span");
            (e.className = "menu-off-blinking-text blink"), (e.innerText = "UP TO 15% OFF"), t.appendChild(e);
        }
    }
});


document.addEventListener("DOMContentLoaded", function() {
  // Target the first <li>'s toggle div
  const firstToggle = document.querySelector(
    ".custom-mobile-menu-wrapper .custom-mobile-menu-list > li:first-child > .custom-mobile-menu-toggle"
  );

  if (firstToggle) {
    // Add red color class to the toggle
    firstToggle.classList.add("custom-color-red");

    // Append blinking text inside the <a> link of the toggle
    const titleLink = firstToggle.querySelector(".custom-mobile-menu-link");
    if (titleLink) {
      const blink = document.createElement("span");
      blink.className = "menu-off-blinking-text blink";
      blink.innerText = "FLAT 14% OFF";
      titleLink.appendChild(blink);
    }
  }
});





// For mobile blinking flat off START ////////////////////////////////////////////////////


// document.addEventListener("DOMContentLoaded", (t) => {
//     const e = document.querySelector(".custom-mobile-menu-list .custom-mobile-menu-item:first-child");
//     if (e) {
//         e.classList.add("color-red");
//         const t = e.querySelector("a");
//         if (t) {
//             const e = document.createElement("span");
//             (e.className = "menu-off-blinking-text blink"), (e.innerText = "FLAT 14% OFF"), t.appendChild(e);
//         }
//     }
// });


// document.addEventListener("DOMContentLoaded", function() {
//   // Target the first <li>'s toggle div
//   const firstToggle = document.querySelector(
//     ".custom-mobile-menu-wrapper .custom-mobile-menu-list > li:first-child > .custom-mobile-menu-toggle"
//   );

//   if (firstToggle) {
//     // Add red color class to the toggle
//     firstToggle.classList.add("custom-color-red");

//     // Append blinking text inside the <a> link of the toggle
//     const titleLink = firstToggle.querySelector(".custom-mobile-menu-link");
//     if (titleLink) {
//       const blink = document.createElement("span");
//       blink.className = "menu-off-blinking-text blink";
//       blink.innerText = "FLAT 14% OFF";
//       titleLink.appendChild(blink);
//     }
//   }
// });

// For mobile blinking flat off END ////////////////////////////////////////////////////






// Table Of Content JS
 // Automatic Table of Contents Generator
        class TableOfContents {
            constructor(options = {}) {
                this.selector = options.selector || '#table-of-contents';
                this.headingSelector = '.toc-main-content h2,.toc-main-content h3';
                this.title = options.title || 'Table of Contents';
                this.container = document.querySelector(this.selector);
                
                if (this.container) {
                    this.generateTOC();
                    this.addScrollSpy();
                }
            }

            generateTOC() {
                const headings = document.querySelectorAll(this.headingSelector);
                
                if (headings.length === 0) {
                    return;
                }

                // Create TOC HTML structure
                const tocHTML = this.buildTOCHTML(headings);
                this.container.innerHTML = tocHTML;
            }

            buildTOCHTML(headings) {
                let tocHTML = `<div class="blog-toc">
                    <div class="blog-toc-header" id="toc-header">
                        ${this.title}
                        <span class="blog-toc-toggle">▼</span>
                    </div>
                    <ul id="toc-content">`;

                headings.forEach((heading, index) => {
                    // Generate unique ID for each heading
                    const headingId = this.generateHeadingId(heading, index);
                    heading.id = headingId;

                    // Get heading level (h2, h3, etc.)
                    const level = heading.tagName.toLowerCase();
                    const text = heading.textContent.trim();

                    tocHTML += `<li>
                        <a href="#${headingId}" class="toc-${level}" data-target="${headingId}">
                            ${text}
                        </a>
                    </li>`;
                });

                tocHTML += `</ul></div>`;
                return tocHTML;
            }

            generateNumber(numbering, currentLevel) {
                const levelNum = parseInt(currentLevel.substring(1));
                let number = '';
                
                // Build hierarchical number (e.g., 1.2.3)
                for (let i = 2; i <= levelNum; i++) {
                    if (numbering[`h${i}`] > 0) {
                        if (number) number += '.';
                        number += numbering[`h${i}`];
                    }
                }
                
                return number;
            }

            generateHeadingId(heading, index) {
                // Create ID from heading text or use existing ID
                let id = heading.id;
                
                if (!id) {
                    id = heading.textContent
                        .toLowerCase()
                        .replace(/[^\w\s-]/g, '') // Remove special characters
                        .replace(/\s+/g, '-') // Replace spaces with hyphens
                        .replace(/-+/g, '-') // Replace multiple hyphens with single
                        .trim();
                    
                    // Ensure ID is unique
                    if (document.getElementById(id)) {
                        id += `-${index}`;
                    }
                }
                
                return id;
            }

            addScrollSpy() {
                const tocLinks = this.container.querySelectorAll('a[data-target]');
                const headings = document.querySelectorAll(this.headingSelector);
                const tocHeader = this.container.querySelector('#toc-header');
                const tocContent = this.container.querySelector('#toc-content');
                const tocToggle = this.container.querySelector('.blog-toc-toggle');

                // Set initial max-height for smooth transitions
                tocContent.style.maxHeight = tocContent.scrollHeight + 'px';

                // Add accordion functionality
                tocHeader.addEventListener('click', () => {
                    const isCollapsed = tocContent.classList.contains('collapsed');
                    
                    if (isCollapsed) {
                        // Expand
                        tocContent.classList.remove('collapsed');
                        tocToggle.classList.remove('collapsed');
                        tocContent.style.maxHeight = tocContent.scrollHeight + 'px';
                    } else {
                        // Collapse
                        tocContent.classList.add('collapsed');
                        tocToggle.classList.add('collapsed');
                        tocContent.style.maxHeight = '0px';
                    }
                });

                // Smooth scroll for TOC links
                tocLinks.forEach(link => {
                    link.addEventListener('click', (e) => {
                        e.preventDefault();
                        const targetId = link.getAttribute('data-target');
                        const targetElement = document.getElementById(targetId);
                        
                        if (targetElement) {
                            // For fixed offset from top (e.g., 100px from top)
                            const elementPosition = targetElement.offsetTop - 180;
                            window.scrollTo({
                                top: elementPosition,
                                behavior: 'smooth'
                            });
                        }
                    });
                });

                // Highlight current section on scroll
                const observerOptions = {
                    rootMargin: '-100px 0px -66%',
                    threshold: 0
                };

                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            // Remove active class from all links
                            tocLinks.forEach(link => link.classList.remove('active'));
                            
                            // Add active class to current link
                            const activeLink = this.container.querySelector(`a[data-target="${entry.target.id}"]`);
                            if (activeLink) {
                                activeLink.classList.add('active');
                            }
                        }
                    });
                }, observerOptions);

                // Observe all headings
                headings.forEach(heading => {
                    if (heading.id) {
                        observer.observe(heading);
                    }
                });
            }
        }

        // Initialize Table of Contents when DOM is loaded
        document.addEventListener('DOMContentLoaded', () => {
            new TableOfContents({
                selector: '#table-of-contents',
                headingSelector: 'h2, h3',
                title: 'Table of Contents'
            });
        });

        // For Shopify themes, you can also initialize after theme loads
        if (typeof Shopify !== 'undefined') {
            document.addEventListener('shopify:section:load', () => {
                new TableOfContents();
            });
        }
// End Table Of Content JS
